/**
 * @file
 * @copyright Virtual Console, LLC - All Rights Reserved
 * @license Unauthorized copying of this file, via any medium is strictly prohibited
 * @ignore Proprietary and confidential
 * @author Ben McDonald [mcdonald.ben@gmail.com]
*/

function HistoryDefinition() {
    'use strict';

    var throttleUpdates = 800;
    /**
    * Records history state and provides undo/redo
    *
    * @type {function(!function, !function, !function):!Object}
    */
    function History(setState, getState, eventFunction) {
        /** @type {!Object} */
        var _this = {};

        /** @type {!Array.<string>} */
        var history = [];
        /** @type {!number} */
        var currentIndex = -1;
        var isVirgin = false;
        var lastUpdate = null;

        function strcmp(a, b) {
            for (var i=0,n=Math.max(a.length, b.length); i<n && a.charAt(i) === b.charAt(i); ++i) {
                if (i === n) {
                    return true;
                }
            }
            return a.charAt(i) === b.charAt(i);
        }

        _this.canvasEdited = function (text) {
            if (lastUpdate === null || lastUpdate + throttleUpdates <= Date.now()) {
                /** @type {!string} */
                var serializedCanvas = getState();
                if (history.length === 0 || !strcmp(history[currentIndex].data, serializedCanvas)) {
                    currentIndex += 1;
                    if (history.length > currentIndex) {
                        history.splice(currentIndex);
                    }

                    history.push({
                        'data': serializedCanvas,
                        'text': text
                    });

                    lastUpdate = Date.now();

                    if (isVirgin) {
                        eventFunction('isVirgin', false);
                    }
                    isVirgin = false;
                    eventFunction('edited', text);
                }
            }
        };

        _this.isVirgin = function () {
            return isVirgin;
        };

        /** @type {function()} */
        _this.undo = function() {
            if (currentIndex > 0) {
                currentIndex -= 1;

                setState(history[currentIndex].data);
                lastUpdate = Date.now() - throttleUpdates;
            }
        };

        /** @type {function()} */
        _this.redo = function() {
            if (history.length > currentIndex + 1) {
                currentIndex += 1;

                setState(history[currentIndex].data);
                lastUpdate = Date.now() - throttleUpdates;
            }
        };

        _this.getActionHistory = function() {
            return history.map(function(e){return e.text;});
        };

        return _this;
    }

    return History;
}

(function(window) {
    'use strict';
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( [
            ],
            HistoryDefinition );
    } else {
        // browser global
        window.History = HistoryDefinition();

    }
})(window);


window.pathModel = (function () {
	'use strict';

	const ACTIONS = Object.freeze({
		ADD_MOVETO_SEG: 'ADD_MOVETO_SEG',
		ADD_LINETO_SEG: 'ADD_LINETO_SEG',
		// ADD_CURVETO_CUBIC_SEG: 'ADD_CURVETO_CUBIC_SEG',
		// ADD_CURVETO_QUADRATIC_SEG: 'ADD_CURVETO_QUADRATIC_SEG',
		// ADD_CURVETO_CUBIC_SMOOTH_SEG: 'ADD_CURVETO_CUBIC_SMOOTH_SEG',
		// ADD_CURVETO_QUADRATIC_SMOOTH_SEG: 'ADD_CURVETO_QUADRATIC_SMOOTH_SEG',
		// ADD_ARC_SEG: 'ADD_ARC_SEG',
		DELETE_CURVE_POINT: 'DELETE_CURVE_POINT',
		LINE_TO_CURVE: 'LINE_TO_CURVE',
		MOVE_CONTROL_POINT: 'MOVE_CONTROL_POINT',
		MOVE_CURVE_POINT: 'MOVE_CURVE_POINT',
		REMOVE_SEG: 'REMOVE_SEG',
		REMOVE_CURVE_POINT: 'REMOVE_CURVE_POINT',
		OPEN_PATH: 'OPEN_PATH',
		CLOSE_PATH: 'CLOSE_PATH'
	});

    // _this.removeControlPoint = function (pathElem, pathSeg, attriNumber) {
    //     // Delete curve control point
    //     var newPathSeg;

    //     // If only one control point replace segment with a line
    //     if (pathSeg.pathSegTypeAsLetter === 'S' || pathSeg.pathSegTypeAsLetter === 'T' || pathSeg.pathSegTypeAsLetter === 'Q') {
    //         newPathSeg = pathElem.createSVGPathSegLinetoAbs(pathSeg.x, pathSeg.y);
    //         _this.replacePathSeg(pathElem, pathSeg, newPathSeg);
    //     } else if(pathSeg.pathSegTypeAsLetter === 'C') {
    //     // If two control points remove with a single control point line
    //         var otherControlPoint = attriNumber === '2'?'1':'2';
    //         newPathSeg = pathElem.createSVGPathSegCurvetoCubicSmoothAbs( // 'T' letter
    //             pathSeg.x, pathSeg.y,
    //             pathSeg['x' + otherControlPoint],
    //             pathSeg['y' + otherControlPoint]);
     
    //         _this.replacePathSeg(pathElem, pathSeg, newPathSeg);
    //     }

    //     // Return new segment
    //     return newPathSeg;
    // };

	const path = (state, action) => {
		state = state || [];
		console.assert(typeof(state) === 'object' && 'length' in state, state);
		const isClosed = state.some(s => s.type === 'Z');

		if (state.length === 0 && action.type !== ACTIONS.ADD_MOVETO_SEG &&
						Object.keys(ACTIONS).indexOf(action.type) !== -1) {
			throw 'First segment much be a moveto';
		}
		if (state.length !== 0 && action.type === ACTIONS.ADD_MOVETO_SEG) {
			throw 'Only first seg can be move to';
		}
		if (action.type === ACTIONS.CLOSE_PATH && state.length < 3) {
			throw 'Cannot close. Path too short';
		}
		if (action.type === ACTIONS.CLOSE_PATH && isClosed) {
			throw 'Path not open';
		}
		if (action.type === ACTIONS.OPEN_PATH && !isClosed) {
			throw 'Path not closed';
		}
		if (action.type === ACTIONS.LINE_TO_CURVE && (['T', 'L'].indexOf(state[action.payload.index].type) === -1)) {
			throw 'Not a line or S at that index';
		}
		if (action.type === ACTIONS.LINE_TO_CURVE &&
						!(state[action.payload.index].values[0] === action.payload.x && state[action.payload.index].values[1] === action.payload.y)) {
			throw 'Curve point on the line';
		}
		// if (action.type === ACTIONS.MOVE_CONTROL_POINT && (state[action.payload.index].type === 'Z')) {
		// 	throw 'Not a line at that index';
		// }
		if (action.payload && action.payload.index && action.payload.index === 0 && action.payload.index > state.length && (isClosed && action.payload.index + 1 > state.length)) {
			throw 'Index invalid';
		}
		if (action.type === ACTIONS.REMOVE_CURVE_POINT && (['S', 'T', 'Q', 'C'].indexOf(state[action.payload.index].type) === -1)) {
			throw 'No curse at index';
		}
		if (action.type === ACTIONS.REMOVE_CURVE_POINT && 'firstPoint' in action.payload && state[action.payload.index].type !== 'C') {
			throw 'No curse at index';
		}


		switch (action.type) {
			case ACTIONS.ADD_MOVETO_SEG:
				return [{type: 'M', values: [action.payload.x, action.payload.y]}];
			case ACTIONS.ADD_LINETO_SEG:
				return state.slice(0, action.payload.index).concat([{type: 'L', values: [action.payload.x, action.payload.y]}])
										.concat(state.slice(action.payload.index));
			// case ACTIONS.ADD_CURVETO_CUBIC_SEG:
			// 	return state.slice(0, action.payload.index).concat([{type: 'C', values: [action.payload.x, action.payload.y, action.payload.x1, action.payload.y1, action.payload.x2, action.payload.y2]}])
			// 							.concat(state.slice(action.payload.index));
			// case ACTIONS.ADD_CURVETO_QUADRATIC_SEG:
			// 	return state.slice(0, action.payload.index).concat([{type: 'Q', values: [action.payload.x, action.payload.y, action.payload.x1, action.payload.y1]}])
			// 							.concat(state.slice(action.payload.index));
			// case ACTIONS.ADD_CURVETO_CUBIC_SMOOTH_SEG:
			// 	return state.slice(0, action.payload.index).concat([{type: 'S', values: [action.payload.x, action.payload.y, action.payload.x2, action.payload.y2]}])
			// 							.concat(state.slice(action.payload.index));
			// case ACTIONS.ADD_CURVETO_QUADRATIC_SMOOTH_SEG:
			// 	return state.slice(0, action.payload.index).concat([{type: 'T', values: [action.payload.x, action.payload.y]}])
			// 							.concat(state.slice(action.payload.index));
			case ACTIONS.REMOVE_CURVE_POINT:
				return (('firstPoint' in action.payload)?
						state.slice(0, action.payload.index).concat([{type: 'T', values:
											[state[action.payload.index].values[0], state[action.payload.index].values[1],
											state[action.payload.index].values[action.payload.firstPoint?4:2],
											state[action.payload.index].values[action.payload.firstPoint?5:3]]}])
											.concat(state.slice(action.payload.index + 1))
					:
					 	state.slice(0, action.payload.index).concat([{type: 'L', values:
					 						[state[action.payload.index].values[0], state[action.payload.index].values[1]]}])
											.concat(state.slice(action.payload.index + 1))
					);
			case ACTIONS.LINE_TO_CURVE:
				return (state[action.payload.index].type === 'S'?
						state.slice(0, action.payload.index).concat([{type: 'C', values: state[action.payload.index].values.slice(0, 4).concat([action.payload.x, action.payload.y])}])
												.concat(state.slice(action.payload.index + 1))
					:
						state.slice(0, action.payload.index).concat([{type: 'S', values: state[action.payload.index].values.slice(0, 2).concat([action.payload.x, action.payload.y])}])
												.concat(state.slice(action.payload.index + 1))
					);
			case ACTIONS.REMOVE_SEG:
				return state.slice(0, action.payload.index).concat(state.slice(action.payload.index + 1));
			case ACTIONS.MOVE_CONTROL_POINT:
				return state.slice(0, action.payload.index).concat([{type: state[action.payload.index].type, values: state[action.payload.index].values.slice(0, 0).concat([action.payload.x, action.payload.y]).concat(state[action.payload.index].values.slice(2))}])
										.concat(state.slice(action.payload.index + 1));
			case ACTIONS.OPEN_PATH:
				return state.filter(s => s.type.toLowerCase() !== 'z');
			case ACTIONS.CLOSE_PATH:
				// return state.concat([{type: 'M', values: [state[0].values[0], state[0].values[1]]}, {type: 'Z'}]);
				return state.concat([{type: 'Z'}]);
			default:
				return state;
		}
	};


	return {
		ACTIONS: ACTIONS,
		path: path
	};
})();

(function (Redux, pathModel) {
	'use strict';

    function runTest() {	
		const store = Redux.createStore(pathModel.path, []);

		store.dispatch({
			type: pathModel.ACTIONS.ADD_MOVETO_SEG,
			payload: {
				x: 150,
				y: 150,
			}
		});

		function assertPathStr(match) {
			const pathStr = store.getState().map(s => `${s.type}${s.values?' ' + s.values.join(' '):''}`).join(' ');
            var newPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            newPath.setAttribute('d', pathStr);

			if (pathStr !== match && newPath.getAttribute('d') === match) {
				console.error(pathStr, match, store.getState());
			}
		}

		assertPathStr('M 150 150');

		store.dispatch({
			type: pathModel.ACTIONS.ADD_LINETO_SEG,
			payload: {
				x: 150,
				y: 150,
				index: 1
			}
		});
		assertPathStr('M 150 150 L 150 150');
		store.dispatch({
			type: pathModel.ACTIONS.MOVE_CONTROL_POINT,
			payload: {
				x: 250,
				y: 250,
				attriNumber: 0,
				index: 1
			}
		});
		assertPathStr('M 150 150 L 250 250'); // TODO elimate line

		store.dispatch({
			type: pathModel.ACTIONS.ADD_LINETO_SEG,
			payload: {
				x: 100,
				y: 100,
				index: 2
			}
		});
		assertPathStr('M 150 150 L 250 250 L 100 100');
		
		store.dispatch({
			type: pathModel.ACTIONS.ADD_LINETO_SEG,
			payload: {
				x: 400,
				y: 400,
				index: 2
			}
		});
		assertPathStr('M 150 150 L 250 250 L 400 400 L 100 100');
		
		store.dispatch({
			type: pathModel.ACTIONS.REMOVE_SEG,
			payload: {
				index: 2
			}
		});
		assertPathStr('M 150 150 L 250 250 L 100 100');

		store.dispatch({
			type: pathModel.ACTIONS.LINE_TO_CURVE,
			payload: {
				x: 100,
				y: 100,
				index: 2
			}
		});
		assertPathStr('M 150 150 L 250 250 T 100 100 100 100');
		store.dispatch({
			type: pathModel.ACTIONS.CLOSE_PATH
		});
		assertPathStr('M 150 150 L 250 250 T 100 100 100 100 Z');
		store.dispatch({
			type: pathModel.ACTIONS.OPEN_PATH
		});
		assertPathStr('M 150 150 L 250 250 T 100 100 100 100');
		store.dispatch({
			type: pathModel.ACTIONS.ADD_LINETO_SEG,
			payload: {
				x: 100,
				y: 100,
				index: 2
			}
		});
		assertPathStr('M 150 150 L 250 250 L 100 100 T 100 100 100 100');
    }
    runTest();
})(window.Redux, window.pathModel);

window.pathInfo = (function () {
	'use strict';

    const _this = {};

    _this.getPointSegList = function (pathElem) {
        var pointSegs = [];
        for(var i = 0, length = pathElem.pathSegList.length; i < length; i++) {
            if (pathElem.pathSegList.getItem(i).pathSegTypeAsLetter !== 'Z') {
                pointSegs.push(pathElem.pathSegList.getItem(i)) ;
            }
        }
        return pointSegs;
    };

    _this.isClosed = function (pathElem) {
        return pathElem.pathSegList.length > 0 && 
                    pathElem.pathSegList.getItem(pathElem.pathSegList.length - 1)
                        .pathSegTypeAsLetter.toLowerCase() === 'z';
    };

    _this.isStartSeg = function (pathElem, pathSeg) {
        var segIndex = _this.getPathSigIndex(pathElem, pathSeg);

        return !_this.isClosed(pathElem) && (segIndex===0);
    };

    _this.isEndSeg = function (pathElem, pathSeg) {
        var segIndex = _this.getPathSigIndex(pathElem, pathSeg);

        return !_this.isClosed(pathElem) && (segIndex===pathElem.pathSegList.length - 1);
    };

    _this.isStartOrEndSeg = function (pathElem, pathSeg) {
        var segIndex = _this.getPathSigIndex(pathElem, pathSeg);

        return !_this.isClosed(pathElem) && (segIndex===0 ||
            segIndex===(pathElem.pathSegList.length - 1));
    };

    _this.getPathSigIndex = function (pathElem, pathSeg) {
        return Array.from(pathElem.pathSegList._list || pathElem.pathSegList).indexOf(pathSeg);
    };

    _this.getPathSegReflection = function (pathSeg, attriNumber) {
        var x = pathSeg.x + (pathSeg.x - pathSeg['x' + attriNumber]);
        var y = pathSeg.y + (pathSeg.y - pathSeg['y' + attriNumber]);

        return [x, y];
    };

    _this.getAttachedControlPoints = function (pathElem, pathSeg) {
        const attachedControlPoints = [];

        if (pathSeg.x2) {
            attachedControlPoints.push({
                'pathSeg': pathSeg,
                'attriNumber': '2'
            });
        }

        const nextPathSeg = _this.getNextPathSeg(pathElem, pathSeg);
        if (nextPathSeg && nextPathSeg.x1) {
            attachedControlPoints.push({
                'pathSeg': nextPathSeg,
                'attriNumber': '1'
            });
        }

        return attachedControlPoints;
    };


    _this.numOfControlPoints = function (pathElem) {
        var controlPointCount = 0;
        for(var i = 0, length = pathElem.pathSegList.length; i < length; i++) {
            if (pathElem.pathSegList.getItem(i).pathSegTypeAsLetter !== 'Z') {
                controlPointCount += 1;
                if (pathElem.pathSegList.getItem(i).x1) {
                    controlPointCount += 1;
                }
                if (pathElem.pathSegList.getItem(i).x2) {
                    controlPointCount += 1;
                }
            }
        }
        return controlPointCount;
    };


    _this.isValidState = function (pathElem) {
        return pathElem.pathSegList.getItem(0).pathSegTypeAsLetter === 'M';
    };

    _this.getOrderPointIndex = function (pathElem, pathSeg, attriNumber) {
        var index = (_this.getPathSigIndex(pathElem, pathSeg) * 3);
        if (attriNumber !== '') {
            index += parseInt(attriNumber, 10) - 3;
        }

        return index;
    };

    _this.getPreviousPathSeg = function (pathElem, pathSeg, isLooping) {
        var segList = _this.getPointSegList(pathElem);

        var index = Array.from(segList).indexOf(pathSeg) - 1;
        var prevSeg = (0>index)?null:segList[index];

        if (isLooping && prevSeg === null && _this.isClosed(pathElem)) {
            prevSeg = segList[segList.length - 1];
        }
        return prevSeg;
    };

    _this.getNextPathSeg = function (pathElem, pathSeg, isLooping) {
        var segList = _this.getPointSegList(pathElem);

        var index = Array.from(segList).indexOf(pathSeg) + 1;
        var nextSeg = (segList.length>index)?segList[index]:null;

        if (isLooping && nextSeg === null) {
            nextSeg = 0;
        }

        return nextSeg;
    };


    _this.getAttachedPointsToControlPoint = function (pathElem, pathSeg, attriNumber) {
        const attachedControlPoints = [];
        const previousPathSeg = _this.getPreviousPathSeg(pathElem, pathSeg);
        const nextPathSeg = _this.getNextPathSeg(pathElem, pathSeg);

        if (pathSeg.pathSegTypeAsLetter === 'C') {
            if (attriNumber === '1' && previousPathSeg) {
                attachedControlPoints.push({
                    'x': previousPathSeg.x,
                    'y': previousPathSeg.y
                });
            } else {
                attachedControlPoints.push({
                    'x': pathSeg.x,
                    'y': pathSeg.y
                });            
            }
        }
        if (attriNumber === '2' && nextPathSeg && nextPathSeg.pathSegTypeAsLetter === 'S') {
            const segReflection = _this.getPathSegReflection(pathSeg, attriNumber);
            attachedControlPoints.push({
                'x': segReflection[0],
                'y': segReflection[1]
            });
        }

        if (attriNumber === '1' &&
                pathSeg.pathSegTypeAsLetter === 'Q' && previousPathSeg) {
            attachedControlPoints.push({
                'x': previousPathSeg.x,
                'y': previousPathSeg.y
            });
            attachedControlPoints.push({
                'x': pathSeg.x,
                'y': pathSeg.y
            }); 

            if (nextPathSeg && nextPathSeg.pathSegTypeAsLetter === 'T') {
                const segReflection = _this.getPathSegReflection(pathSeg, attriNumber);
                attachedControlPoints.push({
                    'x': segReflection[0],
                    'y': segReflection[1]
                });
            }
        }

        // if (attriNumber === '1' &&
        //         pathSeg.pathSegTypeAsLetter === 'Q' && nextPathSeg) {
        //     if (nextPathSeg && nextPathSeg.pathSegTypeAsLetter === 'T') {
        //         attachedControlPoints.push({
        //             'x': nextPathSeg.x1,
        //             'y': nextPathSeg.y1
        //         });
        //     }
        // }

        if (attriNumber === '2' &&
                pathSeg.pathSegTypeAsLetter === 'S') {
            if (previousPathSeg && !previousPathSeg.x2){            
                attachedControlPoints.push({
                    'x': previousPathSeg.x,
                    'y': previousPathSeg.y
                });
            }

            attachedControlPoints.push({
                'x': pathSeg.x,
                'y': pathSeg.y
            }); 

            // if (nextPathSeg && nextPathSeg.pathSegTypeAsLetter === 'T') {
            //     var segReflection = _this.getPathSegReflection(pathSeg, attriNumber);
            //     attachedControlPoints.push({
            //         'x': segReflection[0],
            //         'y': segReflection[1]
            //     });
            // }
        }

        // if (nextPathSeg && nextPathSeg.x1) {
        //     attachedControlPoints.push({
        //         'x': nextPathSeg.x1,
        //         'y': nextPathSeg.y1
        //     });
        // }

        return attachedControlPoints;
    };

    _this.getControlPointParent = function (pathElem, pathSeg, attriNumber) {
        console.assert(typeof(attriNumber) === 'string');
        if (attriNumber === '1') {
            return _this.getPreviousPathSeg(pathElem, pathSeg, attriNumber);
        }
        if (attriNumber === '2') {
            return pathSeg;
        } else {
            console.trace();
        }
    };

    return _this;
})();
function svgPathUtil(pathInfo) {
    'use strict';

    var _this = {};


    _this.removeHorizontalVertialLines = function (pathElem) {
        for (var i=0, pathSeg, newPathSeg;i<pathElem.pathSegList.length;i++){
            pathSeg = pathElem.pathSegList.getItem(i);
            if (pathSeg.pathSegTypeAsLetter === 'V') {
                var x = pathInfo.getPreviousPathSeg(pathElem, pathSeg).x;
                newPathSeg = pathElem.createSVGPathSegLinetoAbs(x, pathSeg.y);

                _this.replacePathSeg(pathElem, pathSeg, newPathSeg);
                i=-1;
            } else if (pathSeg.pathSegTypeAsLetter === 'H') {
                var y = pathInfo.getPreviousPathSeg(pathElem, pathSeg).y;
                newPathSeg = pathElem.createSVGPathSegLinetoAbs(pathSeg.x, y);

                _this.replacePathSeg(pathElem, pathSeg, newPathSeg);
                i=-1;
            }
        }
    };

    _this.replacePathSeg = function (pathElem, pathSeg, newPathSeg) {
        var index = pathInfo.getPathSigIndex(pathElem, pathSeg);
        _this.replacePathSegAtIndex(pathElem, newPathSeg, index);
    };

    _this.replacePathSegAtIndex = function (pathElem, newPathSeg, index) {
        pathElem.pathSegList.removeItem(index);
        pathElem.pathSegList.insertItemBefore(newPathSeg, index);
    };

    _this.close = function (pathElem) {
        console.assert(!pathInfo.isClosed(pathElem));
        console.assert(pathElem.pathSegList.length > 2);
        pathElem.pathSegList.appendItem(pathElem.createSVGPathSegClosePath());
    };

    _this.open = function (pathElem) {
        console.assert(pathInfo.isClosed(pathElem));
        pathElem.pathSegList.removeItem(pathElem.pathSegList.length - 1);
    };

    _this.removeControlPoint = function (pathElem, pathSeg, attriNumber) {
        // Delete curve control point
        var newPathSeg;

        // If only one control point replace segment with a line
        if (pathSeg.pathSegTypeAsLetter === 'S' || pathSeg.pathSegTypeAsLetter === 'T' || pathSeg.pathSegTypeAsLetter === 'Q') {
            newPathSeg = pathElem.createSVGPathSegLinetoAbs(pathSeg.x, pathSeg.y);
            _this.replacePathSeg(pathElem, pathSeg, newPathSeg);
        } else if(pathSeg.pathSegTypeAsLetter === 'C') {
        // If two control points remove with a single control point line
            var otherControlPoint = attriNumber === '2'?'1':'2';
            newPathSeg = pathElem.createSVGPathSegCurvetoCubicSmoothAbs(
                pathSeg.x, pathSeg.y,
                pathSeg['x' + otherControlPoint],
                pathSeg['y' + otherControlPoint]);
     
            _this.replacePathSeg(pathElem, pathSeg, newPathSeg);
        }

        // Return new segment
        return newPathSeg;
    };

    _this.toggleOpenClose = function (pathElem) {
        if (pathInfo.isClosed(pathElem)) {
            _this.open(pathElem);
        } else {
            _this.close(pathElem);
        }
    };

    _this.lineToS = function (pathElem, pathSeg) {
        var previousPathSeg = _this.getPreviousPathSeg(pathElem, pathSeg);

        console.assert(previousPathSeg &&
                (pathSeg.pathSegTypeAsLetter === 'L' ||
                    pathSeg.pathSegTypeAsLetter === 'T'));
   
       var newPathSeg = pathElem.createSVGPathSegCurvetoCubicSmoothAbs(
            pathSeg.x, pathSeg.y,
            previousPathSeg.x + ((pathSeg.x - previousPathSeg.x) / 2),
            previousPathSeg.y + ((pathSeg.y - previousPathSeg.y) / 2));
     
        _this.replacePathSeg(pathElem, pathSeg, newPathSeg);
        return newPathSeg;
    };

    _this.getSegCurvePoints = function (pathElem, pathSeg) {
        var previousPathSeg = _this.getPreviousPathSeg(pathElem, pathSeg);

        var x1, y1, x2, y2;
        // If T or S line
        if (!(x1 in pathSeg) &&
                pathSeg.pathSegTypeAsLetter !== 'L' &&
                ('x2' in previousPathSeg)) {
            var attr2 = pathInfo.getPathSegReflection(previousPathSeg, '2');
            x1 = attr2[0];
            y1 = attr2[1];
        }

        x1 = pathSeg.x1 || x1 ||
            (previousPathSeg.x + ((pathSeg.x - previousPathSeg.x) / 2));
        y1 = pathSeg.y1 || y1 ||
            (previousPathSeg.y + ((pathSeg.y - previousPathSeg.y) / 2));

        x2 = pathSeg.pathSegTypeAsLetter === 'Q'?pathSeg.x1:null ||
                pathSeg.x2 || x1 ||
                (previousPathSeg.x + ((pathSeg.x - previousPathSeg.x) / 2));
        y2 = pathSeg.pathSegTypeAsLetter === 'Q'?pathSeg.y1:null ||
                pathSeg.y2 || y1 ||
                (previousPathSeg.y + ((pathSeg.y - previousPathSeg.y) / 2));


        return {
            'x1' : x1,
            'y1' : y1,
            'x2' : x2,
            'y2' : y2
        };
    };

    _this.pathToC = function (pathElem, pathSeg) {
        var previousPathSeg = _this.getPreviousPathSeg(pathElem, pathSeg);

        console.assert(previousPathSeg &&
                (pathSeg.pathSegTypeAsLetter === 'Q'));

        var segCurvePoints = 
            _this.getSegCurvePoints(pathElem, pathSeg);
   
        var newPathSeg = pathElem.createSVGPathSegCurvetoCubicAbs(
            pathSeg.x, pathSeg.y,
            segCurvePoints.x1,
            segCurvePoints.y1,
            segCurvePoints.x2,
            segCurvePoints.y2);
     
        _this.replacePathSeg(pathElem, pathSeg, newPathSeg);
        return newPathSeg;
    };

    _this.lineToQ = function (pathElem, pathSeg) {
        var previousPathSeg = _this.getPreviousPathSeg(pathElem, pathSeg);

        console.assert(previousPathSeg &&
                (pathSeg.pathSegTypeAsLetter === 'L' ||
                    pathSeg.pathSegTypeAsLetter === 'T'));
   
       var newPathSeg = pathElem.createSVGPathSegCurvetoQuadraticAbs(
            pathSeg.x, pathSeg.y,
            previousPathSeg.x + ((pathSeg.x - previousPathSeg.x) / 2),
            previousPathSeg.y + ((pathSeg.y - previousPathSeg.y) / 2));
     
        _this.replacePathSeg(pathElem, pathSeg, newPathSeg);
        return newPathSeg;
    };


    return _this;
}

var svgPathUtil = svgPathUtil(pathInfo);


function assertEqual(a, b) {
    if (a !== b) {
        console.assert(a === b, a, b);
        
    }
}


function makeSvgElem() {
    var svgElem = document.createElement('svg');
    svgElem.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
    svgElem.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    svgElem.setAttribute('version', '1.1');

    return svgElem;
}


function runTests() {
    var svgElem = makeSvgElem();
    var newPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    newPath.setAttribute('d', 'M10 80 C 40 10, 65 10, 95 80 S 150 150, 180 80');

    svgElem.appendChild(newPath);

    assertEqual(svgPathUtil.getOrderPointIndex(newPath, newPath.pathSegList.getItem(0), ''), 0);
    assertEqual(svgPathUtil.getOrderPointIndex(newPath, newPath.pathSegList.getItem(1), '1'), 1);
    assertEqual(svgPathUtil.getOrderPointIndex(newPath, newPath.pathSegList.getItem(1), '2'), 2);
    assertEqual(svgPathUtil.getOrderPointIndex(newPath, newPath.pathSegList.getItem(1), ''), 3);
    assertEqual(svgPathUtil.getOrderPointIndex(newPath, newPath.pathSegList.getItem(2), ''), 6);
}
// runTests();

(function (svgPathUtil, pathInfo) {
	'use strict';

    const HANDLE_RADIUS = 4;
    const MIN_RADIUS = 3;

    function transformSvg (svgElem, x, y, ownerDoc) {
        console.assert(typeof(x) === 'number');
        console.assert(typeof(y) === 'number');

        x = Math.max(x, 0);
        y = Math.max(y, 0);
        x = Math.min(x, ownerDoc.width.baseVal.value);
        y = Math.min(y, ownerDoc.height.baseVal.value);
        svgElem.setAttribute('transform', 'translate(' + x + ',' + y + ')');
    }

    function makePathHangle (ownerDoc, isControlPoint) {
        var groupElem = ownerDoc.createElementNS('http://www.w3.org/2000/svg', 'g');
        groupElem.setAttribute('class', isControlPoint?'path-handle control-point curve-control':'path-handle point-control');

        var circleElem = ownerDoc.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circleElem.setAttribute('cx', 0);
        circleElem.setAttribute('cy', 0);
        circleElem.setAttribute('class', 'touch-circle');
        groupElem.appendChild(circleElem);

        circleElem = ownerDoc.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circleElem.setAttribute('cx', 0);
        circleElem.setAttribute('cy', 0);
        circleElem.setAttribute('r', 2);
        circleElem.setAttribute('class', 'center-circle');
        groupElem.appendChild(circleElem);

        return groupElem;
    }

    class ControlPointView {
        constructor(controlPoint) {
            console.assert(typeof(controlPoint) === 'object');

            this._controlPoint = controlPoint;
            this._attriNumber = controlPoint.attriNumber;
            this._svgPath = controlPoint._svgPath;
            this._handleElem = makePathHangle(this._svgPath.ownerDocument, controlPoint.attriNumber !== '');

            this._handleElem.setAttribute('data-pnt-num', controlPoint.attriNumber || '0');
            this._handleElem.setAttribute('data-pnt-lte', controlPoint.pathSegTypeAsLetter);
            // if (this._attriNumber !== '') {
                this._controlLine = [];
            // }

            this.updateControlLines();
        }
        _updateNumberOfControlPoints(newNumber) {
            while (this._controlLine.length < newNumber) {
                const controlLine = this._svgPath.ownerDocument.createElementNS('http://www.w3.org/2000/svg', 'line');
                controlLine.setAttribute('class', 'control-line');

                this._svgPath.parentNode.insertBefore(controlLine, this._svgPath.ownerSVGElement.querySelector('.control-line') || this._svgPath.ownerSVGElement.querySelector('.curve-control'));

                this._svgPath.parentNode.appendChild(controlLine);
                this._controlLine.push(controlLine);
            }

            while (this._controlLine.length > newNumber) {
                const lastEntry = this._controlLine[this._.controlLine.length - 1];

                lastEntry.remove();
                this._controlLine.pop();
            }
        }
        updateControlLines() {
            if (this._attriNumber !== '') {
                var controlPointList = this._controlPoint.getAttachedPointsToControlPoint();
                this._updateNumberOfControlPoints(controlPointList.length);

                controlPointList.forEach((pointData, i) => {
                    this._controlLine[i].setAttribute('x1', this._controlPoint.getPosition().x);
                    this._controlLine[i].setAttribute('y1', this._controlPoint.getPosition().y);
                    this._controlLine[i].setAttribute('x2', pointData.x);
                    this._controlLine[i].setAttribute('y2', pointData.y);
                });
            }   
        }
        setSelected(e, isSelected) {
            this._handleElem.classList.toggle('selected', isSelected);
        }
        hoverOn() {
            this._handleElem.classList.add('hover');
            this._controlLine.forEach(function(h) {
                h.classList.add('hover');
            });
        }
        hoverOff() {
            this._handleElem.classList.remove('hover');
            this._controlLine.forEach(function(h) {
                h.classList.remove('hover');
            });
        }
        updateHandelPosition(isAddPointMode, isLastSector, isShowFirstPointSector) {
            transformSvg(this._handleElem, this._controlPoint.getPosition().x, this._controlPoint.getPosition().y, this._svgPath.ownerSVGElement);

            // if (handlerData.attriNumber !== '' && 
            //         handlerData.pathSeg.pathSegTypeAsLetter === 'S') {
            //     newPosition = svgPathUtil.getPathSegReflection(handlerData.pathSeg, handlerData.attriNumber);
            // }


            // TODO End seg click more complex
            this._handleElem.querySelector('.touch-circle').style.display = (isAddPointMode &&
                    !isShowFirstPointSector)?'none':'';

            let isControlPoint = this._handleElem.classList.contains('control-point');
            this._handleElem.querySelector('.touch-circle')
                .setAttribute('r', HANDLE_RADIUS * (isShowFirstPointSector?1:1) * (isControlPoint?1:1));
            // handle.querySelector('.center-circle')
            //     .style.strokeWidth = ((isAddPointMode && isLastSector)?8:2) + 'px';
                // handle.querySelector('.center-circle')
                //     .setAttribute('r', (isAddPointMode && isLastSector)?8:2);

            this.updateControlLines();  
        }
        removeElems() {
            this._controlLine.forEach(function(e) {
                e.remove();
            });

            this._handleElem.remove();

            this._attriNumber = undefined;
            this._handleElem = undefined;
            this._controlLine = undefined;
            this._svgPath = undefined;
        }
    }

    class ControlPoint {
        constructor(attriNumber, pathSeg, svgPath) {
            console.assert(typeof(attriNumber) === 'string');
            console.assert(typeof(pathSeg) === 'object');

            this._attriNumber = attriNumber;
            this._svgPath = svgPath;
            this._pathSegTypeAsLetter = pathSeg.pathSegTypeAsLetter;

            this._pathSeg = pathSeg;
            // if (this._attriNumber !== '') {
                this._controlLine = [];
            // }


            this._view = new ControlPointView(this);

            this._handleElem = this._view._handleElem;
        }
        get attriNumber() {
            return this._attriNumber;
        }
        get pathSegTypeAsLetter() {
            return this._pathSegTypeAsLetter;
        }
        get pathSeg() {
            return this._pathSeg;
        }
        get handleElem() {
            return this._handleElem;
        }
        get controlLine() {
            return this._controlLine;
        }
        setSelected(e, isSelected) {
            this._view.setSelected(e, isSelected);
        }
        hoverOn() {
            this._view.hoverOn();
        }
        hoverOff() {
            this._view.hoverOff();
        }
        isControlPoint() {
            return this._attriNumber !== '';
        }
        getAttachedPointsToControlPoint() {
        	return pathInfo.getAttachedPointsToControlPoint(this._svgPath, this._pathSeg, this._attriNumber);
        }
        updateControlLines() {
	        this._view.updateControlLines();
        }
        getPosition() {
        	return {
        		x: this._pathSeg['x' + this._attriNumber],
        		y: this._pathSeg['y' + this._attriNumber]
        	};
        }
        updateHandelPosition() {
        	this._view.updateHandelPosition(); 
        }
        removeElems() {
			this._view.removeElems(); 

            this._view = undefined;
            this._attriNumber = undefined;
            this._pathSeg = undefined;
            this._controlLine = undefined;
            this._svgPath = undefined;
        }
    }

	window.PathEditorView = function(svgPath) {
        var controlPointSvgGroup = svgPath.parentElement;

        const controlPointsData = new Map();

        function getHandlesWithPathSeg(pathSeg) {
            return [...controlPointsData.values()]
                .filter(function(handler) {
                    return pathSeg === handler.pathSeg;
                });
        }

        function getHandleWithPathSegAndAttri(pathSeg, attriNumber) {
            console.assert(typeof(attriNumber) === 'string');
            return getHandlesWithPathSeg(pathSeg)
                .filter(function(handler) {
                    return handler.attriNumber === attriNumber;
                })[0];
        }


        function removeSvgElemsUsedForSeg(handler) {
            var handlerData = controlPointsData.get(handler);
            handlerData.removeElems();
            controlPointsData.delete(handler);
        }

        function deleteHander(handler) {
            var handlerData = controlPointsData.get(handler);
            if (!handlerData) {
                console.error('handlerData already removed ', handlerData);
                return;
            }

            removeSvgElemsUsedForSeg(handler);
            if (handlerData.attriNumber === '') {        
                var index = pathInfo.getPathSigIndex(svgPath, handlerData.pathSeg);
                if (index !== -1) {
                    svgPath.pathSegList.removeItem(index);
                }

                getHandlesWithPathSeg(handlerData.pathSeg)
                    .forEach(removeSvgElemsUsedForSeg);
            } else {
                var newPathSeg = svgPathUtil.removeControlPoint(svgPath, handlerData.pathSeg, handlerData.attriNumber);
                if (handlerData.pathSeg.pathSegTypeAsLetter === 'C' && handlerData.attriNumber === '2') {
                    var otherHandler = getHandleWithPathSegAndAttri(handlerData.pathSeg, '1');
                    // var otherHandlerData = controlPointsData.get(otherHandler);
                    otherHandlerData.attriNumber = '2';
                    otherHandlerData.pathSeg = newPathSeg;
                    controlPointsData.set(otherHandler, ControlPoint('2', pathSeg, svgPath));
                }

                getHandlesWithPathSeg(handlerData.pathSeg)
                    .forEach(function(h) {
                        var cpHandlerData = controlPointsData.get(h);
                        cpHandlerData.pathSeg = newPathSeg;
                        controlPointsData.set(h, cpHandlerData);
                    });

                // handlerData.pathSeg = newPathSeg;
                // pathEditorView.controlPointsData.set(handler, handlerData);

                // _this.selectOnly([handler]);

            }


            // updateAllHanders();
        }

        function onHover(pathHandler, isCtrlKeyDown, isShiftKeyDown) {        
            var handlerData = controlPointsData.get(pathHandler);  
            if (handlerData.attriNumber === '') {        
                var attachedHandles = pathInfo.getAttachedControlPoints(svgPath, handlerData.pathSeg)
                    .map(function(attachedControlPoint) {
                        return getHandleWithPathSegAndAttri(attachedControlPoint.pathSeg,
                                    attachedControlPoint.attriNumber);
                    });

                attachedHandles.forEach(function(h) {
                        h.hoverOn();
                    });
            } else {            
                handlerData.hoverOn();
            }
        }

        function offHover() {
            [...controlPointsData.values()]
                .forEach(function(h) {
                    h.hoverOff();
                });
        }

        function setSelected(e, isSelected) {
            controlPointsData.get(e).setSelected(e, isSelected);  
        }

        function updateHandelPosition(handle) {
            const handlerData = controlPointsData.get(handle);
            console.assert(handlerData, handle);

            const isAddPointMode = !pathInfo.isClosed(svgPath); //isEditToggle || 
            controlPointSvgGroup.classList.toggle('is-edit-toggle', isAddPointMode);
            const isLastSector = pathInfo.isEndSeg(svgPath, handlerData.pathSeg);

            const isShowFirstPointSector = pathInfo.isStartSeg(svgPath, handlerData.pathSeg) &&
                        (pathInfo.getPointSegList(svgPath).length > 3 || pathInfo.getPointSegList(svgPath).length < 2);


            handlerData.updateHandelPosition(isAddPointMode, isLastSector, isShowFirstPointSector);
        }

        function getAttachedHandlers(pathSeg) {
            return pathInfo.getAttachedControlPoints(svgPath, pathSeg)
                .map(function(attachedControlPoint) {
                    return getHandleWithPathSegAndAttri(attachedControlPoint.pathSeg,
                                attachedControlPoint.attriNumber)._view._handleElem;
                });
        }

        function updateHandelAndAttachedPosition(handler) {
            const handlerData = controlPointsData.get(handler);
            let nextPathSeg = pathInfo.getNextPathSeg(svgPath, handlerData.pathSeg, true);

            updateHandelPosition(handler);

            if (nextPathSeg.x1 === undefined && nextPathSeg.x2 === undefined) {
                nextPathSeg = pathInfo.getNextPathSeg (svgPath, nextPathSeg, true);
            }
            if (nextPathSeg) {
                 getAttachedHandlers(nextPathSeg)
                    .filter(pathHandlerElem => !pathHandlerElem.classList.contains('selected'))
                    .forEach(function(pathHandlerElem) {
                        updateHandelPosition(pathHandlerElem);
                    });
            }            
        }


        function buildHangle(pathSeg, attriNumber) {
            const controlPointHander = new ControlPoint(attriNumber, pathSeg, svgPath);

            controlPointsData.set(controlPointHander.handleElem, controlPointHander);

            updateHandelPosition(controlPointHander.handleElem);
            controlPointSvgGroup.insertBefore(controlPointHander.handleElem, (controlPointHander.isControlPoint()?null:(controlPointSvgGroup.querySelector('.point-control') || svgPath)));

            return controlPointHander.handleElem;
        }


        function buildSegment(pathSeg) {
            // TODO make curve handles face towards point and rectanglar
            // var allXcoords = [];
            // var allYcoords = [];
            // for (var j=0;j<svgPath.pathSegList.length;j++){
            //     var pathSeg2 = svgPath.pathSegList.getItem(j);

            //     if (i !== j && 
            //             ['M', 'Q', 'S', 'C'].indexOf(pathSeg2.pathSegTypeAsLetter) !== -1) {
            //         allXcoords.push(pathSeg2.x);
            //         allYcoords.push(pathSeg2.y);
            //     }
            // }


            if (pathSeg.pathSegTypeAsLetter === 'M' || pathSeg.pathSegTypeAsLetter === 'T') {
                return buildHangle(pathSeg, '');
            } else if (pathSeg.pathSegTypeAsLetter === 'L') {
                return buildHangle(pathSeg, '');
            } else if (pathSeg.pathSegTypeAsLetter === 'Q') {
                buildHangle(pathSeg, '');
                buildHangle(pathSeg, '1');
            // } else if (pathSeg.pathSegTypeAsLetter === 'S') {
            //     buildHangle(pathSeg, x', 'y');
            //     buildHangle(pathSeg, x2', 'y2');
            // } else if (pathSeg.pathSegTypeAsLetter === 'T') {
            //     buildHangle(pathSeg, x', 'y');
            } else if (pathSeg.pathSegTypeAsLetter === 'C') {
                buildHangle(pathSeg, '');
                buildHangle(pathSeg, '1');
                buildHangle(pathSeg, '2');
            } else if (pathSeg.pathSegTypeAsLetter === 'S') {
                buildHangle(pathSeg, '');
                buildHangle(pathSeg, '2');
            }
        }


        function updateHander(pathHandlerElem) {
            let handlerData = controlPointsData.get(pathHandlerElem);
            handlerData.updateControlLines();
            updateHandelPosition(pathHandlerElem);
        }


        function updateAllHanders() {
            Array.from(svgPath.ownerDocument.querySelectorAll('.path-handle'))
                .forEach(updateHander);
        }

		return {
			ControlPoint: ControlPoint,
            updateAllHanders: updateAllHanders,
			deleteHander: deleteHander,
            setSelected: setSelected,
            getHandleWithPathSegAndAttri: (pathSeg, attriNumber) => getHandleWithPathSegAndAttri(pathSeg, attriNumber)._view._handleElem,
            updateHandelAndAttachedPosition: updateHandelAndAttachedPosition,
            getAttachedHandlers: getAttachedHandlers,
            buildHangle: buildHangle,
            buildSegment: buildSegment,
            updateHandelPosition: updateHandelPosition,
            onHover: onHover,
            offHover: offHover,
			controlPointsData: controlPointsData,
		};
	};
})(window.svgPathUtil, window.pathInfo);

function pathAreaDefinition() {
	'use strict';

	// Return the area for an SVG <polygon> or <polyline>
	// Self-crossing polys reduce the effective 'area'
	function polyArea(poly) {
	    var area = 0,
	        pts = poly.points,
	        len = pts.numberOfItems;
	    for (var i = 0; i < len; ++i) {
	        var p1 = pts.getItem(i),
	            p2 = pts.getItem((i + -1 + len) % len);
	        area += (p2.x + p1.x) * (p2.y - p1.y);
	    }
	    return Math.abs(area / 2);
	}

	// path:      an SVG <path> element
	// threshold: a 'close-enough' limit (ignore subdivisions with area less than this)
	// segments:  (optional) how many segments to subdivisions to create at each level
	// returns:   a new SVG <polygon> element
	function pathToPolygonViaSubdivision(path, threshold, segments) {
	    if (!threshold) threshold = 0.0001; // Get really, really close
	    if (!segments) segments = 3; // 2 segments creates 0-area triangles

	    var points = subdivide(ptWithLength(0), ptWithLength(path.getTotalLength()));
	    for (var i = points.length; i--;) points[i] = [points[i].x, points[i].y];

	    var doc = path.ownerDocument;
	    var poly = doc.createElementNS('http://www.w3.org/2000/svg', 'polygon');
	    poly.setAttribute('points', points.join(' '));
	    return poly;

	    // Record the distance along the path with the point for later reference
	    function ptWithLength(d) {
	        var pt = path.getPointAtLength(d);
	        pt.d = d;
	        return pt;
	    }

	    // Create segments evenly spaced between two points on the path.
	    // If the area of the result is less than the threshold return the endpoints.
	    // Otherwise, keep the intermediary points and subdivide each consecutive pair.
	    function subdivide(p1, p2) {
	        var pts = [p1];
	        for (var i = 1, step = (p2.d - p1.d) / segments; i < segments; i++) {
	            pts[i] = ptWithLength(p1.d + step * i);
	        }
	        pts.push(p2);
	        if (polyArea(pts) <= threshold) return [p1, p2];
	        else {
	            var result = [];
	            for (var i = 1; i < pts.length; ++i) {
	                var mids = subdivide(pts[i - 1], pts[i]);
	                mids.pop(); // We'll get the last point as the start of the next pair
	                result = result.concat(mids)
	            }
	            result.push(p2);
	            return result;
	        }
	    }

	    // Calculate the area of an polygon represented by an array of points
	    function polyArea(points) {
	        var p1, p2;
	        for (var area = 0, len = points.length, i = 0; i < len; ++i) {
	            p1 = points[i];
	            p2 = points[(i - 1 + len) % len]; // Previous point, with wraparound
	            area += (p2.x + p1.x) * (p2.y - p1.y);
	        }
	        return Math.abs(area / 2);
	    }
	}

	return function (path) {
		return polyArea(pathToPolygonViaSubdivision(path));
	};
}


(function(window) {
    'use strict';
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( [        
            ],
            pathAreaDefinition );
    } else {
        // browser global
        window.pathArea = pathAreaDefinition(window.svgPathUtil);
    }
})(window);

function pathEditorDefinition(svgPathUtil, pathInfo, pathModel, Redux) {
    'use strict';


    const DEBUG = true;

    function PathEditor(svgPath, isNewPointMode, eventCallback) {
        const pathEditorView = PathEditorView(svgPath);

        const _this = {};
        let svgDoc = svgPath.ownerSVGElement;
        let ownerDoc = svgPath.ownerDocument;

        let selectedElems;

        let isEditToggle = false;
        let isCtrlKeyDownState = false;
        let isShiftKeyDownState = false;
        let store;
function compareString( s1, s2, splitChar ){
    if ( typeof splitChar == "undefined" ){
        splitChar = " ";
    }
    var string1 = new Array();
    var string2 = new Array();

    string1 = s1.split( splitChar );
    string2 = s2.split( splitChar );
    var diff = new Array();

    if(s1.length>s2.length){
        var long = string1;
    }
    else {
        var long = string2;
    }
    for(var x=0;x<long.length;x++){
        if(string1[x]!=string2[x]){
            diff.push(string2[x]);
        }
    }

    return diff;    
}
        function storeDispatch(action) {
            try{            
                store.dispatch(action);

                const pathStr = store.getState().map(s => `${s.type}${s.values?' ' + s.values.join(' '):''}`).join(' ').trim();
                const pathStr2 = svgPath.getAttribute('d').replace('z', 'Z').trim();
                if (DEBUG && pathStr != pathStr2) {
                    console.error(compareString( pathStr, pathStr2 ));
                    console.error(pathStr);
                    console.error(pathStr2);
                }
            } catch (e) {
                console.error(e);
            }
        }

        function closePath() {
            svgPathUtil.close(svgPath);
            storeDispatch({
                type: pathModel.ACTIONS.CLOSE_PATH
            });
        }
        function openPath() {
            svgPathUtil.open(svgPath);
            storeDispatch({
                type: pathModel.ACTIONS.OPEN_PATH
            });
        }

        function moveControlPoint(pos, attriNumber, index) {
            storeDispatch({
                type: pathModel.ACTIONS.MOVE_CONTROL_POINT,
                payload: Object.assign(pos, {index, attriNumber})
            });
        }

        function removeControlPoint(attriNumber, index) {

        }

        function removeSegment(index) {
            svgPath.pathSegList.removeItem(index);
            storeDispatch({
                type: pathModel.ACTIONS.REMOVE_SEG,
                payload: {
                    index: 2
                }
            });
        }

        function addLine(pos, index) {
            storeDispatch({
                type: pathModel.ACTIONS.ADD_LINETO_SEG,
                payload: Object.assign(pos, {index})
            });
        }

        function createSVGPathSegCurvetoCubicSmoothAbs(lastSeg, controlPoint) {
            var newPathSeg = svgPath.createSVGPathSegCurvetoCubicSmoothAbs(
                lastSeg.x, lastSeg.y,
                controlPoint.x, controlPoint.y);
            svgPath.pathSegList.appendItem(newPathSeg);
            console.log('Replace L with S');

            // storeDispatch({
            //     type: pathModel.ACTIONS.LINE_TO_CURVE,
            //     payload: {
            //         index: 2
            //     }
            // });


            return newPathSeg;
        }

        function getLastSeg() {
            return svgPath.pathSegList.getItem(svgPath.pathSegList.length - 1);
        }


        function updateHandlerOfPathSeg(pathSeg, attriNumber) {
            pathEditorView.updateHandelPosition(pathEditorView.getHandleWithPathSegAndAttri(pathSeg, attriNumber));
        }

        _this.ctrlKeyChange = function(isCtrlKeyDown) {
            isCtrlKeyDownState = isCtrlKeyDown; 
            isEditToggle = isCtrlKeyDownState || isShiftKeyDownState;
        };
        _this.shiftKeyChange = function(isShiftKeyDown) {
            isShiftKeyDownState = isShiftKeyDown;
            isEditToggle = isCtrlKeyDownState || isShiftKeyDownState;
        };

        _this.dblTap = function(pathHandler, x, y, isCtrlKeyDown, isShiftKeyDown) {
            addNewPointAtLocation(x, y);
        };

        _this.toggleOpenClose = function() {
            if (pathInfo.isClosed(svgPath)) {
                openPath();
            } else {
                closePath();
            }
        };

        function checkState() {
            console.assert(pathEditorView.controlPointsData.size === pathInfo.numOfControlPoints(svgPath));
            console.assert(pathInfo.isValidState(svgPath));
        }

        function addNewPointAtLocation(x, y, isToBeAppended) {
            const selectedElems = _this.getSelectedElems();
            const pathSegListLength = svgPath.pathSegList.length;

            const lookBackNum = svgDoc.querySelector('.newPointControl')?2:1;
            if (pathSegListLength !== 1 && svgPath.pathSegList.getItem(pathSegListLength - lookBackNum).x === x &&
                    svgPath.pathSegList.getItem(pathSegListLength - lookBackNum).y === y) {
                console.error('Line at same point', x, y, svgPath.pathSegList.getItem(pathSegListLength - 1));
                return;
            }

            console.log('addNewPointAtLocation', x, y);
            Array.from(svgDoc.querySelectorAll('.path-handle'))
                .forEach(function(h) {
                    h.style.pointerEvents = '';
                });
            var newPointControl = svgDoc.querySelector('.newPointControl');
            if (newPointControl) {
                newPointControl.classList.remove('newPointControl');
            }


            const newPathSeg = svgPath.createSVGPathSegLinetoAbs(x, y);

            console.assert(svgPath.pathSegList.length !== 0);

            let pathSegIndex;
            if (!pathInfo.isClosed(svgPath)) {
                // svgPath.pathSegList.appendItem(newPathSeg);
                pathSegIndex = pathSegListLength;
            } else if (selectedElems.length === 0 || isToBeAppended || selectedElems.length === 0) {
                // svgPath.pathSegList.insertItemBefore(newPathSeg, svgPath.pathSegList.length - 1);
                pathSegIndex = pathSegListLength - 1;

                console.log('Appending new point ', newPathSeg);
            } else {
                pathSegIndex = pathInfo.getPathSigIndex(svgPath,
                        pathEditorView.controlPointsData.get(
                            selectedElems[selectedElems.length - 1]
                        ).pathSeg);

                if (pathSegIndex === 0) {
                    pathSegIndex += 1;
                }
            }
            console.log('Inserting new point ', pathSegIndex, newPathSeg);
            svgPath.pathSegList.insertItemBefore(newPathSeg, pathSegIndex);
            addLine({x, y}, pathSegIndex);

            var newHandler = pathEditorView.buildSegment(newPathSeg);

            newHandler.classList.add('newPointControl');
            newHandler.style.pointerEvents = 'none';

            _this.selectOnly([pathEditorView.getHandleWithPathSegAndAttri(newPathSeg, '')]);

            pathEditorView.updateAllHanders();

            checkState();
            return newHandler;       
        }

        (function () {
            var startHandlerX;
            var startHandlerY;
            var currentPathHandlerElem;

            _this.dragStart = function(pathHandlerElem, x, y, isCtrlKeyDown, isShiftKeyDown) {
                // TODO select control points with point handler
                var handlerData;
                if (!pathInfo.isClosed(svgPath) || isCtrlKeyDown) {

                    // isStartSeg
                    // if (pathHandlerElem) {
                    //     handlerData = pathEditorView.controlPointsData.get(pathHandlerElem);  
                    //     if (svgPath.pathSegList.length > 2 &&
                    //                 pathInfo.isStartSeg(svgPath, handlerData.pathSeg)) {
                    //         _this.clear();
                    //         if (!pathInfo.isClosed(svgPath)) {
                    //             closePath();
                    //         }
                            
                    //         return false;              
                    //     }
                    // }
                    
                    // Have a path handler and not the first segment
                    if (pathHandlerElem && !pathInfo.isStartSeg(svgPath, pathEditorView.controlPointsData.get(pathHandlerElem).pathSeg)) {
                        // Remove new marker from control point
                        var newPointControl = svgDoc.querySelector('.newPointControl');
                        if (newPointControl) {
                            newPointControl.classList.remove('newPointControl');
                        }

                        // Remove curve marker from control point
                        var newCurvePointControl = svgDoc.querySelector('.newCurvePointControl');
                        if (newCurvePointControl) {
                            newCurvePointControl.classList.remove('newCurvePointControl');
                        }

                        // Add new point and add it as a control point
                        addNewPointAtLocation(x + 1, y + 1, true);
                    }
                    // }
                } else if (pathHandlerElem) {        
                    currentPathHandlerElem = pathHandlerElem;
                    svgDoc.classList.add('dragging');
                    handlerData = pathEditorView.controlPointsData.get(pathHandlerElem);  

                    startHandlerX = handlerData.pathSeg['x' + handlerData.attriNumber];
                    startHandlerY = handlerData.pathSeg['y' + handlerData.attriNumber];

                    _this.click(currentPathHandlerElem, x, y, isCtrlKeyDown, isShiftKeyDown);
                }
            };

            _this.dragMove = function(x, y, startX, startY, isCtrlKeyDown, isShiftKeyDown, isMouseDown) {
                _this.ctrlKeyChange(isCtrlKeyDown);
                // _this.shiftKeyChange(isShiftKeyDown);
                if (!pathInfo.isClosed(svgPath)) {
                    // getLastSeg()

                    // if (isNewPointMode && svgDoc.querySelector('.newPointControl') === null) {
                    //     // svgDoc.querySelector('.newPointControl').classList.remove('newPointControl');
                    //     addNewPointAtLocation(x, y, true).classList.add('newPointControl');
                    // }

                    const lastSeg = getLastSeg();

                    let pathSeg = lastSeg;
                    if (isMouseDown && !(lastSeg.pathSegTypeAsLetter === 'L' && svgPath.pathSegList.length === 2) &&
                            svgDoc.querySelector('.newPointControl') !== null) {
                        console.log(lastSeg.pathSegTypeAsLetter, svgPath.pathSegList.length);
                        var reflectX = lastSeg.x - (x - lastSeg.x);
                        var reflectY = lastSeg.y - (y - lastSeg.y);
                        if (lastSeg.pathSegTypeAsLetter === 'L') {
                            console.log('Replace L with S');

                            deleteHander(pathEditorView.getHandleWithPathSegAndAttri(svgPath.pathSegList.getItem(svgPath.pathSegList.length - 1), ''));

                            var newPathSeg = createSVGPathSegCurvetoCubicSmoothAbs(lastSeg,
                                    {x: reflectX, y:reflectY});

                            pathEditorView.buildHangle(newPathSeg, '');
                            var newPathHandler = pathEditorView.buildHangle(newPathSeg, '2');
                            if (svgDoc.querySelector('.newPointControl')) {
                                svgDoc.querySelector('.newPointControl').classList.remove('newPointControl');
                            }
                            newPathHandler.classList.add('newPointControl');
                            newPathHandler.classList.add('newCurvePointControl');


                            pathSeg = newPathSeg;
                        } else {
                            lastSeg.x2 = reflectX;
                            lastSeg.y2 = reflectY;

                            moveControlPoint({x: reflectY, y: reflectY}, 2, pathInfo.getPathSigIndex(svgPath, lastSeg));
                        }
                        pathEditorView.updateHandelPosition(pathEditorView.getHandleWithPathSegAndAttri(pathSeg, '2'));
                    } else if (svgDoc.querySelector('.newPointControl') !== null) {  
                        const handlerData = pathEditorView.controlPointsData.get(svgDoc.querySelector('.newPointControl'));  

                        // moveSelected(startX - x, startY - y);
                        handlerData.pathSeg['x' + handlerData.attriNumber] = x;
                        handlerData.pathSeg['y' + handlerData.attriNumber] = y;

                        updateHandlerOfPathSeg(handlerData.pathSeg, '');
                    } else {
                        addNewPointAtLocation(x, y, true);
                    }
                } else if (currentPathHandlerElem) {        
                    const handlerData = pathEditorView.controlPointsData.get(currentPathHandlerElem);  
                    // var xDiff = currentHandlerData.pathSeg.x - startHandlerX;
                    // var yDiff = currentHandlerData.pathSeg.y - startHandlerY;
                    var xDiff = x - startX -
                        (handlerData.pathSeg['x' + handlerData.attriNumber] -
                            startHandlerX);
                    var yDiff = y - startY -
                        (handlerData.pathSeg['y' + handlerData.attriNumber] -
                            startHandlerY);

                    _this.moveSelected(xDiff, yDiff);
                }
                
            };

            _this.dragEnd = function(x, y, isCtrlKeyDown, isShiftKeyDown) {
                if (!pathInfo.isClosed(svgPath) && svgDoc.querySelector('.newPointControl') === null) {
                    // svgDoc.querySelector('.newPointControl').classList.remove('newPointControl');
                    addNewPointAtLocation(x, y, true);
                }

                // User is dagging the point to make a curve
                if (svgDoc.querySelector('.newCurvePointControl')) {
                    svgDoc.querySelector('.newCurvePointControl').classList.remove('newCurvePointControl');
                    addNewPointAtLocation(x, y, true);
                }
                svgDoc.classList.remove('dragging');

                currentPathHandlerElem = null;
            };
        })();

        // TODO show control lines on hover
        _this.onHover = function(pathHandler, isCtrlKeyDown, isShiftKeyDown) {
            pathEditorView.onHover(pathHandler, isCtrlKeyDown, isShiftKeyDown);
        };

        _this.offHover = function(pathHandler) {     
            pathEditorView.offHover();  
        };

        _this.click = function(pathHandler, x, y, isCtrlKeyDown, isShiftKeyDown) {
            console.assert(svgPath.pathSegList.length !== 0);

            if (svgPath.pathSegList.length === 0 || svgPath.pathSegList.length === 1 || svgPath.pathSegList.length === 2) {
                addNewPointAtLocation(x, y);
            } else if (!pathInfo.isClosed(svgPath) && !pathHandler) {
                addNewPointAtLocation(x, y);
            } else if (!pathInfo.isClosed(svgPath)) {
                const handlerData = pathEditorView.controlPointsData.get(pathHandler); 
                if (handlerData._pathSeg.pathSegTypeAsLetter.toLowerCase() === 'm') {
                    var newPointControl = svgDoc.querySelector('.newPointControl');
                    if (newPointControl) {
                        deleteHander(newPointControl);
                    }
                    closePath();
                } else {
                    console.error('Only control point should start point');
                }
            } else {
                var handlerData = pathEditorView.controlPointsData.get(pathHandler);  
                var toSelect = [pathHandler];
                if (isShiftKeyDown) {

                    if (pathHandler.classList.contains('selected')) {                
                        setSelected(pathHandler, false);
                        if (handlerData.attriNumber === '') {        
                            pathEditorView.getAttachedHandlers(handlerData.pathSeg)
                                .filter(function(h) {
                                    return h.classList.contains('selected');
                                })
                                .map(function(h) {
                                    setSelected(h, false);
                                });
                        }
                    } else {
                        toSelect = toSelect.concat(_this.getSelectedElems());
                        if (handlerData.attriNumber === '') {        
                            toSelect = toSelect.concat(pathEditorView.getAttachedHandlers(handlerData.pathSeg));
                        }
                        _this.selectOnly(toSelect);
                    }
                } else {
                    if (handlerData.attriNumber === '') {        
                        toSelect = toSelect.concat(pathEditorView.getAttachedHandlers(handlerData.pathSeg));
                    }
                    _this.selectOnly(toSelect);
                }
            }

            // if (pathHandler && !isShiftKeyDown) {
            //     var toSelect = [pathHandler];
            //     var handlerData = pathEditorView.controlPointsData.get(pathHandler);  

            //     if (handlerData.attriNumber === '') {        
            //         toSelect = toSelect.concat(svgPathUtil.getAttachedControlPoints(svgPath, handlerData.pathSeg)
            //             .map(function(attachedControlPoint) {
            //                 return pathEditorView.getHandleWithPathSegAndAttri(attachedControlPoint.pathSeg,
            //                             attachedControlPoint.attriNumber);
            //             }));
            //     }
            //     _this.selectOnly(toSelect);
            // }

            // http://html5index.org/SVG%20-%20SVGPathElement.html#createSVGPathSegClosePath
            // svgPath.createSVGPathSegClosePath();
            // svgPath.pathSegList.appendItem(svgPath.createSVGPathSegLinetoAbs(x, y)());
        };

        function setSelected(e, isSelected) {
            pathEditorView.setSelected(e, isSelected);
        }

        // _this.cycleType = function () {
        //     _this.getSelectedPointControlElems()
        //         .forEach(function(pathHandle) {
        //             var dataHandle = pathEditorView.controlPointsData.get(pathHandle);
        //             var newPath;
        //             if (dataHandle.pathSeg.pathSegTypeAsLetter === 'L') {
        //                 console.log('L to T');
        //                 newPath = svgPath.createSVGPathSegCurvetoQuadraticSmoothAbs(
        //                             dataHandle.pathSeg.x, dataHandle.pathSeg.y
        //                         );
        //             } else if (dataHandle.pathSeg.pathSegTypeAsLetter === 'T') {
        //                 console.log('T to L');
        //                 newPath = svgPath.createSVGPathSegLinetoAbs(
        //                             dataHandle.pathSeg.x, dataHandle.pathSeg.y
        //                         );
        //             } else if (dataHandle.pathSeg.pathSegTypeAsLetter === 'T') {
        //                 console.log('T to S');
        //                 newPath = svgPathUtil.lineToS(svgPath, dataHandle.pathSeg);

        //                 dataHandle.pathSeg = newPath;
        //                 pathEditorView.controlPointsData.set(pathHandle, dataHandle);
        //                 return;
        //             } else if (dataHandle.pathSeg.pathSegTypeAsLetter === 'Q') {
        //                 console.log('Q to S');
        //                 newPath = svgPath.createSVGPathSegCurvetoCubicSmoothAbs(
        //                             dataHandle.pathSeg.x, dataHandle.pathSeg.y,
        //                             dataHandle.pathSeg.x1, dataHandle.pathSeg.y1
        //                         );
        //                 dataHandle.xAttr = 'x2';
        //                 dataHandle.yAttr = 'y2';
        //                 dataHandle.attriNumber = '2';
        //             } else if (dataHandle.pathSeg.pathSegTypeAsLetter === 'S') {
        //                 console.log('S to Q');
        //                 newPath = svgPath.createSVGPathSegCurvetoQuadraticAbs(
        //                             dataHandle.pathSeg.x, dataHandle.pathSeg.y,
        //                             dataHandle.pathSeg.x2, dataHandle.pathSeg.y2
        //                         );
        //                 dataHandle.xAttr = 'x1';
        //                 dataHandle.yAttr = 'y1';
        //                 dataHandle.attriNumber = '1';
        //             } else if (dataHandle.pathSeg.pathSegTypeAsLetter === 'S') {
        //                 console.log('S to C');
        //                 newPath = svgPathUtil.pathToC(svgPath, dataHandle.pathSeg);

        //                 dataHandle.pathSeg = newPath;
        //                 pathEditorView.controlPointsData.set(pathHandle, dataHandle);
        //             } else {
        //                 return;
        //             }

        //             svgPathUtil.replacePathSeg(svgPath, dataHandle.pathSeg,
        //                     newPath
        //                 );

        //             dataHandle.pathSeg = newPath;
        //             pathEditorView.controlPointsData.set(pathHandle, dataHandle);

        //         });
        //     updateAllHanders();
        // };

        function sortHandlers(handleList) {
            handleList.sort(function(a, b) {
                var handlerDataA = pathEditorView.controlPointsData.get(a);
                var handlerDataB = pathEditorView.controlPointsData.get(b);


                return pathInfo.getOrderPointIndex(svgPath, handlerDataA.pathSeg, handlerDataA.attriNumber) -
                    pathInfo.getOrderPointIndex(svgPath, handlerDataB.pathSeg, handlerDataB.attriNumber);
            });

            
            return handleList;
        }

        _this.getSelectedElems = function () {
            var handleList =  sortHandlers(Array.from(svgDoc.querySelectorAll('.path-handle.selected')));

            return handleList;
        };

        _this.getSelectedPointControlElems = function () {
            return Array.from(svgDoc.querySelectorAll('.path-handle.selected'))
                .filter(function(pathHandlerElem) {
                    return !pathHandlerElem.classList.contains('.control-point');
                });
        };

        _this.getAllElems = function () {
            return Array.from(svgDoc.querySelectorAll('.path-handle'));
        };

        _this.getAllSelectable = function () {
            var handleList = sortHandlers(Array.from(pathEditorView.controlPointsData.keys()));

            return handleList;
             // pathInfo.getPointSegList(svgPath)
             //    .map(function(pathSeg) {
             //        return pathEditorView.getHandleWithPathSegAndAttri(pathSeg, '');
             //    });
        };

        function removeSvgElemsUsedForSeg(handler) {
            var handlerData = pathEditorView.controlPointsData.get(handler);
            handlerData.removeElems();
            pathEditorView.controlPointsData.delete(handler);
        }

        function deleteHander(handler) {
            const handlerData = pathEditorView.controlPointsData.get(handler);
            if (!handlerData || !handlerData.pathSeg) {
                console.error('handlerData already removed ', handlerData);
                return;
            }

            if (handlerData.attriNumber === '') {        
                const index = pathInfo.getPathSigIndex(svgPath, handlerData.pathSeg);
                if (index !== -1) {
                    removeSegment(index);
                }

                getHandlesWithPathSeg(handlerData.pathSeg)
                    .forEach(removeSvgElemsUsedForSeg);
            } else {
                const newPathSeg = svgPathUtil.removeControlPoint(svgPath, handlerData.pathSeg, handlerData.attriNumber);
                removeControlPoint(handlerData.attriNumber, pathInfo.getPathSigIndex(svgPath, handlerData.pathSeg));

                // if (newPathSeg) {
                //     pathEditorView.controlPointsData.set(newPathSeg, new pathEditorView.ControlPoint('2', newPathSeg, svgPath));
                // }

                if (handlerData.pathSeg.pathSegTypeAsLetter === 'C' && handlerData.attriNumber === '2') {
                    const otherHandler = pathEditorView.getHandleWithPathSegAndAttri(handlerData.pathSeg, '1');
                    const otherHandlerData = pathEditorView.controlPointsData.get(otherHandler);
                    otherHandlerData.removeElems();
                    pathEditorView.controlPointsData.set(otherHandler, new pathEditorView.ControlPoint('2', newPathSeg, svgPath));
                }

                getHandlesWithPathSeg(handlerData.pathSeg)
                    .forEach(function(h) {
                        const cpHandlerData = pathEditorView.controlPointsData.get(h);
                        pathEditorView.controlPointsData.set(h, new pathEditorView.ControlPoint(cpHandlerData.attriNumber, newPathSeg, svgPath));
                        cpHandlerData.removeElems();
                    });

                // handlerData.pathSeg = newPathSeg;
                // pathEditorView.controlPointsData.set(handler, handlerData);

                // _this.selectOnly([handler]);

            }
            // removeSvgElemsUsedForSeg(handler);


            // updateAllHanders();
        }

        function getHandlesWithPathSeg(pathSeg) {
            return _this.getAllElems()
                .filter(function(handler) {
                    return pathSeg === pathEditorView.controlPointsData.get(handler).pathSeg;
                });
        }

        function movePathPointHandle(handler, dx, dy) {
            var handlerData = pathEditorView.controlPointsData.get(handler);

            handlerData.pathSeg['x' + handlerData.attriNumber] += dx;
            handlerData.pathSeg['y' + handlerData.attriNumber] += dy;

            pathEditorView.updateHandelPosition(handler);

            pathEditorView.updateHandelAndAttachedPosition(handler);

            if (handlerData.attriNumber === '') {        
                pathEditorView.getAttachedHandlers(handlerData.pathSeg)
                    .filter(function(pathHandlerElem) {
                        return !pathHandlerElem.classList.contains('selected');
                    })
                    .forEach(function(pathHandlerElem) {
                        var handleData = pathEditorView.controlPointsData.get(pathHandlerElem);

                        handleData.pathSeg['x' + handleData.attriNumber] += dx;
                        handleData.pathSeg['y' + handleData.attriNumber] += dy;

                        pathEditorView.updateHandelPosition(pathHandlerElem);
                    });
            }
        }

        // TODO if shift down apply hover to all selected
        _this.moveSelected = function (dx, dy) {
            var selectedElems = _this.getSelectedElems();

            selectedElems
                .forEach(function(handler) {
                    movePathPointHandle(handler, dx, dy);
                });
        };

        function deleteHandleElems(handlerElems) {
            // Don't delete first handle or handles attached to
            // first point

            // If at least one point
            if (pathInfo.getPointSegList(svgPath).length > 1) {        
                var firstX = svgPath.pathSegList.getItem(0).x;
                var firstY = svgPath.pathSegList.getItem(0).y;

                handlerElems
                    .forEach(deleteHander);

                if (pathInfo.getPointSegList(svgPath).length === 0) {
                    if (pathInfo.isClosed(svgPath)) {
                        openPath();
                    }

                    var newPathSeg = svgPath.createSVGPathSegMovetoAbs(firstX, firstY);
                    svgPath.pathSegList.appendItem(newPathSeg);
                    pathEditorView.buildSegment(newPathSeg);
                } else if (svgPath.pathSegList.getItem(0).pathSegTypeAsLetter !== 'M') {
                    // If starting moveTo command have been removed create a new one at the beginning of the path
                    var x = svgPath.pathSegList.getItem(0).x;
                    var y = svgPath.pathSegList.getItem(0).y;

                    // Delete all controls for first path
                    getHandlesWithPathSeg(svgPath.pathSegList.getItem(0))
                        .forEach(deleteHander);
                    var newPathSeg = svgPath.createSVGPathSegMovetoAbs(x, y);
                    if (svgPath.pathSegList.length === 0) {
                        svgPath.pathSegList.appendItem(newPathSeg);
                    } else {
                        svgPath.pathSegList.insertItemBefore(newPathSeg, svgPath.pathSegList.getItem(0));
                    }

                    pathEditorView.buildSegment(newPathSeg);


                    if (pathInfo.isClosed(svgPath)) {
                        openPath();
                    }
                }
                // updateAllHander(s);
            } else {
                if (pathInfo.isClosed(svgPath)) {
                    openPath();
                }
                _this.startNewPointMode();
                console.log('Cannot delete last point', svgPath.getAttribute('d'));
            }

            if (svgPath.pathSegList.length < 3) {
                _this.startNewPointMode();
            }
            checkState();
        }

        _this.startNewPointMode = function () {
            var newPathHandler = _this.newPointAutoPlace();
            newPathHandler.classList.add('newPointControl');
            isNewPointMode = true;
        };

        _this.newPointAutoPlace = function () {
            var selectedElems = _this.getSelectedElems();
            var pathSeg;
            if (selectedElems.length > 0) {
                pathSeg = pathEditorView.controlPointsData.get(selectedElems[selectedElems.length - 1]).pathSeg;
            } else {
                pathSeg = pathInfo.getPointSegList(svgPath)[pathInfo.getPointSegList(svgPath).length  - 1];
            }
            return addNewPointAtLocation(pathSeg.x + 15, pathSeg.y + 15);
        };

        _this.deleteSelected = function () {
            _this.clear();
            deleteHandleElems(_this.getSelectedElems());
            _this.nextSelected();
        };


        /**
         * @memberof CanvasController
         * @function
         * @public
         * @type {function(!Array.<string>):!Array.<string>}
         */
        _this.selectOnly = function (selectOnlyThese) {
            console.assert(selectOnlyThese.forEach);

            /** @type {!Array.<string>} */
            var selectedElems = _this.getSelectedElems();

            /** @type {!Array.<string>} */
            var toUnselect = selectedElems.filter(function(c) {
                return selectOnlyThese.indexOf(c) === -1;
            });

            /** @type {!Array.<string>} */
            var toBeSelect = selectOnlyThese.filter(function(s) {
                return selectedElems.indexOf(s) === -1;
            });

            toUnselect.forEach(function(e) {
                setSelected(e, false);
            });
            toBeSelect.forEach(function(e) {
                setSelected(e, true);
            });

            console.assert(selectOnlyThese.length === _this.getSelectedElems().length);
            return selectOnlyThese;
        };


        _this.clearSelect = function() {
            selectedElems = [];
            eventCallback('edited');
        };

        _this.selectAll = function() {
            _this.clear();
            _this.selectOnly(_this.getAllSelectable());
        };

        function intersectedPoints(rect) {

        }


        // TODO you pathSeg index for order
        // TODO selet curve points with control points
        /**
        * Change selection to next or previous element
        *
        * @type {function(number)}
        */
        function tabSelection(delta) {
            /** @type {?Element} */
            var nextSelectable = null;
            /** @type {!Array.<string>} */
            var allSelectable = _this.getAllSelectable();

            if (allSelectable.length) {
                var nextIndex = 0;

                /** @type {!Array.<string>} */
                var selectedElems = _this.getSelectedElems();
                if (selectedElems.length) {
                    nextIndex = allSelectable.indexOf(selectedElems[selectedElems.length - 1]);

                    nextIndex += delta + allSelectable.length;
                    nextIndex = nextIndex % allSelectable.length;
                }

                nextSelectable = allSelectable[nextIndex];

                _this.selectOnly([nextSelectable]);
                console.assert(nextSelectable);
            }
        }

        /**
         * Change object selection to the next object
         * 
         * @memberof CanvasController
         * @function
         * @public
         */
        _this.nextSelected = function() {
            tabSelection(1);
        };

        /**
         * Change object selection to the previous object
         * 
         * @memberof CanvasController
         * @function
         * @public
         */
        _this.previousSelected = function() {
            tabSelection(-1);
        };

        _this.clear = function() {
            var newPointControl = svgDoc.querySelector('.newPointControl');
            if (newPointControl) {
                deleteHander(newPointControl);
                if (!pathInfo.isClosed(svgPath)) {
                    closePath();
                }
            }

            isNewPointMode = true;
            pathEditorView.updateAllHanders();
        };

        _this.clearPath = function () {
            svgPath.pathSegList.clear();
            init();
        };

        _this.destroy = function() {
            if (isNewPointMode) {
                var pathSeg = svgPath.pathSegList.getItem(svgPath.pathSegList.length - 1);
                if (pathSeg.pathSegTypeAsLetter !== 'M' && svgPath.pathSegList.length > 2) {
                    removeSegment(svgPath.pathSegList.length - 1);
                }
            }

            initVariables();

            Object.keys(_this).forEach(function(k) {
                _this[k] = function () {console.error('OBJECT DELETED');};
            });
            svgDoc = null;
            ownerDoc = null;

            if (svgPath.pathSegList.length < 2) {
                svgPath.remove();
            }
        };

        function initVariables() {
            Array.from(svgDoc.querySelectorAll('.path-handle, .control-line'))
                .forEach(function(e) {
                    e.remove();
                });

            selectedElems = [];
            pathEditorView.controlPointsData.clear();
        }

        function setUpControlPointState() {
            if (svgPath.pathSegList.length === 0) {
                var newPathSeg = svgPath.createSVGPathSegMovetoAbs(0, 0);
                svgPath.pathSegList.appendItem(newPathSeg);
            }

            if (!pathInfo.isClosed(svgPath)) {

            }
            if (svgPath.pathSegList.length < 3) {
                isNewPointMode = true;
            }
        }

        function init() {
            function cleanPath() {
                const newPathObject = SvgPath(svgPath.getAttribute('d')).abs().unarc();

                // Apply transform
                if (svgPath.hasAttribute('transform')) {    
                    newPathObject.transform(svgPath.getAttribute('transform'));
                    svgPath.removeAttribute('transform');
                }


                svgPath.setAttribute('d', newPathObject.toString());

                svgPathUtil.removeHorizontalVertialLines(svgPath);
            }

            initVariables();

            if (svgPath.pathSegList.length === 0) {
                const newPathSeg = svgPath.createSVGPathSegMovetoAbs(0, 0);
                svgPath.pathSegList.appendItem(newPathSeg);
            }
            if (svgPath.pathSegList.length < 3) {
                isNewPointMode = true;
            }

            cleanPath();

            pathInfo.getPointSegList(svgPath).forEach(pathEditorView.buildSegment);

            svgPath.style.pointerEvents = 'none';

            if (isNewPointMode) {
                var lastControlPoint = getHandlesWithPathSeg(svgPath.pathSegList.getItem(svgPath.pathSegList.length - 1))[0];
                lastControlPoint.classList.add('newPointControl');
            }

            const initState = svgPath.getPathData({normalize: true});
            try{            
                store = Redux.createStore(pathModel.path, initState);
                store.subscribe(() => console.log(store.getState()));
            } catch (e) {
                console.error(e);
            }
        }

        init();

        return _this;
    }

    return PathEditor;
}

(function(window) {
    'use strict';
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( [        
            ],
            pathEditorDefinition );
    } else {
        // browser global
        window.PathEditor = pathEditorDefinition(window.svgPathUtil, window.pathInfo, window.pathModel, window.Redux);
    }
})(window);

function makeSvgElem() {
    var svgElem = document.createElement('svg');
    svgElem.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
    svgElem.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    svgElem.setAttribute('version', '1.1');

    return svgElem;
}


function runTests() {
    var svgElem = makeSvgElem();
    var newPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    newPath.setAttribute('d', 'M10 80 C 40 10, 65 10, 95 80 S 150 150, 180 80');

    document.body.appendChild(svgElem);
    svgElem.appendChild(newPath);

    PathEditor(newPath);

    svgElem.remove();
}
// document.addEventListener("DOMContentLoaded", runTests);
/*

    code M command moveto', x:3, y:7
    code L command lineto', x:5, y:-6
    code C command curveto', x1:33, y1:43, x2:38, y2:47, x:43, y:47
    code Z command closepath

    // Can be simplified
    code Q command quadratic curveto', x1:50, y1:50, x:73, y:57
    code S command smooth curveto', x2:63, y2:67, x:63, y:67

    code T command smooth quadratic curveto', x:70, y:40


    // ** Codes not used. If found are replaced with equivelent, more maintainable codes.
    code A command elliptical arc', rx:5, ry:5, xAxisRotation:45, largeArc:true, sweep:false, x:40, y:20
    // Replace with L
    code V command vertical lineto', y:27
    code H command horizontal lineto', x:23
    // Relative codes
    code s command - relative - smooth curveto x2:-10, y2:10, x:10, y:10
    code v command - relative - vertical lineto y:10
    code h command - relative - horizontal lineto x:10
    code l command - relative - lineto x:10, y:0
    code m command - relative - moveto x:-10, y:10
    code c command - relative - curveto x1:0, y1:5, x2:5, y2:10, x:10, y:10
    code q command - relative - quadratic curveto x1:20, y1:-5, x:0, y:-10
    code t command - relative - smooth quadratic curveto x:0, y:-15
    code a command - relative - elliptical arc rx:5, ry:5, xAxisRotation:20, largeArc:false, sweep:true, x:-10, y:-10
*/

function addKeys(getCanvasController, history, key) {
    key('esc', function(){
        if (getCanvasController()) {
            getCanvasController().clear();
            return false;
        }
    });

    function isNotInputActive() {
        return ['button', 'input', 'radio', 'select'].indexOf(document.activeElement.nodeName.toLowerCase()) === -1;
    }
    function cyclePointType () {
        if (isNotInputActive()) {
            getCanvasController().cycleType();
            return false;
        }
    }
    function deleteSelected () {
        if (getCanvasController()) {
            getCanvasController().deleteSelected();
        }
    }

    key('delete', deleteSelected);

    key('tab', function(){
        if (getCanvasController()) {
            getCanvasController().nextSelected();
            return false;
        }
    });
    key('ctrl+tab, ⇧+tab, ⌘+tab', function() {
        if (getCanvasController()) {
            getCanvasController().previousSelected();
            return false;
        }
    });


    key('up', function() {
        if (isNotInputActive()) {
            getCanvasController().moveSelected(0, -1);
            return false;
        }
    });
    key('down', function() {
        if (isNotInputActive()) {
            getCanvasController().moveSelected(0, 1);
            return false;
        }
    });
    key('left', function() {
        if (isNotInputActive()) {
            getCanvasController().moveSelected(-1, 0);
            return false;
        }
    });
    key('right', function() {
        if (isNotInputActive()) {
            getCanvasController().moveSelected(1, 0);
            return false;
        }
    });

    key('shift+up', function() {
        if (isNotInputActive()) {
            getCanvasController().moveSelected(0, -10);
            return false;
        }
    });
    key('shift+down', function() {
        if (isNotInputActive()) {
            getCanvasController().moveSelected(0, 10);
            return false;
        }
    });
    key('shift+left', function() {
        if (isNotInputActive()) {
            getCanvasController().moveSelected(-10, 0);
            return false;
        }
    });
    key('shift+right', function() {
        if (isNotInputActive()) {
            getCanvasController().moveSelected(10, 0);
            return false;
        }
    });


    key('w', cyclePointType);
    key('ctrl+c', function() {
        if (isNotInputActive()) {
            getCanvasController().toggleOpenClose();
            return false;
        }
    });
    key('ctrl+a', function() {
        if (isNotInputActive()) {
            getCanvasController().selectAll();
            return false;
        }
    });
    key('ctrl+z, ⌘+z', function() {
        if (isNotInputActive()) {
            history.undo();
        }
    });
    key('ctrl+y, ⌘+y, ctrl+shift+z, ⌘+shift+z', function() {
        if (isNotInputActive()) {
            history.redo();
        }
    });
}

function removeKeys(key) {
    key.unbind('esc');
    key.unbind('delete');
    key.unbind('tab');
    key.unbind('w');
    key.unbind('ctrl+tab, ⇧+tab, ⌘+tab');
    key.unbind('up');
    key.unbind('down');
    key.unbind('left');
    key.unbind('right');
    key.unbind('shift+up');
    key.unbind('shift+down');
    key.unbind('shift+left');
    key.unbind('shift+right');
    key.unbind('ctrl+c');
    key.unbind('ctrl+a');
    key.unbind('ctrl+z, ⌘+z');
    key.unbind('ctrl+y, ⌘+y, ctrl+shift+z, ⌘+shift+z');
}


function canvasControllerDefinition(PathEditor, key) {
    'use strict';

    function CanvasController(svgElem) {

        // http://stackoverflow.com/questions/1861382/convert-png-to-svg


        /** @type {function(!Element, string):(boolean|Element)} */
        function getCssSelectorMatch(domElement, cssSelector) {
            while (domElement.parentNode) {
                if (!domElement.classList.contains('newPointControl') && domElement.style.pointerEvents !== 'none' && domElement.matches(cssSelector)) {
                    return domElement;
                }

                domElement = domElement.parentNode;
            }

            return null;
        }

        // TouchEmulator();
        // var hammertime = new Hammer(document.querySelector('svg'), {});

        // hammertime.get('pinch').set({ enable: true });
        // hammertime.get('rotate').set({ enable: true });

        // // hammertime.add( new Hammer.Pan({ direction: Hammer.DIRECTION_ALL, threshold: 0 }) );
        // hammertime.add( new Hammer.Tap({ event: 'doubletap', taps: 4 }) );
        // hammertime.add( new Hammer.Tap({ event: 'quadrupletap', taps: 4 }) );
        // var doubleTap = new Hammer.Tap({event: 'doubletap', taps: 2 })

        // hammertime.on('pan', function(ev) {
        //     console.log('pan', ev);
        //     if (pathEditor) {

        //     }
        // });
        // hammertime.on('tap', function(ev) {
        //     // console.log('tap', ev);
        // });
        // hammertime.on('doubletap', function(ev) {
        //     // console.log('tap', ev);
        // });
        // hammertime.on('rotate', function(ev) {
        //     console.log('rotate', ev);
        // });
        // hammertime.on('pinch', function(ev) {
        //     console.log('pinch', ev);
        // });
        // hammertime.on('press', function(ev) {
        //     console.log('press', ev);
        // });
        // hammertime.on('quadrupletap', function(ev) {
        //     console.log('quadrupletap', ev);
        // });

        var pathEditor;

        var startX = null;
        var startY = null;
        /** @type {boolean} */
        var dragging = false;

        function transformEventCoor(event, addedOffset) {
            addedOffset = true;
            var mouseX = event.clientX;
            var mouseY = event.clientY;

            if (event.touches && event.touches[0]) {
                mouseX = event.touches[0].clientX;
                mouseY = event.touches[0].clientY;
            }

            var scrollSearch = event.target;
            while (scrollSearch !== document.body) {
                mouseX += scrollSearch.scrollLeft;
                mouseY += scrollSearch.scrollTop;

                scrollSearch = scrollSearch.parentNode;
            }

            var target = event.target || event.srcElement,
                svg = target.ownerSVGElement || getCssSelectorMatch(event.target, 'svg'),
                rect = svg.getBoundingClientRect(),
                offsetX = addedOffset?mouseX - rect.left:mouseX,
                offsetY = addedOffset?mouseY - rect.top:mouseY;

            // var parentPosition = getPosition(event.currentTarget);
            // offsetX = mouseX - parentPosition.x;
            // offsetY = mouseY - parentPosition.y;

            return {
                'x': offsetX,
                'y': offsetY,
            };
        }

        function canvasMove(e) {
            e.preventDefault();
            var pos = transformEventCoor(e);
            pathEditor.dragMove(pos.x, pos.y, startX, startY, e.ctrlKey, e.shiftKey,
                startX !== null);
            history.canvasEdited('dragMove');
        }

        function mouseDownAction(e) {
            var target = getCssSelectorMatch(e.target, '.path-handle');
            if (target) {
                target = target.classList.contains('newPointControl')?undefined:target;
            }

            var pos = transformEventCoor(e);
            pathEditor.dragStart(target, pos.x, pos.y, e.ctrlKey, e.shiftKey);
            startX = pos.x;
            startY = pos.y;
            e.stopPropagation();
            history.canvasEdited('mousedownEvent');

        }

        function mousedownEvent(e) {
            if (e.button === 0) {
                mouseDownAction(e);
            } else {
                dragging = false;
            }
            svgElem.removeEventListener('mousemove', canvasMoveHoverWatch, false);
        }

        function clickEvent(e) {
            var target = getCssSelectorMatch(e.target, '.path-handle');

            if (target) {         
                var pos = transformEventCoor(e, true);   
                pathEditor.click(target, pos.x, pos.y, e.ctrlKey, e.shiftKey);
                history.canvasEdited('click');
            }
        }


        var lastHoverID;
        /** @type {function(!Object):boolean} */
        function canvasMoveHoverWatch(event) {
            // startEvent = _module.processEvent(event, svgDoc);
            // canvasController.mouseMove(startEvent.x, startEvent.y);
            if (!dragging) {      

                /** @type {!Element} */
                var target = event.target;
                // If the element is a referenced element we need to get the correspondingUseElement.
                if (target.correspondingUseElement) {
                    target = target.correspondingUseElement;
                }

                var selectable = getCssSelectorMatch(target, '.path-handle');

                if (selectable) {
                    if (lastHoverID) {
                        if (lastHoverID !== selectable) {
                            pathEditor.offHover(lastHoverID);
                            pathEditor.onHover(selectable);
                            lastHoverID = selectable;
                        }
                    } else {
                        pathEditor.onHover(selectable);
                        lastHoverID = selectable;
                    }
                } else {
                    if (lastHoverID) {
                        pathEditor.offHover(lastHoverID);
                        lastHoverID = null;
                    }
                }
            }
        }

        function dblclick(e) {
            // if (currentPath !== e.target) {
            // }
            // if (e.target.nodeName === 'path') {
            //     if (pathEditor && pathEditor.svgPath === e.target) {
            //         return;
            //     }
            //     restoreCurrentPathEditor();
            //     pathEditor = CanvasController(e.target);
            // } else 
            if (pathEditor) {
                var pos = transformEventCoor(e, true);   

                pathEditor.dblTap(e.target, pos.x, pos.y, false);
                history.canvasEdited('dblTap');
            }
        }



        function mouseup(e) {
            startX = null;
            startY = null;
            var pos = transformEventCoor(e);
            pathEditor.dragEnd(pos.x, pos.y, e.ctrlKey, e.shiftKey);

            svgElem.addEventListener('mousemove', canvasMoveHoverWatch, false);
            history.canvasEdited('mousemove');
        }

        // svgElem.addEventListener('mouseout', mouseup, false);
        svgElem.addEventListener('mousedown', mousedownEvent, false);
        svgElem.addEventListener('touchstart', mouseDownAction, false);
        svgElem.addEventListener('click', clickEvent, false);
        svgElem.addEventListener('mousemove', canvasMove, false);
        svgElem.addEventListener('touchmove', canvasMove, false);
        svgElem.addEventListener('mouseup', mouseup, false);
        svgElem.addEventListener('touchend', mouseup, false);
        svgElem.addEventListener('mousemove', canvasMoveHoverWatch, false);
        svgElem.addEventListener('dblclick', dblclick, true);

        function destroy() {
            svgElem.removeEventListener('mousemove', canvasMove, false);
            svgElem.removeEventListener('mouseup', mouseup, false);
            svgElem.removeEventListener('mousedown', mousedownEvent, false);
            svgElem.removeEventListener('click', clickEvent, false);
            svgElem.removeEventListener('mousemove', canvasMoveHoverWatch, false);
            svgElem.removeEventListener('dblclick', dblclick, true);

            pathEditor.destroy();
            pathEditor = null;

            // if (svgPathUtil.getPointSegList(svgPath).length === 1) {
            //     svgPath.remove();
            // }
            deleteCurrentPathEditor();
        }

        var parentNode = svgElem.parentNode;
        var history = History(function (newState) {
            console.log('New state ', newState);

            parentNode.innerHTML = newState;
            Array.from(svgElem.querySelectorAll('.path-handle, .control-line'))
                .forEach(function(e) {
                    e.remove();
                });
            svgElem.removeAttribute('class');
            restoreCurrentPathEditor();
        }, function () {

            // var serializer = new XMLSerializer();
            // return serializer.serializeToString(svgElem);
            return parentNode.innerHTML;
        }, function () {});

        restoreCurrentPathEditor();
        history.canvasEdited('Init');


        function deleteCurrentPathEditor() {
            if (pathEditor) {
                pathEditor.destroy();
                pathEditor = null;
            }
        }
        function restoreCurrentPathEditor() {
            deleteCurrentPathEditor();

            pathEditor = PathEditor(svgElem.querySelector('path'));
        }
        // addKeys(function() {
        //     return pathEditor;
        // }, history, window.key);

        // function makePath() {
        //     restoreCurrentPathEditor();
        //     var newPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        //     newPath.setAttribute('fill', '#F00');
        //     newPath.setAttribute('stroke', '#000');
        //     newPath.setAttribute('stroke-width', 6);
        //     svgElem.appendChild(newPath);
        //     pathEditor = CanvasController(newPath, true);
        // }


        function runTest() {
            mousedownEvent({
                'target': document.querySelector('svg'),
                'clientX': 100,
                'clientY': 100,
                'stopPropagation': () => {}
            });
            mouseup({
                'target': document.querySelector('svg'),
                'clientX': 120,
                'clientY': 120,
                'stopPropagation': () => {}
            });
            dblclick({
                'target': document.querySelector('svg'),
                'clientX': 120,
                'clientY': 120,
                'stopPropagation': () => {}
            });
            dblclick({
                'target': document.querySelector('svg'),
                'clientX': 100,
                'clientY': 100,
                'stopPropagation': () => {}
            });
        }

        return {
            'runTest': runTest,
            'destroy': destroy,
            'redo': history.redo,
            'undo': history.undo,
            'deleteSelected': function() {
                pathEditor.deleteSelected();
            },
            'newPoint': function() {
                pathEditor.newPointAutoPlace();
            },
            'clearPath': function() {
                pathEditor.clearPath();
            },
            'cyclePointType': function() {
                pathEditor.cyclePointType();
            },
        };
    }



    return CanvasController;
}

(function(window) {
    'use strict';
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( [        
            ],
            canvasControllerDefinition );
    } else {
        // browser global
        window.CanvasController = canvasControllerDefinition(window.PathEditor, window.key);
    }
})(window);




/**
 * @file
 * @copyright Virtual Console, LLC - All Rights Reserved
 * @license Unauthorized copying of this file, via any medium is strictly prohibited
 * @ignore Proprietary and confidential
 * @author Ben McDonald [mcdonald.ben@gmail.com]
 *
 * @description Set of untilities to edit SVG documents
*/


var attributeWithReferences = ['fill', 'stroke', 'filter', 'marker-start', 'marker-mid',
                               'marker-end', 'clip-path', 'mask', 'href'];
var defTagChildren = ['lineargradient', 'radialgradient', 'pattern', 'filter'];

/** @namespace svgUtils */
function SVGUtilsDefinition(DomUtils, MathUtils, svgMatrixUntils, SvgPath) {
    'use strict';
    var _this = {};

    _this.svgns = 'http://www.w3.org/2000/svg';
    _this.xlinkns = 'http://www.w3.org/1999/xlink';
    _this.xmlns = 'http://www.w3.org/XML/1998/namespace';
    _this.xmlnsns = 'http://www.w3.org/2000/xmlns/'; // see http://www.w3.org/TR/REC-xml-names/#xmlReserved
    _this.htmlns = 'http://www.w3.org/1999/xhtml';
    _this.mathns = 'http://www.w3.org/1998/Math/MathML';

    _this.colorProperties = ['stroke', 'fill', 'stopColor', 'stop-color'];



    function removeNonStandardAttritbues(parentElement) {
        Array.from(parentElement.querySelectorAll('*'))
            .filter(function(e) {
                return e instanceof SVGElement;
            })
            .forEach(function(e) {
                var attriToRemove = [];
                for (var index = 0; index < e.attributes.length; index++) {
                   if (!validAttribute(e, e.attributes[index].name)) {
                        attriToRemove.push(e.attributes[index].name);
                   }
                }

                attriToRemove.forEach(function(a) {
                    e.removeAttribute(a);
                });
            });
    }
    _this.removeNonStandardAttritbues = removeNonStandardAttritbues;

    var validAttributeCache = {};
    function validAttribute(element, attributeName) {
        var isValid;
        if (element.nodeName in validAttributeCache && attributeName in validAttributeCache[element.nodeName]) {
            isValid = validAttributeCache[element.nodeName][attributeName];
        } else {
            isValid = attributeName in element || attributeName === 'class' || attributeName in element.style ||
                    attributeName === 'xlink' || attributeName === 'd' || attributeName.indexOf('href') !== -1 || attributeName.indexOf('xml:') !== -1;

            validAttributeCache[element.nodeName] = validAttributeCache[element.nodeName] || {};
            validAttributeCache[element.nodeName][attributeName] = isValid;
            console.log(element.nodeName, attributeName, isValid);
        }

        return isValid;
    }
    _this.validAttribute = validAttribute;

    function svgElementFromString(svgText) {
        var docElem = (new DOMParser())
            .parseFromString('<svg xmlns="http://www.w3.org/2000/svg">' +
                svgText + '</svg>', 'text/xml').documentElement;

        var node = docElem.firstChild;
        document.importNode(node, true);
        return node;
    }

    _this.createSVGElement = function(tagName) {
        return document.createElementNS(_this.svgns, tagName);
    };

    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(!Element, number, number, number):!Object}
     */
    _this.scaleViewport = function(element, delta, x, y) {
        var z = Math.pow(1 + 0.3, delta);
        var k = element.ownerSVGElement.createSVGMatrix().translate(x, y).scale(z).translate(-x, -y);

        if (element.transform.baseVal.numberOfItems) {
            element.transform.baseVal.consolidate();
            var currentMatrix = element.transform.baseVal.getItem(0).matrix;

            // if (element.style.transform) {
                // var currentMatrix = element.ownerSVGElement.createSVGMatrix();
                // var oldValues = element.parentNode.parentNode.style.transform.replace('matrix3d(', '').replace(')', '')
                //             .split(',').map(function(f) {return parseFloat(f);});
                // Object.keys(currentMatrix).sort().forEach(function(key, i) {
                //     currentMatrix[key] = oldValues[i];
                // });         
                // currentMatrix.a = oldValues[0];
                // currentMatrix.d = oldValues[0];
                // currentMatrix.e = oldValues[12];
                // currentMatrix.f = oldValues[13];
            // }
            k = currentMatrix.multiply(k);
        }

        // var b = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
        // // var b = Object.keys(k).sort().map(function(key) {return k[key];}).concat([0,0,0,0,1,0,0,0,0,1]);
        // b[0] = k.a;
        // b[3] = 0;
        // b[4] = 0;
        // b[5] = k.a;
        // b[12] = 0;
        // b[13] = 0;
        // // b[12] = k.e;
        // // b[13] = k.f;
        // element.parentNode.parentNode.style.transform = 'matrix3d(' + 
        //         b.join(',') + ')';
        // k.a = 1;
        // k.f = 1;
        _this.setCTM(element, k);
        return k;
    };

    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(!Element, number):!Object}
     */
    _this.absoluteScaleViewport = function(element, scale) {
        var k = element.ownerSVGElement.createSVGMatrix().scale(scale);

        if (element.transform.baseVal.numberOfItems) {
            element.transform.baseVal.consolidate();
            var currentMatrix = element.transform.baseVal.getItem(0).matrix;
            currentMatrix.a = 1;
            currentMatrix.d = 1;
            k = currentMatrix;
        }
        _this.setCTM(element, k);

        return k;
    };

    // Function: svgedit.utilities.getPathBBox
    // Get correct BBox for a path in Webkit
    // Converted from code found here:
    // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
    //
    // Parameters:
    // path - The path DOM element to get the BBox for
    //
    // Returns:
    // A BBox-like object
    _this.getPathBBox = function(path) {
        var referenceElement = path;
        referenceElement = path.correspondingUseElement || referenceElement;
        if (path.href && path.href.baseVal) {
            referenceElement = document.getElementById(path.href.baseVal.substring(1)) || referenceElement;
        }

        
        var seglist = referenceElement.pathSegList;
        var tot = seglist.numberOfItems;

        var x1 = null;
        var y1 = null;
        var x2 = null;
        var y2 = null;

        var xCoordinates = [];
        var yCoordinates = [];
        for(var i=0; i < tot; i++) {
            var seg = seglist.getItem(i);

            // xCoordinates.push(seg.x);
            // yCoordinates.push(seg.y);
            // xCoordinates.push(seg.x1);
            // yCoordinates.push(seg.y1);
            if (!x1) {
                x1 = seg.x || seg.x1;
                y1 = seg.y || seg.y1;
            } else {
                x2 = seg.x || seg.x1;
                y2 = seg.y || seg.y1;
            }
        }

        // xCoordinates = xCoordinates.filter(function(i){return i;});
        // yCoordinates = yCoordinates.filter(function(i){return i;});

        // var x = Math.min.apply(null, xCoordinates);
        // var width = Math.max.apply(null, xCoordinates) - x;
        // var y = Math.min.apply(null, yCoordinates);
        // var height = Math.max.apply(null, yCoordinates) - y;

        if (x1 === null) {
            return null;
        } else {        
            return {
                'x1': x1,
                'y1': y1,
                'x2': x2,
                'y2': y2
            };
        }
    };


    var i = 0;
    _this.getId = function (prefix) {
        prefix = prefix || '';
        var newID = prefix + Math.round(Math.random() * 100000000).toString();
        while(document.getElementById(newID) !== null) {
            newID = prefix + Math.round(Math.random() * 100000000).toString();
        }
        return newID;
    };


    /**
     * Sets the current transform matrix of an element.
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(!Element}:!Object}
     */
    // _this.getBBox = function(elem) {
    //     if (elem.nodeType != 1) return null;
    //     var ret = null;
    //     var elname = elem.nodeName;

    //     switch ( elname ) {
    //         case 'text':
    //             if(selected.textContent === '') {
    //                 selected.textContent = 'a'; // Some character needed for the selector to use.
    //                 ret = selected.getBBox();
    //                 selected.textContent = '';
    //             } else {
    //                 try { ret = selected.getBBox();} catch(e){}
    //             }
    //             break;
    //         case 'path':
    //             if (selected.getAttribute('d').indexOf('A') === -1) {
    //                 ret = svgedit.utilities.getPathBBox(selected);
    //             } else {
    //                 try { ret = selected.getBBox();} catch(e){}
    //             }
    //             break;
    //         case 'g':
    //         case 'a':
    //             ret = groupBBFix(selected);
    //             break;
    //         default:

    //             if(elname === 'use') {
    //                 ret = groupBBFix(selected, true);
    //             }
    //             if(elname === 'use' || ( elname === 'foreignObject' && svgedit.browser.isWebkit() ) ) {
    //                 if(!ret) ret = selected.getBBox();
    //                 // This is resolved in later versions of webkit, perhaps we should
    //                 // have a featured detection for correct 'use' behavior?
    //                 // ——————————
    //                 //if(!svgedit.browser.isWebkit()) {
    //                     var bb = {};
    //                     bb.width = ret.width;
    //                     bb.height = ret.height;
    //                     bb.x = ret.x + parseFloat(selected.getAttribute('x')||0);
    //                     bb.y = ret.y + parseFloat(selected.getAttribute('y')||0);
    //                     ret = bb;
    //                 //}
    //             } else if(~visElems_arr.indexOf(elname)) {
    //                 try { ret = selected.getBBox();}
    //                 catch(e) {
    //                     // Check if element is child of a foreignObject
    //                     var fo = $(selected).closest('foreignObject');
    //                     if(fo.length) {
    //                         try {
    //                             ret = fo[0].getBBox();
    //                         } catch(e) {
    //                             ret = null;
    //                         }
    //                     } else {
    //                         ret = null;
    //                     }
    //                 }
    //             }
    //     }
    //     if(ret) {
    //         ret = svgedit.utilities.bboxToObj(ret);
    //     }

    //     // get the bounding box from the DOM (which is in that element's coordinate system)
    //     return ret;
    // };


    /**
     * Sets the current transform matrix of an element.
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(!Element, !Object)}
     */
    _this.setCTM = function(svgElement, m) {
        if (Number.isFinite(m.a) && Number.isFinite(m.b) &&
            Number.isFinite(m.c) && Number.isFinite(m.d) &&
            Number.isFinite(m.e) && Number.isFinite(m.f)) {
            svgMatrixUntils.setElementMatrix(svgElement, m);
            // return svgElement.transform.baseVal.initialize(
            //     svgElement.ownerSVGElement.createSVGTransformFromMatrix(m));
        } else {
            console.log('Invalid matrix ', m, svgElement);
        }
    };

    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(!Element, Array.<string>):Array.<string>, boolean}
     */
    _this.getAllAttributesValues = function(doc, attributes, includeChildNodes) {
        var attributeValuesList = attributes.map(function(attribute) {
            return Array.from(doc.querySelectorAll('[' + attribute + ']')).map(function (ele) {
                return ele.getAttribute(attribute);
            });
        });
        return [].concat.apply([], attributeValuesList);
    }

    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(!Element):Array.<string>}
     */
    _this.getAllAttributesWithURL = function(doc) {
        var urlList = _this.getAllAttributesValues(doc, attributeWithReferences).map(_this.getUrlFromAttr);
        return urlList.filter(function (e) {return e;});
    }

    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(string):string}
     */
    _this.getUrlFromAttr = function(attrVal) {
        if (attrVal) {
            // url("#somegrad")
            if (attrVal.indexOf('url("') === 0) {
                return attrVal.substring(5, attrVal.indexOf('"',6));
            }
            // url('#somegrad')
            else if (attrVal.indexOf("url('") === 0) {
                return attrVal.substring(5, attrVal.indexOf("'",6));
            }
            else if (attrVal.indexOf("url(") === 0) {
                return attrVal.substring(4, attrVal.indexOf(')'));
            }
        }
        return null;
    };

    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(!Element, function, boolean):Array.<string>}
     */
    _this.adjustSvgDomColors = function (svgDom, callback, includeChildNodes)  {
        return DomUtils.applyFunctionToAttributes(svgDom.cloneNode(true)
                    , ['stroke', 'fill', 'stopColor', 'stop-color'], ['stroke', 'fill', 'stopColor', 'stop-color'], function (a) {
            if (a.indexOf('url') === -1 && a !== 'none') {
                return callback(a);
            } else {
                return a;
            }
        })
    };

    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(!Element):string}
     */
    _this.domToSvgUrl = function (svgDom) {
        return "data:image/svg+xml;base64," + window.btoa(new XMLSerializer().serializeToString(svgDom));
    };

    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(!Element)}
     */
    _this.removeUnusedDefs = function(svgDoc) {
        var requireRefs = _this.getAllAttributesWithURL(svgDoc);

        Array.from(svgDoc.querySelectorAll('defs > *')).forEach(function(defChild) {
            if (requireRefs.indexOf('#' + defChild.id) === -1) {
                defChild.parentNode.removeChild(defChild);
            }
        });
    };

    _this.makeLinearGradient = function(ownerDocument, svgDocument, colorsAndOffsets, gradientVector, rotation, transform) {
        var linearGradient = ownerDocument.createElementNS(_this.svgns, 'linearGradient');
        linearGradient.setAttribute('color-interpolation', 'linearRGB');

        gradientVector.x /= 2;
        gradientVector.y /= 2;

        if (gradientVector) {
            if (gradientVector.x>0){
                gradientVector.x += 0.25;
                linearGradient.setAttribute('x1', '0.25');
                linearGradient.setAttribute('x2', gradientVector.x);
            } else {
                gradientVector.x -= 0.25;
                linearGradient.setAttribute('x1', -gradientVector.x);
                linearGradient.setAttribute('x2', '0.25');
            }
            if (gradientVector.y>0){
                gradientVector.y += 0.25;
                linearGradient.setAttribute('y1', '0.25');
                linearGradient.setAttribute('y2', gradientVector.y);
            } else {
                gradientVector.y -= 0.25;
                linearGradient.setAttribute('y1', -gradientVector.y);
                linearGradient.setAttribute('y2', '0.25');
            }
        }

        if (rotation) {
            linearGradient.setAttribute('gradientUnits', 'userSpaceOnUse');
            linearGradient.setAttribute('gradientTransform', 'rotate(' + Math.round(rotation) + ')');
        }
        if (transform) {
            linearGradient.setAttribute('gradientUnits', 'userSpaceOnUse');
            linearGradient.setAttribute('gradientTransform', 'transform(' + transform + ')');
        }

        colorsAndOffsets.forEach(function(colorsAndOffset, i) {
            var stop = ownerDocument.createElementNS(_this.svgns, 'stop');
            stop.setAttribute('stop-color', colorsAndOffset.color);
            if (colorsAndOffset.offset) {
                stop.setAttribute('offset', colorsAndOffset.offset || ((i*100).toString() + '%'));
            }
            if(colorsAndOffset.opacity) {
                stop.setAttribute('stop-opacity', colorsAndOffset.opacity);
            }

            linearGradient.appendChild(stop);
        });

        svgDocument.querySelector('defs').appendChild(linearGradient);

        return linearGradient;
    };

    _this.addLinearGradient = function(elem, fillOrStoke, colorsAndOffsets) {
        var linearGradient = makeLinearGradient(elem.ownerDocument, elem.ownerSVGElement, colorsAndOffsets);
        linearGradient.id = elem.id + fillOrStoke;

        elem.setAttribute(fillOrStoke, 'url(#' + linearGradient.id + ')');

        _this.removeUnusedDefs(elem.ownerSVGElement);
    };

    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(!Element):!Object}
     */
    // _this.imageToSVG= function (imageEle) {
    //     var parent = imageEle.parentElement;

    //     var svgString = '<svg></svg>';
    //     var svg = $(addSVGString(parent, svgString));

    //     var attributes = $(imageEle).prop("attributes");

    //     $.each(attributes, function() {
    //         svg.attr(this.name, this.value);
    //     });

    //     // Return a promise
    //     return $.get($(imageEle).attr("xlink:href"), [], function (svgDom) {
    //         svg.attr('name', $(imageEle).attr('cbs:name'));
    //         svg.attr('depth', $(imageEle).attr('cbs:depth'));
    //         if ($(imageEle).attr('x')) {
    //             svg.attr('x', $(imageEle).attr('x'));
    //             svg.attr('y', $(imageEle).attr('y'));
    //         }
    //         svg.attr('width', $(imageEle).attr('width'));
    //         svg.attr('height', $(imageEle).attr('height'));
    //         // svg.attr('viewBox', '0 0 ' +
    //         //     svg.attr('width') + ' ' +
    //         //     svg.attr('height'));

    //         svg.append($(svgDom).children());
    //         $(imageEle).before($(svg).remove());
    //         $(imageEle).remove();
    //     });
    // };

    /**
     * Adds SVG element defined in svgSting to parent element
     * @param {string} svgSting
     * @param {Element} parent
     * @return {Element}
     */
    // function addSVGString(parent, svgSting) {
    // }


    /**
     * Returns the input string wraped in a SVG element text
     * @param {string} svgSting
     * @return {string}
     */
    function wrapWithSVGHeaders (svgSting) {
        var preSVG = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:cbs="http://www.casesbysource.com/" version="1.1">';
        var postSVG = '</svg>';

        return preSVG + svgSting + postSVG;
    }

    function positionSvgObjectNoTransform(element, x, y, scaleX, scaleY) {
        scaleX = scaleX || 1;
        scaleY = scaleY || 1;
        switch (element.nodeName.toLowerCase()) {
            case 'ellipse':
                if (x) {
                    element.cx.baseVal.value = (x + element.rx.baseVal.value) / scaleX;
                }
                if (y) {
                    element.cy.baseVal.value = (y + element.ry.baseVal.value) / scaleY;
                }
                break;
            case 'circle':
                if (x) {
                    element.cx.baseVal.value = (x + element.r.baseVal.value) / scaleX;
                }
                if (y) {
                    element.cy.baseVal.value = (y + element.r.baseVal.value) / scaleY;
                }
                break;
            case 'foreignObject':
            case 'rect':
            case 'image':
                if (x) {
                    element.x.baseVal.value = x / scaleX;
                }
                if (y) {
                    element.y.baseVal.value = y / scaleY;
                }
                break;
            default:
                return false;
        }

        return true;
    }
    _this.positionSvgObject = function (svgElement, x, y) {
        _this.removeTransform(svgElement);
        var currentMatrix = svgMatrixUntils.getElementMatrix(svgElement ,svgElement.parentNode);
        if (!positionSvgObjectNoTransform(svgElement, x, y, currentMatrix.a, currentMatrix.d)) {
            var bbox = getElementBBoxWithTransform(svgElement);

            if (x) {
                currentMatrix.e = x + (bbox.width / 2);
            }
            if (y) {
                currentMatrix.f = y;
            }

            _this.setCTM(svgElement, currentMatrix);
        }
        return true;
    };

    function removeTransform(element) {
        var currentMatrix = svgMatrixUntils.getElementMatrix(element ,element.parentNode);
        if (moveBySvgObjectNoTransform(element, currentMatrix.e * currentMatrix.a, currentMatrix.f * currentMatrix.d, currentMatrix.a, currentMatrix.d)) {
            currentMatrix.e = 0;
            currentMatrix.f = 0;
            _this.setCTM(element, currentMatrix);
        }
        // if (sizeSvgObjectNoTransform(element, currentMatrix.a, currentMatrix.d)) {
        //     currentMatrix.a = 1;
        //     currentMatrix.d = 1;
        // }
    }
    _this.removeTransform = removeTransform;

    function moveBySvgObjectNoTransform(element, dx, dy, scaleX, scaleY) {
        scaleX = scaleX || 1;
        scaleY = scaleY || 1;
        switch (element.nodeName.toLowerCase()) {
            case 'ellipse':
                if (dx) {
                    element.cx.baseVal.value += dx / scaleX;
                }
                if (dy) {
                    element.cy.baseVal.value += dy / scaleY;
                }
                break;
            case 'circle':
                if (dx) {
                    element.cx.baseVal.value += dx / scaleX;
                }
                if (dy) {
                    element.cy.baseVal.value += dy / scaleY;
                }
                break;
            case 'rect':
            case 'image':
                if (dx) {
                    if (!element.x.baseVal.value) {
                        element.x.baseVal.value = 0;
                    }
                    element.x.baseVal.value += dx / scaleX;
                }
                if (dy) {
                    if (!element.y.baseVal.value) {
                        element.y.baseVal.value = 0;
                    }
                    element.y.baseVal.value += dy / scaleY;
                }
                break;
            default:
                return false;
        }

        return true;
    }
    _this.moveBySvgObject = function (svgElement, dx, dy) {
        var currentMatrix = svgMatrixUntils.getElementMatrix(svgElement ,svgElement.parentNode);
        _this.removeTransform(svgElement);
        if (!moveBySvgObjectNoTransform(svgElement, dx, dy, currentMatrix.a, currentMatrix.d)) {
            var pt = svgElement.ownerSVGElement.createSVGPoint();
            if (dx) {
                pt.x = dx / currentMatrix.a;
            }
            if (dy) {
                pt.y = dy / currentMatrix.d;
            }

            var k = svgElement.ownerSVGElement.createSVGMatrix().translate(pt.x, pt.y);
            k = currentMatrix.multiply(k);

            _this.setCTM(svgElement, k);
        }
        return true;
    };

    function sizeSvgObjectNoTransform(element, width, height) {
        switch (element.nodeName.toLowerCase()) {
            case 'ellipse':
                if (width) {
                    var positionDiffX = (element.rx.baseVal.value - (width / 2)) ;
                    element.cx.baseVal.value = element.cx.baseVal.value - positionDiffX;
                    element.rx.baseVal.value = width/ 2;                    
                }
                if (height) {
                    var positionDiffY = (element.ry.baseVal.value - (height / 2));
                    element.cy.baseVal.value = element.cy.baseVal.value - positionDiffY;
                    element.ry.baseVal.value = height/ 2;
                }
                break;
            case 'circle':
                var newRadius = Math.max(width/ 2, height/ 2);
                var positionDiff = (element.r.baseVal.value - newRadius) / 2;
                if (width) {
                    element.setAttribute('cx', element.cx.baseVal.value - positionDiff);
                }
                if (height) {
                    element.setAttribute('cy', element.cy.baseVal.value - positionDiff);
                }
                if (width || height) {
                    element.r.baseVal.value = Math.max(width/ 2, height/ 2);
                }
                break;
            case 'rect':
            case 'image':
                if (width) {
                    element.setAttribute('width', width);
                }
                if (height) {
                    element.setAttribute('height', height);
                }
                break;
            default:
                return false;
        }

        return true;
    }
    _this.sizeSvgObject = function (svgElement, width, height) {
        _this.removeTransform(svgElement);
        var currentMatrix = svgMatrixUntils.getElementMatrix(svgElement ,svgElement.parentNode);
        if (!sizeSvgObjectNoTransform(svgElement, width, height, currentMatrix.a, currentMatrix.d)) {
            var bbox = getElementBBoxWithTransform(svgElement);
            width = width || bbox.width;
            height = height || bbox.height;

            var k = svgElement.ownerSVGElement.createSVGMatrix().scale(width/bbox.width, height/bbox.height);
            k = currentMatrix.multiply(k);

            _this.setCTM(svgElement, k);
        }
        return true;
    };

    function scaleObject(svgElement, scale) {
        var bbox = getElementBBoxWithTransform(svgElement);
        if (bbox.width * scale < 1 || bbox.height * scale < 1) {
            return false;
        }
        return sizeSvgObjectNoTransform(svgElement, bbox.width * scale, bbox.height * scale);
    }
    _this.scaleObject = scaleObject;


    // Turns all path commands into absolute coordinates (in-place). Origin: Phrogz,
    // http://stackoverflow.com/questions/9677885/convert-svg-path-to-absolute-commands
    _this.absolutizePath = function (path) {
        var segs = path.pathSegList,
            len = segs.numberOfItems,
            M = 'createSVGPathSegMovetoAbs',
            L = 'createSVGPathSegLinetoAbs',
            H = 'createSVGPathSegLinetoHorizontalAbs',
            V = 'createSVGPathSegLinetoVerticalAbs',
            C = 'createSVGPathSegCurvetoCubicAbs',
            S = 'createSVGPathSegCurvetoCubicSmoothAbs',
            Q = 'createSVGPathSegCurvetoQuadraticAbs',
            T = 'createSVGPathSegCurvetoQuadraticSmoothAbs',
            A = 'createSVGPathSegArcAbs',
            seg, abs, x, y, i, c, x0, y0, x1, y1, x2, y2;
        for (x = y = i = 0; i < len; i++) {
            seg = segs.getItem(i);
            c = seg.pathSegTypeAsLetter;
            abs = undefined;
            if (/[MLHVCSQTA]/.test(c)) {
                // already absolute; just update current coord
                if ('x' in seg) {
                    x = seg.x;
                }
                if ('y' in seg) {
                    y = seg.y;
                }
            } else {
                if ('x1' in seg) {
                    x1 = x + seg.x1;
                }
                if ('x2' in seg) {
                    x2 = x + seg.x2;
                }
                if ('y1' in seg) {
                    y1 = y + seg.y1;
                }
                if ('y2' in seg) {
                    y2 = y + seg.y2;
                }
                if ('x' in seg) {
                    x += seg.x;
                }
                if ('y' in seg) {
                    y += seg.y;
                }
                switch (c) {
                case 'm':
                    abs = path[M](x, y);
                    break;
                case 'l':
                    abs = path[L](x, y);
                    break;
                case 'h':
                    abs = path[H](x);
                    break;
                case 'v':
                    abs = path[V](y);
                    break;
                case 'c':
                    abs = path[C](x, y, x1, y1, x2, y2);
                    break;
                case 's':
                    abs = path[S](x, y, x2, y2);
                    break;
                case 'q':
                    abs = path[Q](x, y, x1, y1);
                    break;
                case 't':
                    abs = path[T](x, y);
                    break;
                case 'a':
                    abs = path[A](x, y, seg.r1, seg.r2, seg.angle,
                    seg.largeArcFlag, seg.sweepFlag);
                    break;
                case 'z':
                case 'Z':
                    x = x0;
                    y = y0;
                    break;
                }
                if (abs) {
                    segs.replaceItem(abs, i);
                }
            }
            // Record the start of a subpath
            if (c == 'M' || c == 'm') {
                x0 = x;
                y0 = y;
            }
        }
    };

    _this.svgDiliation = (elem, pixels) => {
        console.assert(elem.tagName.toLowerCase() === 'path');
    };


    // Takes any arbitrary element sub-tree(s) and converts it/them into an array of
    // <path> elements suitable for appending on `root` (the <svg> root, by default)
    // Original implementation by Phrogz -- http://phrogz.net/SVG/transformations.js
    _this.pathify = function (elem, root) {
        var node = 'nodeType' in elem ? elem : elem[0],
            doc = node.ownerDocument,
            svg = node.ownerSVGElement,
            svg_ns = svg.getAttribute('xmlns'),
            normal = (root || svg).getCTM().inverse(),
            // compensation for root's scaling
            matrix = normal.multiply(node.getCTM()),
            // transform, relative to svg root
            output = [],
            makers = {
                path: function() {
                    path = elem.getAttribute('d');
                },
                line: line,
                rect: rect,
                circle: circle,
                ellipse: ellipse,
                polygon: polygon,
                polyline: polygon
            }, i, len, path, make, transform;

        if (elem.tagName == 'g' || 'function' === typeof elem.push) {
            for (i = 0; node = (elem.childNodes || elem)[i]; i++) {
                if (node.nodeType == 1) {
                    output = output.concat(pathify(node, root));
                }
            }
        } else {
            const pathElem = doc.createElementNS(svg_ns, 'path');
            make = makers[elem.tagName];
            if (make) make();
            else path = null;
            if (path) {

                transform = svg.createSVGTransform();
                transform.setMatrix(matrix);
                // path.transform.baseVal.initialize(transform);

                // temp: set its reference environment so applyTransforms knows what to do
                // elem.parentNode.appendChild(path);
                const newPathObject = SvgPath(path).abs().unarc();

                // Apply transform
                if (pathElem.hasAttribute('transform')) {    
                    newPathObject.transform(pathElem.getAttribute('transform'));
                    pathElem.removeAttribute('transform');
                }
                pathElem.setAttribute('d', newPathObject.toString());

                // path.setAttribute('d', applyTransforms(path));
                // path.removeAttribute('transform');
                // elem.parentNode.removeChild(path);

                // copyPresentation(elem, path);
                output.push(pathElem);
            }
        }
        return output;

        function line() {
            var x1 = +elem.getAttribute('x1'),
                y1 = +elem.getAttribute('y1'),
                x2 = +elem.getAttribute('x2'),
                y2 = +elem.getAttribute('y2');
            path = 'M' + x1 + ',' + y1 + 'L' + x2 + ',' + y2;
        }

        function rect() {
            var x = +elem.getAttribute('x'),
                y = +elem.getAttribute('y'),
                w = +elem.getAttribute('width'),
                h = +elem.getAttribute('height'),
                rx = Math.min(w / 2, +elem.getAttribute('rx') || 0),
                ry = Math.min(h / 2, +elem.getAttribute('ry') || 0),
                r = rx || ry,
                arc_to;
            if (rx && !elem.hasAttribute('ry')) ry = rx;
            else if (ry && !elem.hasAttribute('rx')) rx = ry;
            arc_to = 'A' + rx + ',' + ry + ',0,0,' + (rx * ry < 0 ? 0 : 1) + ',';
            path = 'M' + (x + rx) + ',' + y + 'H' + (x + w - rx) + (r ? arc_to + (x + w) + ',' + (y + ry) : '') + 'V' + (y + h - ry) + (r ? arc_to + (x + w - rx) + ',' + (y + h) : '') + 'H' + (x + rx) + (r ? arc_to + x + ',' + (y + h - ry) : '') + 'V' + (y + ry) + (r ? arc_to + (x + rx) + ',' + y : '');
        }

        function circle() {
            var cx = +elem.getAttribute('cx'),
                cy = +elem.getAttribute('cy'),
                r = +elem.getAttribute('r'),
                y0 = cy - r,
                y1 = cy + r;
            path = 'M' + cx + ',' + y0 + 'A' + [r, r, 0, 0, 0, cx, y1, r, r, 0, 0, 0, cx, y0].join(',');
        }

        function ellipse() {
            var cx = +elem.getAttribute('cx'),
                cy = +elem.getAttribute('cy'),
                rx = +elem.getAttribute('rx'),
                ry = +elem.getAttribute('ry'),
                y0 = cy - ry,
                y1 = cy + ry;
            path = 'M' + cx + ',' + y0 + 'A' + [rx, ry, 0, 0, 0, cx, y1, rx, ry, 0, 0, 0, cx, y0].join(',');
        }

        function polygon() {
            for (var i = 0, l = [], pts = elem.points, p; i < elem.points.length; i++) {
                p = pts.getItem(i);
                l[i] = p.x + ',' + p.y;
            }
            path = 'M' + l.shift() + 'L' + l.join(' ') + ((elem.tagName.toLowerCase() === 'polygon') ? 'Z' : '');
        }
    };

    _this.getElementOutline = function (elem) {
        var bboxList = [];
        switch (elem.nodeName) {
            case 'g':
                bboxList = Array.from(elem.childNodes)
                    .map(this.transformedBoundingBox);
                break;
            default:
                bboxList = [this.transformedBoundingBox(elem)];
        }
    };

    function bboxOfMany(bboxSet) {
        var x = Math.min.apply(null, bboxSet
            .map(function(rect){
                return rect.x;
            }));
        var width = Math.max.apply(null, bboxSet.map(function(rect){
                    return rect.x + rect.width;
                })) - x;
        var y = Math.min.apply(null, bboxSet
            .map(function(rect){
                return rect.y;
            }));
        var height = Math.max.apply(null, bboxSet.map(function(rect){
                    return rect.y + rect.height;
                })) - y;
        return {
            'x': x,
            'y': y,
            'width': width,
            'height': height
        };
    }

    function bboxOfManyBbox(bboxSet) {
        bboxSet.filter(function(i){return i;});
        if (bboxSet.length === 0) {
            return null;
        }

        var xCoordinates = bboxSet
            .map(function(rect){
                return rect.x;
            })
            .concat(
                bboxSet.map(function(rect){
                    return rect.x + rect.width;
                })
            )
            .filter(function(i){return i;});
        var yCoordinates = bboxSet
            .map(function(rect){
                return rect.y;
            })
            .concat(
                bboxSet.map(function(rect){
                    return rect.y + rect.height;
                })
            )
            .filter(function(i){return i;});

        if (xCoordinates.length === 0 || yCoordinates.length === 0) {
            return null;
        }

        var x = Math.min.apply(null, xCoordinates);
        var width = Math.max.apply(null, xCoordinates) - x;
        var y = Math.min.apply(null, yCoordinates);
        var height = Math.max.apply(null, yCoordinates) - y;
        return {
            'x': x,
            'y': y,
            'width': width,
            'height': height
        };
    }
    _this.bboxOfManyBbox = bboxOfMany;

    function getBoundingBoxes(el, bb, onlyBboxes, childNodes){
        bb = bb || [];
        if (!el.getBBox) {
            return null;
        }

        var svg = el.ownerSVGElement;

        if (!svg) {
            return null;
        }

        var referenceElement = el;
        referenceElement = el.correspondingUseElement || referenceElement;
        if (el.href && el.href.baseVal) {
            referenceElement = document.getElementById(el.href.baseVal.substring(1)) || referenceElement;
        }

        var bbox = {};
        if (referenceElement.nodeName.toLowerCase() === 'path') {
            bbox = _this.getPathBBox(referenceElement);
        } else if (referenceElement.nodeName.toLowerCase() === 'g' && childNodes) {
            Array.from(referenceElement.childNodes)
                // .filter(functio/n(e){return e.nodeType === 1;})
                .filter(function(e){return e.getBBox;})
                // .map(function(e){console.log(e, e.nodeType);
                //     e.ownerSVGElement;e.getBBox;e.getBBox();})
                .forEach(function(e) {
                    getBoundingBoxes(e, bb, onlyBboxes, false);
                });
        } else if (referenceElement.nodeName === 'text' && !el.textContent) {
            el.textContent = 'a';

            try {
                bbox = el.getBBox();
            } catch(e) {
                // Firefox 3.0.x plays badly here
            } finally {
                 bbox = bbox || {height: 0, width: 0, y: 0, x: 0};
            }

//            bb.push([el.getBBox(), el]);
            el.textContent = '';
        } else {
            var bbox = {};
            try {
                bbox = el.getBBox();
            } catch(e) {
                // Firefox 3.0.x plays badly here
            } finally {
                bbox = bbox || {height: 0, width: 0, y: 0, x: 0};
            }
//            bb.push([el.getBBox(), el]);
        }
        if (!bb.length) {
            var bbox = {};
            try {
                bbox = el.getBBox();
            } catch(e) {
                // Firefox 3.0.x plays badly here
            } finally {
                 bbox = bbox || {height: 0, width: 0, y: 0, x: 0};
            }
//            bb.push([el.getBBox(), el]);
        }

        bbox.y = bbox.y || parseFloat(el.getAttribute('y')) || 0;

        bb.push([bbox, el]);


        return bb;
    }
    _this.transformRect = function (bb, matrix, svg){
        var updateBbox = {};
        if ('x' in bb && 'y' in bb && 'width' in bb && 'height' in bb) {

            // Create an array of all four points for the original bounding box
            var pts = [
                svg.createSVGPoint(), svg.createSVGPoint(),
                svg.createSVGPoint(), svg.createSVGPoint()
            ];
            pts[0].x=bb.x;          pts[0].y=bb.y;
            pts[1].x=bb.x+bb.width; pts[1].y=bb.y;
            pts[2].x=bb.x+bb.width; pts[2].y=bb.y+bb.height;
            pts[3].x=bb.x;          pts[3].y=bb.y+bb.height;


            // Transform each into the space of the parent,
            // and calculate the min/max points from that.
            var xMin=Infinity,xMax=-Infinity,yMin=Infinity,yMax=-Infinity;
            pts.forEach(function(pt){
                pt = pt.matrixTransform(matrix);
                xMin = Math.min(xMin,pt.x);
                xMax = Math.max(xMax,pt.x);
                yMin = Math.min(yMin,pt.y);
                yMax = Math.max(yMax,pt.y);
            });

            // Update the bounding box with the new values
            updateBbox.x = xMin | 0;
            updateBbox.width  = (xMax-xMin) | 0;
            updateBbox.y = yMin | 0;
            updateBbox.height = (yMax-yMin) | 0;
        } else if ('x1' in bb && 'y1' in bb && 'y2' in bb && 'y2' in bb) {
            var point1 = svg.createSVGPoint();
            var point2 = svg.createSVGPoint();
            point1.x=bb.x1;
            point1.y=bb.y1;
            point2.x=bb.x2;
            point2.y=bb.y2;

            point1 = point1.matrixTransform(matrix);
            point2 = point2.matrixTransform(matrix);

            updateBbox.x1 = point1.x;
            updateBbox.y1 = point1.y;
            updateBbox.x2 = point2.x;
            updateBbox.y2 = point2.y;
        } else {
            // console.log('Unknown shape', bb);
        }

        return updateBbox;
    };

    function getElementBBoxWithTransform(element) {
        var m = svgMatrixUntils.getElementMatrix(element ,element.parentNode);
        return _this.transformRect(element.getBBox(), m, element.ownerSVGElement);
    }

    _this.getElementBBoxWithTransform = getElementBBoxWithTransform;

    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(!Element):!Object}
     */
    _this.transformedBoundingShapes = function (el, onlyBboxes, childNodes){
        if (el.nodeName === 'svg') {
            var bbox = el.viewBox.baseVal ||
                {
                    'x': 0,
                    'y': 0,
                    'width': el.getAttribute('width') || el.getAttribute('viewBox'),
                };

            return bbox;
        }

        if (!el.getBBox) {
            return null;
        }

        var svg = el.ownerSVGElement;

        if (!svg || !el.getBBox) {
            return null;
        }
        var bb = getBoundingBoxes(el, [], onlyBboxes, childNodes);

        var m = svgMatrixUntils.getElementMatrix(el ,el.parentNode.parentNode);
        var transformBboxes = bb
            .map(function(bbox) {
                return _this.transformRect(bbox[0], m, svg);
            });
        // console.assert(transformBboxes.length);
        // var bb = el.getBBox();

        // Create an array of all four points for the original bounding box

        return transformBboxes;
    };

    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(!Element):!Object}
     */
    _this.transformedBoundingBox = function (el, relativeEle){
        if (el.nodeName === 'svg') {
            var bbox = el.viewBox.baseVal ||
                {
                    'x': 0,
                    'y': 0,
                    'width': el.getAttribute('width') || el.getAttribute('viewBox'),
                };

            return bbox;
        }

        if (!el.getBBox) {
            return null;
        }

        var svg = el.ownerSVGElement;

        if (!svg || !el.getBBox) {
            return null;
        }

        relativeEle = relativeEle || el.parentNode;
        var m   = svgMatrixUntils.getElementMatrix(el ,relativeEle);

        var bbox = {};
        try {
            bbox = el.getBBox();
        } catch(e) {
            // Firefox 3.0.x plays badly here
        } finally {
            bbox = bbox || {height: 0, width: 0, y: 0, x: 0} ;
        }

        if ((el.nodeName === 'text' || el.nodeName === 'tspan') && bbox.height !== 0) {
            bbox.height = Math.max(bbox.height, parseFloat(getComputedStyle(el).lineHeight.replace('px', '')));
        }

        if (bbox.width || bbox.height) {
            bbox.y = bbox.y || parseFloat(el.getAttribute('y')) || 0;
        }

        var transformBbox = _this.transformRect(bbox, m, svg);

        return transformBbox;
    };

    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(Array.<Element>):!Object}
     */
    _this.bboxOfGroup = function(arrayElements) {
        if (arrayElements.length === 1) {
            return arrayElements[0];
        }

        var bbox = {};

        var left = Infinity;
        var right = -Infinity;
        var top = Infinity;
        var bottom = -Infinity;
        arrayElements.forEach(function (element) {
            var transformedBbox = _this.transformedBoundingBox(element);

            left = Math.min(left ,transformedBbox.x);
            right = Math.max(right, transformedBbox.x + transformedBbox.width);
            top = Math.min(top ,transformedBbox.y);
            bottom = Math.max(bottom, transformedBbox.y + transformedBbox.height);
        });

        bbox.x = left;
        bbox.y = top;
        bbox.width = right - left;
        bbox.height = bottom - top;

        return bbox;
    };


    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(!Element, number, number):!Object}
     */
    _this.clientToSVGCoords = function(svgRoot, x, y){
        var pt = svgRoot.createSVGPoint();
        var newScale = svgRoot.currentScale;
        var translation = svgRoot.currentTranslate;
        pt.x = (x - translation.x)/newScale;
        pt.y = (y - translation.y)/newScale;

        var zoom = parseInt(svgRoot.style.zoom, 10) || 1;
        pt.x /= zoom;
        pt.y /= zoom;

        var ctm = svgRoot.getScreenCTM();
        if (ctm.inverse()) {
            pt = pt.matrixTransform(ctm.inverse());
        }
        return pt;
    };

    _this.svgStringToDOMElement = function(xmlString){
        xmlString = xmlString.replace(/( href)/gm," xlink:href");

        var newDoc = new DOMParser().parseFromString("<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>" + xmlString + "</svg>", "text/xml");
        // var newDoc = new DOMParser().parseFromString(xmlString, "text/xml");
        if(newDoc.documentElement && newDoc.documentElement.nodeName.toLowerCase() !== 'html'){
            newDoc = document.adoptNode(newDoc.documentElement);
        }


        Array.from(newDoc.querySelectorAll('image')).forEach(function(imageEle) {
            var hrefAttributes = [imageEle.getAttributeNS(xlinkns, 'href'), imageEle.getAttribute('href'), imageEle.getAttribute('xlink:href')];

            var imageData = hrefAttributes.filter(function (e){
                return e && e !== "null" && e !== "";
            })[0];

            imageEle.removeAttributeNS(xlinkns, 'href');
            imageEle.removeAttribute('href');
            imageEle.removeAttribute('xlink:href');
            imageEle.setAttributeNS(xlinkns, 'xlink:href', imageData);
        });

        return newDoc.firstChild;
    };

    /**
     * @function
     * @memberof svgUtils
     * @public
     * @type {function(Object, string):!Element}
     */
    _this.makeElmentFromMimeType = function (data, mimeType) {
        var newElement;
        switch(mimeType){
            case 'image/png':
            case 'image/jpeg':
            case 'image/tiff':
            case 'image/gif':
            case 'image/svg+xml':
                newElement = document.createElementNS(_this.svgns, 'image');
                newElement.setAttributeNS(_this.xlinkns, 'xlink:href', data);
                newElement.setAttributeNS(null, 'width', "10%");
                newElement.setAttributeNS(null, 'height', "10%");
                newElement.setAttributeNS(null, 'x', "0");
                newElement.setAttributeNS(null, 'y', "0");
                break;
            case "text/plain":
                break;
            case "text/xml":
                newElement = _this.svgStringToDOMElement(data);
                break;
        }

        return newElement;
    };

    const SVG_BASE64_PREFIX = 'data:image/svg+xml;base64,';

    _this.svgImageToGroup = function (imageEle) {

        function processSvg(svgDom) {
            const svgGroup = document.createElementNS('http://www.w3.org/2000/svg', "g");

            const x = imageEle.getAttribute('x') || 0;
            const y = imageEle.getAttribute('y') || 0;

            const viewBox = svgDom.getAttribute('viewBox') || svgDom.getAttribute('viewbox');
            if (viewBox) {
                const [viewBoxX, viewBoxY, viewBoxWidth, viewBoxHeight] = viewBox.split(' ').map(s => parseFloat(s));
                const width = parseFloat(svgDom.getAttribute('width') || viewBoxWidth);
                const height = parseFloat(svgDom.getAttribute('height') || viewBoxHeight);
                svgGroup.setAttribute('transform', `${imageEle.hasAttribute('transform')?imageEle.getAttribute('transform') + ' ':''}translate(${imageEle.getAttribute('x') + viewBoxX} ${imageEle.getAttribute('y') + viewBoxY}) scale(${width / viewBoxWidth} ${height / viewBoxHeight})`)
            } else {
                svgGroup.setAttribute('transform', `${imageEle.hasAttribute('transform')?imageEle.getAttribute('transform') + ' ':''}translate(${imageEle.getAttribute('x')} ${imageEle.getAttribute('y')})`)
            }

            $(svgGroup).append($(svgDom).children());

            return svgGroup;
        }

        return new Promise(function(resolve, reject) {
            if ($(imageEle).attr("xlink:href").indexOf('data:image/svg') !== -1) {
                const svgDom = $(atob($(imageEle).attr("xlink:href").replace(SVG_BASE64_PREFIX, ''))).filter('svg')[0];

                const groupElem = processSvg(svgDom);

                Promise.all([...groupElem.querySelectorAll('image')].map(svgElem => {
                        return new Promise(function(resolve2, reject2) {
                            _this.svgImageToGroup(svgElem).then(g => {
                                svgElem.parentNode.appendChild(g);
                                svgElem.remove();
                                resolve2();
                            }).catch(reject2);
                        })
                    }))
                    .then(() => resolve(groupElem))
                    .catch(reject);
            } else {
                const aElem = document.createElement('a')
                aElem.href = $(imageEle).attr("xlink:href");
                aElem.host = location.host;
                aElem.protocol = 'https:';

                $.get(aElem.href, [], function (svgDom) {
                    const groupElem = processSvg(svgDom.nodeName.toLowerCase() === 'svg'?svgDom:svgDom.querySelector('svg'));

                    Promise.all([...groupElem.querySelectorAll('image')].map(imageElem => {
                            return new Promise(function(resolve2, reject2) {
                                _this.svgImageToGroup(imageElem).then(g => {
                                    imageElem.parentNode.appendChild(g);
                                    imageElem.remove();
                                    resolve2();
                                }).catch(reject2);
                            })
                        }))
                        .then(() => resolve(groupElem))
                        .catch(reject);
                });
            }
        });
    };


    return Object.freeze(_this);
}


(function(window) {
    "use strict";
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( [
                'svg-functions/dom-utils',
                'svg-functions/math-utils',
                'svg-functions/svg-matrix-utils'
            ],
            SVGUtilsDefinition );
    } else {
        // browser global
        window.svgFuncs = SVGUtilsDefinition(window.DomUtils, window.MathUtils, window.svgMatrixUntils, window.SvgPath);
    }
})(window);

(function (rivets, _, $) {
	'use strict';

    function getInfoLink(bitcoinAddress, isTestNet) {
        return 'https://' + (isTestNet?'t':'') + 'btc.blockr.io/address/info/' + bitcoinAddress;
    }

	function lowercaseToday(string) {
	    return string.replace('Today', 'today').replace('Last', 'last').replace('Tomorrow', 'tomorrow').replace('Yesterday', 'yesterday').replace(' AM', 'am').replace(' PM', 'pm');
	}


	rivets.binders.tclick = {
	    'function': true,
	    priority: 1000,
	    unbind: function(el) {
			if (this.handler) {
			//unbind
			}
	    },
	    routine: function(el, value) {
			if (this.handler) {
			//unbind
			}
			$(el).tclick(value);
	    }
	};

	rivets.binders.toggle = {
		bind: function(el) {
			var adapter = this.config.adapters[this.key.interface];
			var model = this.model;
			var keypath = this.keypath;

			this.callback = function() {
				var value = adapter.read(model, keypath);
				adapter.publish(model, keypath, !value);
			};

			$(el).on('click', this.callback);
		},

		unbind: function(el) {
			$(el).off('click', this.callback);
		},

		routine: function(el, value) {
			$(el)[value ? 'addClass' : 'removeClass']('enabled');
		}
	};

	rivets.binders.xlinkhref = function(el, value) {
		el.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', value);
	};


	rivets.formatters.hasLength = function(value) {
		return value.length > 0;
	};



    function noExponents(numberValue){
        var data= String(numberValue).split(/[eE]/);
        if(data.length== 1) return data[0]; 

        var  z= '', sign= numberValue<0? '-':'',
        str= data[0].replace('.', ''),
        mag= Number(data[1])+ 1;

        if(mag<0){
            z= sign + '0.';
            while(mag++) z += '0';
            return z + str.replace(/^\-/,'');
        }
        mag -= str.length;  
        while(mag--) z += '0';
        return str + z;
    }

	rivets.formatters.arrayIndex = function(value, num) {
		return value[parseInt(num, 10)];
	};
	rivets.formatters.first = function(value, num) {
		return value.slice(0, parseInt(num, 10));
	};


    function sigFigs(n, sig) {
    	if (n === 0) {
    		return 0;
    	}
        var mult = Math.pow(10,
            sig - Math.floor(Math.log(n) / Math.LN10) - 1);
        return Math.round(n * mult) / mult;
    }

	rivets.formatters.sigFigs = function(inputValue, figs) {
		return sigFigs(inputValue, parseInt(figs, 10));
	};
	rivets.formatters.numToStr = function(inputValue) {
		return Number(inputValue).toLocaleString('en');
	};

	rivets.formatters.toMiles = function(inputValue) {
		return inputValue * 0.621371;
	};

	rivets.formatters.greaterThanOne = function(value) {
		return value > 1;
	};
	rivets.formatters.prefix = function(value, str) {
		return value?(str + value.toString()):str;
	};
	rivets.formatters.postfix = function(value, str) {
		return value?(value.toString() + str):'';
	};
	rivets.formatters.firstLetterUpper = function(value) {
		return value?(value.slice(0, 1).toUpperCase() + value.slice(1)):value;
	};
	rivets.formatters.lessThanSix = function(value) {
		return value < 6;
	};
	rivets.formatters.isDefined = function(value) {
		return value !== undefined;
	};
	rivets.formatters.toPrecision = function(value) {
		return value.toPrecision?noExponents(value.toPrecision(2)):value;
	};

	rivets.formatters.not = function(value) {
		return !value;
	};
	rivets.formatters.numOfKeys = function(value) {
		return Object.keys(value).length;
	};
	rivets.formatters.toKeys = function(value) {
		return Object.keys(value);
	};
	rivets.formatters.toBlockchainLink = function(value) {
		return getInfoLink(value, true);
	};
	
	rivets.formatters.removeLast = function(value) {
		return value.slice(0, value.length - 1);
	};
	rivets.formatters.getLast = function(value) {
		return value[value.length - 1];
	};

	rivets.formatters.reverse = function(value) {
		return value.slice().reverse();
	};
	



	rivets.formatters.join = function(value, joinString) {
		console.assert(value, value);
	  	return value?value.join(joinString):'';
	};

	function isFunctionA(v) {
		return typeof(v) === "function";
	}
	rivets.formatters.toProp = function(value, property) {
		if (typeof(value) === 'undefined') {
			console.error(value, property);
		} else if (isFunctionA(value[property])) {
			return value[property]();
		} else {
			return value[property];
		}
	};
	rivets.formatters.equal = function(value, v1) {
		return value === v1;
	};

	rivets.formatters.drop = function(value, v1) {
		return value.slice(v1, value.length);
	};


	rivets.formatters.greaterThan = function(value, comp1) {
		return value > parseFloat(comp1);
	};
	rivets.formatters.toLength = function(value) {
		return value.length;
	};

	rivets.formatters.stringify = function(value) {
		return JSON.stringify(value, null, 4);
	};
	var ids = {};

	rivets.formatters.idToMap = function(value) {
		if (value.length > 10) {
			if (!(value in ids)) {
				ids[value] = 'Ticket ' + (Object.keys(ids).length + 1).toString();
			}
			return ids[value];
		} else {
			return value;
		}
	};

	rivets.binders.visibility = function(el, value) {
		 el.style.visibility = value?'':'hidden';
	};
	rivets.binders.hidevisibility = function(el, value) {
		 el.style.visibility = value?'hidden':'';
	};

	rivets.binders.hideanimate = function(el, value) {
		 // el.style.display = value?'none':'';
		 el.style.transition = 'max-height 0.3s';
		 el.style.height = value?'0':'';
		 el.style.minHeight = value?'auto':'';
		 el.style.maxHeight = value?'0':'2000px';
		 el.style.visibility = value?'hidden':'';
	};

	rivets.binders.color = function(el, value) {
		 el.style.color = value?value:'';
	};

	rivets.binders.backgroundcolor = function(el, value) {
		 el.style.backgroundColor = value?value:'';
	};

	rivets.binders.readonly = function(el, value) {
		if (value) {
			el.setAttribute('readonly', true);
		} else {
			el.removeAttribute('readonly');
		}
	};

	rivets.binders.nopointer = function(el, value) {
		if (value) {
			el.style.pointerEvents = 'none';
			el.style.opacity = 0.5;
		} else {
			el.style.pointerEvents = '';
			el.style.opacity = '';
		}
	};

	function changedInput() {

	}

	rivets.binders.setchecked = {
		priority: 3000,
		bind: function(el) {
			var _this = this;
			el.addEventListener('click', function() {
				_this.observer.setValue(true);
			});
		},
		unbind: function(el) {
			// el.removeEventListener('change', changedInput);
		},
		routine: function(el, value) {
			el.checked = value;
		}
	};

	rivets.binders.setnotchecked = {
		priority: 3000,
		bind: function(el) {
			var _this = this;
			el.addEventListener('click', function() {
				_this.observer.setValue(false);
			});
		},
		unbind: function(el) {
			// el.removeEventListener('change', changedInput);
		},
		routine: function(el, value) {
			el.checked = !value;
		}
	};

	rivets.binders.valueaspounds = {
		priority: 3000,
		bind: function(el) {
			var _this = this;
			el.addEventListener('input', function() {
				_this.observer.setValue((el.value * 2.2046).toString()); // TODO remove toString
			});
		},
		unbind: function(el) {
			// el.removeEventListener('change', changedInput);
		},
		routine: function(el, value) {
			return el.setAttribute('value', Math.round((value / 2.2046) * 100) / 100);
		}
	};

	rivets.adapters[':'] = {
		observe: function(obj, keypath, callback) {
			obj.watch(function() {
				callback(obj[keypath]);
			});
		},
		unobserve: function(obj, keypath, callback) {
			obj.unwatch(callback);
		},
		get: function(obj, keypath) {
			return obj[keypath];
		},
		set: function(obj, keypath, value) {
			// obj.attr(keypath, value);
		}
	};
})(rivets, _, jQuery);
/**
 * This module adds drag and drop events to a DOM element. A callback method is
 * called on user drops. The module happens drops to child elements and converts
 * file drops to base64 and calls the callback function for each data dropped. A
 * class is added to DOM element on drag over so that styles can be applied.
 * 
 * @file
 * @copyright Virtual Console, LLC - All Rights Reserved
 * @license Unauthorized copying of this file, via any medium is strictly prohibited
 * @ignore Proprietary and confidential
 * @author Ben McDonald [mcdonald.ben@gmail.com]
 * @description Contains module to attach drop events to a DOM Element
*/

function DomDropEventDefinition() {
    'use strict';

    /** @type {function(!Object):boolean} */
    function handleDragOver(e) {
        e.preventDefault(); // Necessary. Allows us to drop.
        e.dataTransfer.dropEffect = 'copy';  // See the section on the DataTransfer object.

        return false;
    }

    /** @type {function(!Object):boolean} */
    function handleDragEnter(e) {
        // this / e.target is the current hover target.
        // this.classList.add('drag-over');
        // console.log('enter drop', e.target);
    }

    /** @type {function(!Object):boolean} */
    function handleDragLeave(e) {
       // Get the location on screen of the element.
       // var rect = this.getBoundingClientRect();

       //  if (e.x >= (rect.left + rect.width) || e.x <= rect.left
       //      || e.y >= (rect.top + rect.height) || e.y <= rect.top) {
       //  }
        e.stopPropagation(); // Stops some browsers from redirecting.
        e.preventDefault();
        this.classList.remove('drag-over');  // this / e.target is previous target element.
        // console.log('Leave drop', e.target);
    }

    /** @type {function(!Object):boolean} */
    function handleDragEnd(e) {
        e.stopPropagation(); // Stops some browsers from redirecting.
        e.preventDefault();
        this.classList.remove('drag-over');
    }

    function handleFiles(files, callback) {
        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            var imageType = /image.*/;

            if (!file.type.match(imageType)) {
                continue;
            }

            var img = document.createElement('img');
            img.classList.add('obj');
            img.file = file;
            preview.appendChild(img); // Assuming that "preview" is a the div output where the content will be displayed.

            var reader = new FileReader();
            reader.onload = (function(aImg) { return function(e) { aImg.src = e.target.result; }; })(img);
            reader.readAsDataURL(file);
        }
    }

    function textAfterWord(s, word) {
        return s.substring(s.indexOf(word) + word.length);
    }

    function processDataTypes(e, dropCallback) {
        e.stopPropagation(); // Stops some browsers from redirecting.
        e.preventDefault();

        var files = e.dataTransfer.files;
        var f;
        for (var i = 0; f = files[i]; i++) {
            var reader = new FileReader();
            var fileType = f.type;

            // Closure to capture the file information.
            reader.onload = (function() {
                return function(fileEvent) {
                    /** @type {string} */
                    var fileText = fileEvent.target.result.indexOf('base64,')===-1?
                            fileEvent.target.result:
                            atob(textAfterWord(fileEvent.target.result, 'base64,'));
                    console.log('DROP', fileText, fileEvent, e);
                    dropCallback(e.target, fileText, fileType, e, fileEvent.target.result);
                };
            })(f);

            // Read in the image file as a data URL.
            reader.readAsDataURL(f);
        }

        Array.from(e.dataTransfer.types).forEach(function (type) {
            console.log('DROP', e.dataTransfer.getData(type), type, e);
            dropCallback(e.target, e.dataTransfer.getData(type), type, e);
        });

        return false;
    }

    /**
     * @type {function(!Element, function):!Object}
     */
    return function (domElement, dropCallback) {
        /** @type {function(!Object):boolean} */
        function handleDrop(e) {
            domElement.classList.remove('drag-over');
            e.stopPropagation(); // Stops some browsers from redirecting.
            e.preventDefault();

            var files = e.dataTransfer.files;
            var f;
            for (var i = 0; f = files[i]; i++) {
                var reader = new FileReader();
                var fileType = f.type;

                // Closure to capture the file information.
                reader.onload = (function() {
                    return function(fileEvent) {
                        /** @type {string} */
                        var fileText = fileEvent.target.result.indexOf('mage/svg+xml;base64,')===-1?
                                fileEvent.target.result:
                                atob(textAfterWord(fileEvent.target.result, 'base64,'));
                        console.log('DROP', fileText, fileEvent, e);
                        dropCallback(e.target, fileText, fileType, e, fileEvent.target.result);
                    };
                })(f);

                // Read in the image file as a data URL.
                reader.readAsDataURL(f);
            }

            // Array.from(e.dataTransfer.types).forEach(function (type) {
            //     console.log('DROP', e.dataTransfer.getData(type), type, e);
            //     dropCallback(e.target, e.dataTransfer.getData(type), type, e, e.dataTransfer.getData(type));
            // });

            return false;
        }

        domElement.addEventListener('dragenter', handleDragEnter, true);
        domElement.addEventListener('dragover', handleDragOver, true);
        domElement.addEventListener('dragleave', handleDragLeave, true);
        domElement.addEventListener('dragend', handleDragLeave, true);
        domElement.addEventListener('drop', handleDrop, true);

        return function () {
            domElement.removeEventListener('dragenter', handleDragEnter, true);
            domElement.removeEventListener('dragover', handleDragOver, true);
            domElement.removeEventListener('dragleave', handleDragLeave, true);
            domElement.removeEventListener('dragend', handleDragLeave, true);
            domElement.removeEventListener('drop', handleDrop, true);
            domElement = null;
        };
    };
}

(function(window) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        // AMD
        define([], DomDropEventDefinition);
    } else {
        // browser global
        window.domDropEvent = DomDropEventDefinition();

    }
})(window);




window.pathTracerFeature = (function (CanvasController, svgMatrixUntils, $, SvgPath, pathArea, domDropEvent) {
	/*jshint validthis:true,newcap:false */
	'use strict';

	console.assert(typeof(CanvasController) === 'function');
	console.assert(typeof(svgMatrixUntils) === 'object');
	console.assert(typeof($) === 'function');
	console.assert(typeof(SvgPath) === 'function');
	console.assert(typeof(pathArea) === 'function');

	return function(isIE10, hideOverLay, showOverLay, removeBase64Prefix, svgMarkupTextToBase64Image, dropAreaElem, toUnit, global) {
		console.assert(typeof(isIE10) === 'function');
		console.assert(typeof(hideOverLay) === 'function');
		console.assert(typeof(showOverLay) === 'function');
		console.assert(typeof(removeBase64Prefix) === 'function');
		console.assert(typeof(svgMarkupTextToBase64Image) === 'function');
		console.assert(dropAreaElem.nodeName.toUpperCase() === 'DIV');
		console.assert(typeof(toUnit) === 'function');

		const TRACER_BASE_URL = 'https://cases-by-source.crunchgrowth.com:8443';
		// TRACER_BASE_URL = 'https://localhost:8443';
		const TRACER_PATH = '/trace';
		let currentPathEditor;
		let svgElem;

		const _this = {
			uploadStep: true,
			pathEditStep: false,
			measuringStep: false,
			tracingStep: false,
			updateWidth: function () {
				_this.width = '2';
			},
			width: '1',
		};

		function reinitPathEditor() {
			if (currentPathEditor) {
				currentPathEditor.destroy();
				currentPathEditor = null;
			}

			if (svgElem) {
				svgElem.remove();
				svgElem = undefined;
			}

			_this.imageData = undefined;
		}

		function measuringStep() {
			if (currentPathEditor) {
				currentPathEditor.destroy();
				currentPathEditor = null;
			}

			svgElem.style.backgroundImage = '';
			var pathElem = svgElem.querySelector('path');

			// TODO check that there is a path length otherwise uploadStep;

			var bbox = svgMatrixUntils.getBbox(pathElem, null, true);
			svgElem.width.baseVal.value = bbox.width;
			svgElem.height.baseVal.value = bbox.height;

		
	        var newPathObject = SvgPath(pathElem.getAttribute('d')).translate(-bbox.x, -bbox.y);
	        pathElem.setAttribute('d', newPathObject.toString());

			_this.pathEditStep = false; 
			_this.measuringStep = true;
			_this.tracingStep = false;
			_this.uploadStep = false;
		}

		function uploadStep() {
			if (svgElem) {
				if(window.confirm('Do you want to clear the current upload and upload a new shape?')) {
					reinitPathEditor();

					_this.pathEditStep = false;
					_this.measuringStep = false;
					_this.tracingStep = false;
					_this.uploadStep = true;

				}
			} else {
				reinitPathEditor();

				_this.pathEditStep = false;
				_this.measuringStep = false;
				_this.tracingStep = false;
				_this.uploadStep = true;
			}
		}

		function tracingStep() {
			reinitPathEditor();

			if (isIE10()) {
				global.alert('Internet Explorer does not work for the path editor. Please user Google Chrome or another browser.');
			}

			_this.pathEditStep = false;
			_this.measuringStep = false;
			_this.tracingStep = true;
			_this.uploadStep = false;
		}

		function pathEditStep() {
			// if (currentPathEditor) {
			// 	currentPathEditor.destroy();
			// 	currentPathEditor = null;
			// }

			// if (svgElem) {
			// 	svgElem.remove();
			// 	svgElem = undefined;
			// }

			_this.imageData = undefined;
			_this.pathEditStep = true;
			_this.measuringStep = false;
			_this.tracingStep = false;
			_this.uploadStep = false;
		}


		// Converts image to canvas; returns new canvas element
		function convertImageToCanvas(imageDataArray) {
			var pngData = imageDataArray[0];
			// var imageWidth = imageDataArray[1];
			// var imageHeight = imageDataArray[2];

			var form = new FormData();
			form.append('file', removeBase64Prefix(pngData));
			tracingStep();

			fetch(TRACER_BASE_URL + TRACER_PATH, {
				method: 'post',
				body: form
			})
				.then(function(response) {
				    return response.text();
			  	})
			  	.then(function(urlToDownload) {
				  	console.log('Downloading from ' + urlToDownload);
					fetch(TRACER_BASE_URL + urlToDownload)
						.then(function(response) {
							return response.text();
						})
						.then(function(svgFileText) {
							svgElem = $(svgFileText).find('svg').andSelf().filter('svg')[0] || document.createElement('svg');
							svgElem.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
							svgElem.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
							svgElem.setAttribute('version', '1.1');
							svgElem.classList.add('auto-traced-svg');

							var pathElems = Array.from(svgElem.querySelectorAll('path'));
							var pathAreas = pathElems
								.filter(function(p) {
									return pathDoesNotTouchEdge(p.pathSegList._list || p.pathSegList, svgElem.width.baseVal.value, svgElem.height.baseVal.value);
								})
								.map(function(p) {
									return {
										'area': pathArea(p) / (svgElem.width.baseVal.value * svgElem.height.baseVal.value),
										'path': p
									};
								})
								.filter(function(d) {
									return d.area > 0.01;
								});

							pathAreas.sort(function(d1, d2) {
								return d1.area - d2.area;
							});

							console.log('pathAreas ', pathAreas);

							var longestPath = pathAreas.length>0?pathAreas[0].path:null;


							pathElems.forEach(function(p) {
								p.style.fill = '#4500EC';
								p.style.opacity = 0.5;
								if (p !== longestPath) {
									p.remove();
								}
							});

							dropAreaElem.querySelector('.path-editor').appendChild(svgElem);
							svgElem.style.backgroundImage = 'url(' + pngData + ')';
							svgElem.style.backgroundSize = '100% auto';

							if (svgElem.querySelectorAll('path').length === 0) {
					            var newPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
					            svgElem.appendChild(newPath);

					            global.alert('Image couldn\'t be traced. Please use the path tool to outline the object');
							}

							Array.from(svgElem.querySelectorAll('path')).forEach(function(p) {
								p.removeAttribute('style');
								p.removeAttribute('fill');
								p.removeAttribute('stroke');
							});
							currentPathEditor = CanvasController(svgElem, true);

							pathEditStep();
							console.log(longestPath);
						});
			  	})
			  	.catch(function(ex) {
				    console.log('parsing failed', ex);
					global.alert('Image tracing server error. Unable to trace file');
					uploadStep();
			  	});
		}

		function pathDoesNotTouchEdge(pathSegList, width, height) {
			var lineLength = pathSegList.length;
			return !Array.from(pathSegList)
				.some(function(p, i) {
						return p.x===0 || p.y===0 || p.x===width || p.y===height  ||
							(p.pathSegTypeAsLetter === 'M' && i!==0 && i !== lineLength);
					});
		}

		// Images types 'image/png', 'image/jpeg'
		function convertImage(documentElem, imageSrc, outputMineType, maxWidth, maxHeight, base64Callback) {
		    function imageLoaded() {
		        var canvas = documentElem.createElement('canvas');
				var scale = Math.min(maxHeight / image.height, maxWidth / image.width);

		        canvas.width = image.width * scale;
		        canvas.height = image.height * scale;
		        var ctx = canvas.getContext('2d');

		        ctx.drawImage(this, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height);

		        var imageData = ctx.getImageData(0, 0, image.width, image.height);
		        var data = imageData.data;

		        for(var i = 0; i < data.length; i += 4) {
		          var brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
		          // var brightness = (0.299 * data[i]) + (0.587 * data[i + 1]) + (0.114 * data[i + 2]);// CCIR 601
		          // red
		          data[i] = brightness;
		          // green
		          data[i + 1] = brightness;
		          // blue
		          data[i + 2] = brightness;
		        }

		        // overwrite original image
		        ctx.putImageData(imageData, 0, 0);
		        base64Callback([canvas.toDataURL(outputMineType), image.width, image.height]);
		    }

		    var image = new Image();
		    image.onload = imageLoaded;
		    image.src = imageSrc;
		}


		function uploadFile(fileData, fileType) {
			reinitPathEditor();

			if (fileType.indexOf('svg') === -1) {
				convertImage(document, fileData, 'image/png', dropAreaElem.scrollWidth,
									dropAreaElem.scrollHeight, convertImageToCanvas);
				tracingStep();
			} else {
				global.alert('Please upload an image of type JPEG or PNG.');
			}
		}


		function uploadFileInputEvent(e) {
			if (this.files && this.files.length) {
				var fileReader = new FileReader();
				var fileType = this.files[0].type;

				fileReader.onload = function(fileLoadedEvent)  {
					uploadFile(fileLoadedEvent.target.result, fileType);
				};

				fileReader.readAsDataURL(this.files[0]);
			}
			this.value = '';
		}

		domDropEvent(document.querySelector('body'), function(targetElem, fileText, fileType) {
			if (fileType.indexOf('image') !== -1) {
				uploadFile(fileText, fileType);
			} else {
				global.alert('Please upload an image of type JPEG or PNG.');
			}
		});

		document.querySelector('.file-upload-input')
			.addEventListener('change', uploadFileInputEvent);

		Object.assign(_this, {
			toMeasureStep: measuringStep,
			toPathEditStep: pathEditStep,
			toUploadStep: uploadStep,
			undo: () => currentPathEditor.undo(),
			redo: () => currentPathEditor.redo(),
			newPoint: () => currentPathEditor.newPoint(),
			deleteSelected: () => currentPathEditor.deleteSelected(),
			clearPath: () => currentPathEditor.clearPath(),
			openView: () => {
				showOverLay('.upload');

	    		uploadStep();    	
			}
		});


		return _this;
	};
})(window.CanvasController, window.svgMatrixUntils, window.jQuery, window.SvgPath, window.pathArea, window.domDropEvent);

(function () {
	'use strict';

    function runTest() {	

    }
    runTest();
})();




window.SvgOverlay = (function (_) {
	/*jshint validthis:true,newcap:false */
	'use strict';

	console.assert(typeof(_) === 'function');
	const attributesToCopy = ['x', 'y', 'width', 'height', 'viewBox'];
	return function(svgElem) {
		console.assert(svgElem.nodeName.toUpperCase() === 'SVG');


		 
		const svgOverlayElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		svgOverlayElem.setAttribute('class', 'svg-overlay');
		svgOverlayElem.setAttribute('style', 'pointer-events: none;');

		svgOverlayElem.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'defs'));
		
		attributesToCopy.forEach(attr => {
				svgOverlayElem.setAttribute(attr, svgElem.getAttribute(attr));
			});   
		svgOverlayElem.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
		svgElem.parentNode.insertBefore(svgOverlayElem, svgElem.nextSibling);


		// create an observer instance
		const observer = new MutationObserver(function(mutations) {
			mutations
				.filter(mutation => attributesToCopy.indexOf(mutation.attributeName) !== -1)
				.forEach(mutation => {
					svgOverlayElem.setAttribute(mutation.attributeName, svgElem.getAttribute(mutation.attributeName));
				});    
		});
		// configuration of the observer:
		const config = { attributes: true, childList: false, characterData: false };
		// pass in the svgElem node, as well as the observer options
		observer.observe(svgElem, config);
		 
		// later, you can stop observing

		function destroy() {
			observer.disconnect();
			svgOverlayElem.remove();
			svgElem = undefined;
		}

		function clear() {
			while (svgOverlayElem.firstChild) {
				svgOverlayElem.firstChild.remove();
			}
			svgOverlayElem.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'defs'));
		}

		return {destroy, clear, svgOverlayElem};
	};
})(window._);

(function () {
	'use strict';

    function runTest() {	

    }
    runTest();
})();

/* Copyright (C) Case by Source, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ben McDonald <ben@yaks.co.nz>
 */

'use strict';


var baseURL = '/editor/';
var serverURL = baseURL + 'server/';

function inchesToPixels(inches) {
	inches = parseFloat(inches);
	return inches * 96;
}

function pixelsToInches(pixels) {
	return pixels / 96;
}

function serializeXmlNode(xmlNode) {
    if (typeof window.XMLSerializer !== 'undefined') {
        return (new window.XMLSerializer()).serializeToString(xmlNode);
    } else if (typeof xmlNode.xml !== 'undefined') {
        return xmlNode.xml;
    }
    return '';
}

$('.toogle-view').click(function() {
	$('.extra-controls').toggle();

	// document.querySelector('.extra-controls').style.display==='none'?$('.toogle-view').text('˅'):$('.toogle-view').text('˄');
});


function toPixels(currentUnit) {
	currentUnit = parseFloat(currentUnit);
	if ($(document.body).hasClass('mm')) {
		return currentUnit * 96 / 25.4;
	} else {
		return currentUnit * 96;
	}
}

function qAll(cssSelector) {
	var htmlElements = document.querySelectorAll(cssSelector);

	var htmlElementArray = [];
	var arrayLength = htmlElements.length;
	for (var i = 0; i < arrayLength; ++i) {
	 	htmlElementArray.push(htmlElements[i]);
	}

	return htmlElementArray;
}
function q(cssSelector) {
	return document.querySelector(cssSelector);
}



function svgMarkupTextToBase64Image(markupText) {
	return 'data:image/svg+xml;base64,' + btoa(markupText);
}

var qc = _.memoize(q);
var qcAll = _.memoize(qAll);


function toUnit(pixels) {
	pixels = parseFloat(pixels);
	var units;
	if ($(document.body).hasClass('mm')) {
		units = pixels / 96 * 25.4;
	} else {
		units = pixels / 96;
	}
	units = Math.round(units * 1000) / 1000;

	return units;
}

function toCurrentUnit(data) {
  	return data?Math.round(toUnit(inchesToPixels(data)) * 10) / 10:'__';
}


function setNewImagePosition ($image, width, height) {
	$image.attr('width', width);
	$image.attr('height', height);
	$image.attr('x', (svgCanvas.getResolution().w / 2) - (width/2));
	$image.attr('y', (svgCanvas.getResolution().h / 2) - (height/2));

	svgOverlay.clear();
	if(!checkCavityDepth($image[0])){
		global.alert('Cutout does not fit inside this case.');
		$image.remove();
	}
}

var allowedArea;


var timerId;
function clearTimer() {
    clearInterval(timerId);
    if (this) {
        this.removeEventListener('mouseup', clearTimer);
        this.removeEventListener('mouseout', clearTimer);            
    }
}

/** @type {DOMNode, function} */
function addHoldTrigger(element, functionTriggered, interval) {
    interval = interval || 200;
    $(element).click(functionTriggered);
    $(element).mousedown(function (e) {
        var calledTime = 0;
        clearTimer();
        timerId = setInterval(function() {
            calledTime += 1;
            functionTriggered(e, calledTime);
        }, interval);
        element.addEventListener('mouseup', clearTimer);
        element.addEventListener('mouseout', clearTimer);
    });
}


function textAfterWord(s, word) {
    return s.substring(s.indexOf(word) + word.length);
}

function addShape(svgFile, shapeDepth, shapeName) {
	var svgSting = '<image class="noresize target" x="50" y="50" width="100" height="100" xlink:href="' +
				svgFile +
				'" cbs:depth="' + inchesToPixels(shapeDepth) +
				'" id="' + svgCanvas.getNextId() +
				'" cbs:name="' + encodeURIComponent(shapeName) + '"/>';
	var $newElement = addSVGString(document.querySelector('#svgcontent > g'), svgSting);


	if (svgFile.indexOf('base64') === -1) {	
		$.get(svgFile, function (imageXml) {
			setNewImagePosition ($newElement,
				parseFloat($(imageXml).find('svg[width]').attr('width')),
				parseFloat($(imageXml).find('svg[width]').attr('height')));
		});
	} else {
		var svgText = atob(textAfterWord(svgFile, 'base64,'));
		var svgElem = $(svgText).find('svg').andSelf().filter('svg');
		setNewImagePosition ($newElement,
			parseFloat(svgElem.attr('width')),
			parseFloat(svgElem.attr('height')));		
	}

	updateCost();
	hideOverLay();
}

function shapeClick (event) {
	var targetElement = $(event.target).closest('.target')[0];

	if (targetElement) {	
		var svgSting = '<image class="noresize target" x="50" y="50" width="100" height="100" xlink:href="' +
					targetElement.getAttribute('data-src') +
					'" cbs:depth="' + inchesToPixels(targetElement.getAttribute('data-depth')) +
					'" id="' + svgCanvas.getNextId() +
					'" cbs:name="' + encodeURIComponent(targetElement.getAttribute('data-name')) + '"/>';
		var $newElement = addSVGString(document.querySelector('#svgcontent > g'), svgSting);


		if ($newElement[0].hasAttribute('xlink:href')) {
			$.get($newElement[0].getAttribute('xlink:href'), function (imageXml) {
				setNewImagePosition ($newElement,
					parseFloat($(imageXml).find('svg[width]').attr('width')),
					parseFloat($(imageXml).find('svg[width]').attr('height')));
			});
		}

		updateCost();
		hideOverLay();
	}
}

$('html').click(function(e) {
	if ($(e.target).parents('.shape-popup').length === 0) {
		$('.shape-popup').not($(e.target).parents('.shape-section').find('.shape-popup')).removeClass('opened-popup');
		$('.accordion-selected').not($(e.target).parents('.shape-section').find('.shape-popup')).removeClass('accordion-selected');
	}
});

$('.shape-library').bind('mousewheel', function () {
	$('.shape-popup').removeClass('opened-popup');
});


function openLibraryTab(elem) {
	var newLibraryName = elem.getAttribute('data-tabname');
	$('.open-tab').removeClass('open-tab');
	elem.classList.add('open-tab');

	$('[data-tab-show]').hide();
	$('[data-tab-show="' + newLibraryName + '"]').show();
}

function createSvgElem(name) {
    var svgElem = document.createElementNS('http://www.w3.org/2000/svg', name);

    return svgElem;
}

var appData = {
	'customUserData': {
		'deleteFiles': {},
		'myLibrary': []
	},
	'deleteFile': function (fileUrl) {
		appData.customUserData.deleteFiles[fileUrl] = true;
	},
	'downloadShape': function (e) {
		var jsonDownload = {
			'shapeSvg': this.getAttribute('data-svg'),
			'name': this.getAttribute('data-shape-name'),
			'depth': this.getAttribute('data-depth')
		};

	    var link = document.createElement('a');
	    link.download = 'my-custom-shap.json';
	    link.href = 'data:application/json;base64,' + btoa(JSON.stringify(jsonDownload, null, '\t'));
	    link.click();
	},
	'deleteShape': function (e) {
		if(confirm('Delete shape file')) {		
			var shapeSvg = this.getAttribute('data-svg');
			var indexMatch = appData.customUserData.myLibrary
				.map(function(shapeData) {
					return shapeData.shapeSvg;
				})
				.indexOf(shapeSvg);
			if (indexMatch > -1) {
			    appData.customUserData.myLibrary.splice(indexMatch, 1);
				saveShapeLibrary(appData.customUserData.myLibrary, function() {
					global.alert('Shape deleted');
				});	
			} else {
				global.alert('Couldn\'t find the shape to delete');
			}
		}
	},
	'isSvgEditorReady': false,
	'user': {
		'loginRedirectUrl': '#',
		'isAdmin': false,
		'is-logged-in': false
	},
	'current-case': {
		'base-height': 0,
		'is-custom': false,
		'lid-height': 0,
		'restrictedDepthAreas': [],
		'restrictedDepthText' : function () {
			return appData['current-case'].restrictedDepthAreas
				.map(function(a) {
					return toCurrentUnit(a.depth) + '<span class="unitSymbol"></span>';
				})
				.join(' and ');
		}
	},
	'order-data': {
		'numberOfCavitis': 0,
		'colors': [],
		'quanity': 1,
		'foamtype': 'PE',
		'foamname': function() {
			if (appData['order-data'].foamtype === 'PE') {
				return 'Polyethylene';
			} else if (appData['order-data'].foamtype === 'XPE') {
				return 'Cross-Link';
			} else {
				return 'Polyurethane';
			}
		},
		'adders': []
	},
	'imageUploadView': pathTracerFeature(() => isIE10, hideOverLay, showOverLay, removeBase64Prefix,
					svgMarkupTextToBase64Image, document.querySelector('.drop-area'), toUnit, global),
	'openTracerView': () => {
		appData.user.loggedIn?appData.imageUploadView.openView():showOverLay('.loginForm');
	},
	'editor': {
		'minX': 0,
		'minY': 0,
		'maxWidth': 0,
		'maxHeight': 0,
		'maxX': function () {
			return appData.editor.minX + appData.editor.maxWidth;
		},
		'maxY': function () {
			return appData.editor.minY + appData.editor.maxHeight;
		}
	},
	'myLibrary': [
		// { Example
		// 	'name': 'My Shapes',
		// 	'shapeSvg': '/editor/server/svgs/Camera D3.15.svg',
		// 	'depth': 3.15
		// }
	],
	'case-cavities-library': {},
	'update-price': updateCost,
	'open-library-tab': function (e) {
		openLibraryTab(this);
	},
	'open-accordion': function (e) {
		$('.accordion-selected').removeClass('accordion-selected');
		this.classList.add('accordion-selected');
		$('.shape-popup').removeClass('opened-popup');
		var $shape = $(this.parentNode).find('.shape-popup');

		var top = $(this).height() + $(this).position().top + $('.shape-library').position().top;
		$shape.css('top', top + 'px');
		$shape.addClass('opened-popup');

		e.preventDefault();
		e.stopPropagation();
	},
	'add-svg': function (e) {
		var svgFile = this.getAttribute('data-svg');
		var shapeDepth = this.getAttribute('data-depth');
		var shapeName = this.getAttribute('data-shape-name');

		addShape(svgFile, shapeDepth, shapeName);
		hideOverLay();
	}
};


$.fn.tclick = function (onclick) {
    this.bind('touchstart', function (e) { onclick.call(this, e); e.stopPropagation(); e.preventDefault(); });
    this.bind('click', function (e) { onclick.call(this, e); });   //substitute mousedown event for exact same result as touchstart
    return this;
};

$('.shape-library').tclick(shapeClick);

rivets.formatters.currencyToSymbol = function(value) {
	return returnExports.getCurrencyUnitWithCode(value).symbol;
};
rivets.formatters['to-current-unit'] = function(value) {
	return toCurrentUnit(value);
};
var rivetsView = rivets.bind(document.body, {'app': appData});

sightglass.adapters = rivets.adapters;
sightglass.root = '.';

sightglass(appData['current-case'], 'base-height', function() {
	appData['current-case']['lid-height'] = appData['current-case'].height - appData['current-case']['base-height'];
});

sightglass(appData['current-case'], 'is-custom', function() {
	$('.lid-info').css('display', appData['current-case']['is-custom']?'none':'inline');
});

function updateFoam() {
	$('[data-foam-type].pressed')
		.removeClass('pressed')
		.removeAttr('disabled');
	$('[data-foam-type="' + appData['order-data'].foamtype + '"]')
		.addClass('pressed')
		.attr('disabled', 'true');
}

sightglass(appData['order-data'], 'foamtype', function () {
	updateFoam();
	if (currentPartInfo) {
		updateCost();
	}
});

sightglass(appData['current-case'], 'lid-height', function(newValue) {
	$('.lid-info').attr('title', 'Lid height of ' + toCurrentUnit(appData['current-case']['lid-height']) +
		' plus base height of ' + toCurrentUnit(appData['current-case']['base-height']));
});


// if ($.webshims && $.webshims.polyfill) {
	// $.webshims.polyfill();
// }

var foam_sku, shapesList, caseLookup, cavityPrices, groupedCaseLookup, min_spacing, svgWrap;

var isIE10 = deviceInfo.isIe;


function wrapWithSVGHeaders (svgSting) {
	var preSVG = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:cbs="https://www.casesbysource.com/" version="1.1" width="46"' +
	' height="46">';
	var postSVG = '</svg>';

	return preSVG + svgSting + postSVG;
}


function addSVGString(parent, svgSting) {
	var newEle = $(wrapWithSVGHeaders (svgSting));

	$(parent).append(newEle);

	return newEle.children().unwrap();
}


function getAdders() {
	return Array.from(document.querySelectorAll('[name="addOnId"]'))
		.filter(function(e){return e.checked;})
		.map(function(e){return e.value;});
}

var currentPartInfo;
function updateCost() {
	if (foam_sku === undefined) {
		Rollbar.warning('no foam sku', {'order-data': appData['order-data']});
		console.trace();
		return;
	}


	// Total cavities = total selectable minus the grouped elements
	var numberOfCavitis = $('#svgcontent g > *').length -
			$('#svgcontent g > .grip, #svgcontent g > .no-count').length -
			$('#svgcontent g > title').length - $('#svgcontent g > g').length;

	var priceOfCavity;

	cavityPrices.forEach( function (cavityPrice) {
		if (numberOfCavitis >= cavityPrice['Total Cavity Min']) {
			priceOfCavity = parseFloat(cavityPrice.Price);
		}
	});

	if (priceOfCavity === undefined) {
		console.error('priceOfCavity not found ', foam_sku, JSON.stringify(currentPartInfo));
	}

	if (currentPartInfo === undefined) {
		console.error('currentPartInfo not found ', JSON.stringify(currentPartInfo));
	}

	var setupPrice = parseFloat(currentPartInfo['Empty Case Price']) +
				parseFloat(currentPartInfo['Setup Fee']) +
				parseFloat(currentPartInfo['Board Foot']) *
				parseFloat(foam_sku[appData['order-data'].foamtype].Multiplier);

	appData['order-data'].numberOfCavitis = numberOfCavitis;
	appData['order-data'].setupPrice = numberOfCavitis;

	$('.startingprice').text(setupPrice.toFixed(2));
	$('.numberofcavities').text(numberOfCavitis);
	$('.cavitiesprice').text(priceOfCavity.toFixed(2));

	var addPrices = [];
	var error = false;

	getAdders().forEach(function(adder) {
			var addEntries = adderPricing
				.filter(function(adderPrice) {
					return adderPrice.adderSku === adder;
				});
			if (addEntries.length === 0) {
				error = true;
			} else {
				addPrices.push(addEntries[0].price);
			}
		});

	var adderCost = addPrices.reduce(
		function(prev,current){
			return  current + prev;
		}, 0);

	var costForOne = adderCost + setupPrice + priceOfCavity;
	appData['order-data'].price = (costForOne * (appData['order-data'].quanity || 1)).toFixed(2);
	$('.totalcost').text(costForOne.toFixed(2));

	document.body.classList.add('app-loaded');
}


function loadCaseNumber(key) {
	return function () {
		loadCase(groupedCaseLookup[key][0]['Part #']);
		hideOverLay();
	};
}

$('.caseinfo').hammer().on('tap', function () {
	$('.pickcase tbody *').remove();
	var newRow;
	for (var key in groupedCaseLookup) {
		newRow = $('<tr class="datarow"></tr>');

		newRow.append('<td>' + groupedCaseLookup[key][0].Brand +'</td>');
		newRow.append('<td><span class="productid" title="Change to this case">' +
			groupedCaseLookup[key][0]['Product ID'] + '</span></td>');

		newRow.append('<td>' + Math.round(toUnit(inchesToPixels(groupedCaseLookup[key][0].Length)) * 100) / 100 + '</td>');
		newRow.append('<td>' + Math.round(toUnit(inchesToPixels(groupedCaseLookup[key][0].Width)) * 100) / 100 + '</td>');
		newRow.append('<td>' + Math.round(toUnit(inchesToPixels(groupedCaseLookup[key][0].Height)) * 100) / 100 + '</td>');

		newRow.append('<td>$' + groupedCaseLookup[key][0]['Starting Price'] +'</td>');

		$('.pickcase tbody').append(newRow);
		newRow.find('.productid').click(loadCaseNumber(key));
	}

	updateUnits();

	$('.pickcase table').trigger('update');
});

function checkAllCavityDepth() {
	if (typeof(currentPartInfo) === 'undefined') {
		return false;
	}

	var violations = false;
	$('.violations').html('');
	svgOverlay.clear();

	$('#svgcontent .target').toArray().forEach(function (elem) {
		violations = (checkCavityDepth(elem) === false) || violations;
	});

	if (violations) {
		$('.rightpanel .violationWarning').show();
		updateUnits();
	} else {
		$('.rightpanel .violationWarning').hide();
	}
	return violations;
}


function moveAllOntoCanvas() {
	$('#svgcontent > g > *').toArray()
		.filter(function(e) {
			return 'transform' in e;
		})
		.forEach(function (elem) {
			moveOntoCanvas(elem);
		});
}

function moveOntoCanvas(elem) {
	if (!allowedArea) {
		console.warn('Allowed area not defined in case');
		return;
	}
	var bbox = svgMatrixUntils.getBbox(elem, null, true);
	var isTooBig = allowedArea.width < bbox.width || allowedArea.height < bbox.height;

	bbox.width += 6;
	bbox.height += 6;
	bbox.x -= 3;
	bbox.y -= 3;

	var xMove = 0;
	if (allowedArea.x > bbox.x && !isTooBig) {
		xMove = allowedArea.x - bbox.x;
	} else if ((allowedArea.x + allowedArea.width) < (bbox.x + bbox.width)) {
		xMove = allowedArea.x + allowedArea.width - bbox.x - bbox.width;
	}
	var yMove = 0;
	if (allowedArea.y > bbox.y && !isTooBig) {
		yMove = allowedArea.y - bbox.y;
	} else if ((allowedArea.y + allowedArea.height) < (bbox.y + bbox.height)) {
		yMove = allowedArea.y + allowedArea.height - bbox.y - bbox.height;
	}
	if (Math.abs(xMove) > 0.01 || Math.abs(yMove) > 0.01) {
		svgCanvas.moveSelectedElements([xMove], [yMove], false, [elem]);
	}
}


function getRestrictedAreas() {
	return svgWrap.find('[id^="cavity_wheel_well"], .restricted_area').toArray();
}


function checkCavityDepth(elem) {
	// elem.classList.remove('invalid-position');
	removeElemToWarmingOverlay(elem);

	var bbox = svgMatrixUntils.getBbox(elem, null, true);
	var depth = parseFloat($(elem).attr('cbs:depth'));

	var eleName = decodeURIComponent(elem.getAttribute('cbs:name') || 'Unnamed cavity');


	if (currentPartInfo === undefined) {
		console.error('currentPartInfo not found ', JSON.stringify(currentPartInfo));
	}
	var baseDepth = inchesToPixels(currentPartInfo['Base Height']);
	if (depth > baseDepth) {
		// global.alert('<h2>Cavity too deep!</h2>' +
		// 	'Must be edited before proceesing. New help? Check out User Guide' +
		// 	'Depth must be less than or equal to ' + baseDepth);
		const msg = eleName + ': Depth must be less than or equal to ' + toUnit(baseDepth);
		$('.violations').append('<li>' + msg + '<span class="unitSymbol"></span></li>');
		// elem.classList.add('invalid-position');
		addElemToWarmingOverlay(elem, bbox, 10, null, null, msg);
		// $(elem).attr('class', $(elem).attr('class') + ' restricted');
		return false;
	}

	if (!allowedArea) {
		console.warn('Allowed area not defined in case');
	} else if (allowedArea.x > bbox.x ||
				allowedArea.x + allowedArea.width < bbox.x + bbox.width ||
				allowedArea.y > bbox.y ||
				allowedArea.y + allowedArea.height < bbox.y + bbox.height) {
		const msg = eleName + ': Position is off limits';

		$('.violations').append('<li>' + msg + '</li>');
		addElemToWarmingOverlay(elem, bbox, 10, null, null, msg);
		// elem.classList.add('invalid-position');

		return false;
	}

	var inrestrictedArea = false;
	getRestrictedAreas().forEach(function (e) {
		var restrictedAreaFixedBbox = svgMatrixUntils.getBbox(e, null, true);
		// if (svgedit.math.rectsIntersect2(restrictedAreaFixedBbox, fixedBbox)) {
		if (svgedit.math.rectsIntersect(restrictedAreaFixedBbox, bbox)) {
			var restrictedDepth = parseFloat($(e).attr('depth') || $(e).attr('cbs:depth')) * 96;
			if (depth > restrictedDepth) {
				// $('.overlay').show();
				// $('.overlay > *').hide();
				// $('.restricted_zone_alert').show();
				// $(elem).attr('class', $(elem).attr('class') + ' restricted');
				// elem.classList.add('invalid-position');

				const msg = eleName + ': Depth must be less than or equal to ' + toUnit(restrictedDepth);
				addElemToWarmingOverlay(elem, bbox, 10, null, null, msg);
				$('.violations').append('<li>' + msg + '<span class="unitSymbol"></span></li>');
				inrestrictedArea = true;
			}
		}
	});

	if (inrestrictedArea) {
		return false;
	}

	return true;
}






function updateUnits() {
	svgEditor.updateRulers();
	$('#view_grid').click();
	$('#view_grid').click();


	var minX = toUnit(document.querySelector('#casing').getBBox().x);
	var minY = toUnit(document.querySelector('#casing').getBBox().y);
	var maxWidth = toUnit(document.querySelector('#casing').getBBox().width);
	var maxHeight = toUnit(document.querySelector('#casing').getBBox().height);
	var maxDepth = toUnit(inchesToPixels(document.querySelector('#casing').getAttribute('cbs:depth')));
	var restrictedDepth = 
		Math.max.apply(null,
			getRestrictedAreas().map(function (e) {
				return toUnit(inchesToPixels(e.getAttribute('cbs:depth')));
			})
			.concat([maxDepth])
		);

	$('[name="width"], [data-attribute="dimention-width"]').attr('max', maxWidth);
		// .attr('placeholder', 'max ' + maxWidth.toFixed(2));
	$('[name="height"], [data-attribute="dimention-height"]').attr('max', maxHeight);
		// .attr('placeholder', 'max ' + maxHeight.toFixed(2));

	$('[name="radius"], [name="r"]')
		.attr('max', Math.min(maxWidth, maxHeight)/2);
		// .attr('placeholder', 'max ' + (Math.min(maxWidth, maxHeight)/2).toFixed(2));

	$('[name="size"]').attr('max', Math.min(maxWidth, maxHeight).toFixed(2));
		// .attr('placeholder', 'max ' + Math.min(maxWidth, maxHeight).toFixed(2));

	$('[name="depth"]').attr('max', maxDepth.toFixed(2));
		// .attr('placeholder', 'max ' + maxDepth.toFixed(2));

	$('.max-depth').text(maxDepth.toFixed(2));
	$('.restricted-depth').text(restrictedDepth.toFixed(2));

	$('[data-attribute="dimention-x"]').attr('min', minX);
		// .attr('placeholder', 'min ' + minX.toFixed(2));

	$('[data-attribute="dimention-y"]').attr('min', minY);
		// .attr('placeholder', 'min ' + minY.toFixed(2));

	$('[name="x"]').attr('max', minX + maxWidth);
	$('[name="y"]').attr('max', minY + maxHeight);


	$('[name="corner"]').attr('step', toUnit(12));

	$('.measure_length, .measure_line, .x1_line, .y1_line, .x2_line, .y2_line').hide();
}

function moveEnd() {
	moveAllOntoCanvas();
	processAlginMarkup();
}

function loadCaseFromUrl(caseSvgUrl, width, height, custom) {
	svgCanvas.clearSelection();
	$.get(caseSvgUrl, function (caseSVGDOM) {
		var svgElem = $(caseSVGDOM).find('svg');

		if (svgElem.length === 0) {
			global.alert('Failed to load case url ' + caseSvgUrl + '.\n' +
				' No valid data returned -> "' + svgElem + '"');
		}

		if (custom) {
			svgElem.attr('width', width);
			svgElem.attr('height', height);
			svgCanvas.setBackground('', '');
		} else {
			width = svgElem.attr('width').split('px')[0];
			height = svgElem.attr('height').split('px')[0];
			svgCanvas.setBackground('', serverURL + 'casesvg/' + currentPartInfo.SVG);
		}



		$('#casebackground').remove();
		svgWrap = $('<svg id="casebackground" width="100%" height="100%" viewbox="0 0 ' +
										width + ' ' + height + '"></svg>');
		if (custom === undefined) {
			svgWrap.attr('visibility', 'hidden');
			svgWrap.append(svgElem);
		} else {
			addSVGString(svgWrap[0], '<rect id="casing_outer" fill="#502222" x="0" y="0" width="100%" height="100%" rx="10" ry="10"/>');
			addSVGString(svgWrap[0], '<rect id="casing" fill="#333333" x="3%" y="3%" width="94%" height="94%"/>');
		}


		$('#canvasBackground > rect').after(svgWrap);

		svgCanvas.setResolution(width, height);
		svgCanvas.zoomChanged(window, 'canvas');
		svgEditor.updateCanvas();

		// SvgPath(document.querySelector('#casing'.getAttribute('d')).abs().unarc().unshort().toString()
		allowedArea = svgMatrixUntils.getBbox(document.querySelector('#casing'), null, true);

		var backgroundSvg = document.getElementById('casebackground').querySelector('svg');

        if (window.Rollbar) {
        	if (backgroundSvg === null) {
            	Rollbar.warning('no background svg caseSvgUrl ' + caseSvgUrl);
        	}
        }

		var viewBox = backgroundSvg.getAttribute('viewBox');
		if (viewBox) {
			var caseSvgWidth = parseInt(backgroundSvg.getAttribute('width'), 10);
			var caseSvgHeight = parseInt(backgroundSvg.getAttribute('height'), 10);

			var viewBoxSplit = viewBox.split(' ').map(function(m) {return parseInt(m, 10);});
			allowedArea.x -= viewBoxSplit[0];
			allowedArea.y -= viewBoxSplit[1];

			allowedArea.width *= caseSvgWidth / viewBoxSplit[2];
			allowedArea.height *= caseSvgHeight / viewBoxSplit[3];
		}
		
		appData.editor.minX = allowedArea.x;
		appData.editor.minY = allowedArea.y;
		appData.editor.maxWidth = allowedArea.width - allowedArea.x;
		appData.editor.maxHeight = allowedArea.height - allowedArea.y;

		appData['current-case']['max-depth'] =
					parseFloat(document.querySelector('#casing').getAttribute('cbs:depth'));

		appData['current-case'].restrictedDepthAreas = 
			getRestrictedAreas().map(function (e) {
				var bbox = svgMatrixUntils.getBbox(e, null, true);
				return {
					'x': bbox.x,
					'y': bbox.y,
					'width': bbox.width,
					'height': bbox.height,
					'depth': parseFloat(e.getAttribute('cbs:depth'))
				};
			});

		appData['current-case']['max-restricted-depth'] = Math.min.apply(null,
				getRestrictedAreas().map(function (e) {
					return parseFloat(e.getAttribute('cbs:depth'));
				})
				.concat([appData['current-case']['max-depth']])
			);

		appData['current-case'].length = parseFloat(currentPartInfo.Length);
		appData['current-case'].width = parseFloat(currentPartInfo.Width);
		appData['current-case'].height = parseFloat(currentPartInfo.Height);

		appData['current-case']['is-custom'] = !('Base Height' in currentPartInfo);
		if ('Base Height' in currentPartInfo) {
			appData['current-case']['base-height'] = parseFloat(currentPartInfo['Base Height']);
		}


		updateUnits();



		var importFilesMetaTag = svgElem[0].querySelector('.import-files-command');
		if (importFilesMetaTag) {
			console.log('Importing files ' + importFilesMetaTag.getAttribute('xlink:href'));
			$.get(importFilesMetaTag.getAttribute('xlink:href'), function (importedFilesDom) {
				var importFiles = importedFilesDom.querySelector('.imported-files');
				Array.from(importFiles.children).forEach(function(n) {
					svgCanvas.getCurrentDrawing().current_layer.appendChild(n);
				});
		        svgEditor.canvas.undoMgr.addCommandToHistory();
		    });
		}



		moveAllOntoCanvas();
		svgCanvas.undoMgr.resetUndoStack();

		svgEditor.zoomDelta(-1);
	})
	.error(function() {
		global.alert('Failed to load case url ' + caseSvgUrl);
	});
}


function loadCase(partNumber, width, height, custom) {
	$('.welcome_page').hide();
	if (!caseLookup[partNumber]) {
		global.alert('Case info not found');
		return;
	}
	currentPartInfo = caseLookup[partNumber];
	updateCost();


	appData['order-data'].partNumber = partNumber;
	appData['current-case'].caseUrl = 'PC-1520%20D%204.375.svg';
	appData.currentPartInfo = currentPartInfo;
	appData['order-data'].productId = currentPartInfo['Product ID'];

	if (currentPartInfo['Case Image']) {
		$('.caseinfo img').attr('src', serverURL + 'case_images/' + currentPartInfo['Case Image']);
	}
	$('.partnumber').text(partNumber);
	appData['current-case']['part-number'] = partNumber;

	loadCaseFromUrl(serverURL + 'casesvg/' + currentPartInfo.SVG, width, height, custom);

	while(appData['order-data'].colors.length > 0) {
		appData['order-data'].colors.pop();
	}
	if (partNumber === 'Custom Size') {
		appData['order-data'].colors.push({
			'sku': 'Custom Size',
			'name': 'Custom Case'
		});
	} else {	
		updateProductDataFromServer();
		groupedCaseLookup[currentPartInfo['Product ID']].map(function (colorCase) {
			appData['order-data'].colors.push({
				'sku': colorCase['Part #'],
				'name': colorCase.Color
			});
		});
	}
	updateFoam();
	appData['order-data'].color = partNumber;
}


function addDepth(ele) {
	ele.attr('fill', '#242524');
	ele.attr('stroke', '#1F1F1F');
	ele.attr('stroke-width', '1');
	// ele.attr('fill', 'url(#svg_8)');
	ele.attr('class', 'target');
	ele.attr('id', svgCanvas.getNextId());

	var stddeviation = 30;// + (parseFloat(ele.attr('cbs:depth') / 10));
	var fillString = '<filter id="' + ele.attr('id') + 'depth" color-interpolation-filters="sRGB"><feGaussianBlur result="result8" stddeviation="' + stddeviation + '"></feGaussianBlur><feOffset dx="0" dy="0" result="result11"></feOffset><feComposite result="result6" in="SourceGraphic" operator="in" in2="result11"></feComposite><feFlood result="result10" in="result6" flood-opacity="1" flood-color="#0A0B0A"></feFlood><feBlend mode="normal" in="result6" in2="result10"></feBlend><feComposite result="result2" operator="in" in2="SourceGraphic"></feComposite></filter>';
	ele.attr('filter', 'url(#' + ele.attr('id') + 'depth)');
	addSVGString(document.querySelector('#svgcontent defs'), fillString);
}


var currentPathEditor;



function removeBase64Prefix(imageDataUrl) {
    return textAfterWord(imageDataUrl, 'base64,');
}

function base64SvgImageToDom(base64SvgImage) {
	return $(atob(removeBase64Prefix(base64SvgImage))).find('svg').andSelf().filter('svg')[0];
}

function finishedUpload(e) {
	e.preventDefault();

	var srcElem = document.querySelector('.path-editor svg');

	var fileData = document.querySelector('.uploaded-image')
		.getAttribute('src');

	if (srcElem) {
		fileData = svgMarkupTextToBase64Image(srcElem.parentNode.innerHTML);
		srcElem.remove();
	}
	console.assert(fileData.length > 0);
	hideOverLay();
	showOverLay('.my-shape-library');

	var svgDoc = base64SvgImageToDom(fileData);
	var aspectRatio = parseFloat(svgDoc.getAttribute('height')) /
				parseFloat(svgDoc.getAttribute('width'));
	var docWidth =  toPixels(document.querySelector('[name="shape-length"]').value);
	if (!svgDoc.hasAttribute('viewbox') && !svgDoc.hasAttribute('viewBox')) {
		svgDoc.setAttribute('viewBox', [0, 0, svgDoc.getAttribute('width'), svgDoc.getAttribute('height')].join(' '));
	}


	Array.from(svgDoc.querySelectorAll('path')).forEach(function(p) {
		p.style.fill = '#222';
		p.style.stroke= 'none';
		p.style.opacity = 1;
	});
	svgDoc.setAttribute('width', docWidth);
	svgDoc.setAttribute('height', docWidth * aspectRatio);

	document.querySelector('.path-editor').appendChild(svgDoc);

	fileData = svgMarkupTextToBase64Image(svgDoc.parentNode.innerHTML.trim());
	svgDoc.remove();

	console.log('Adding to my library ', fileData);

	var newShape = {
		'name': this.elements.name.value,
		'shapeSvg': fileData,
		'depth': pixelsToInches(toPixels(parseFloat(this.elements['shape-depth'].value)))
	};

	appData.customUserData.myLibrary.push(newShape);


	document.querySelector('.upload-controls')
		.style.display = 'none';
	document.querySelector('.drop-text').style.display = '';

	global.alert('You can now select your image in the My Shape Library menu');
	appData.imageUploadView.toUploadStep();

	saveShapeLibrary(appData.customUserData.myLibrary, function() {
		console.log('My library saved');
	});
}

function requireLogin(callback) {
	return function(e) {	
		if (!appData.user.loggedIn) {
			showOverLay('.loginForm');
		} else {
			callback(e);
		}
	};
}

let svgOverlay;

$(document).ready(function () {
	var userMessagesAboutDevice = deviceInfo.getWarningMessages();
	if (userMessagesAboutDevice) {
		global.alert(userMessagesAboutDevice);
	}

	document.querySelector('.upload-controls')
		.style.display = 'none';

	document.querySelector('.upload-shape-form')
		.addEventListener('submit', finishedUpload);

	// document.querySelector('[name="shape-length"]')
	// 	.addEventListener('input', function() {
	// 		// var length = parseFloat(this.value);
	// 		// document.querySelector('.upload-width').value = length * ();
	// 	});

	function closeWelcomeScreen() {
		var welcomePageElem = document.querySelector('.welcome_page');	

		if (welcomePageElem) {
			document.querySelector('.welcome_page .action').removeEventListener('click', closeWelcomeScreen);
			welcomePageElem.parentNode.removeChild(welcomePageElem);			
		}
	}

	$('.custom_case_size').submit(function (event) {
		event.preventDefault();
		hideOverLay();

		var partNumber = 'Custom Size';

		caseLookup[partNumber] = {
			'Width': pixelsToInches(toPixels(event.delegateTarget.customwidth.value)),
			'Height': pixelsToInches(toPixels(event.delegateTarget.customheight.value)),
			'Length': pixelsToInches(toPixels(event.delegateTarget.customlength.value)),
			'Setup Fee': 75,
			'Empty Case Price': 0,
			'SVG': 'PC-1520%20D%204.375.svg',
			'Case Image': 'customcase.jpg'
		};

		appData['order-data'].partNumber = 'Custom Size';
		appData['order-data'].setupFee = 75;
		appData['order-data'].emptyCasePrice = 0;
		appData['current-case'].caseUrl = 'PC-1520%20D%204.375.svg';
		appData['current-case'].caseIconUrl = 'customcase.jpg';
		appData['current-case'].width = pixelsToInches(toPixels(event.delegateTarget.customwidth.value));
		appData['current-case'].height = pixelsToInches(toPixels(event.delegateTarget.customheight.value));
		appData['current-case'].length = pixelsToInches(toPixels(event.delegateTarget.customlength.value));

		caseLookup[partNumber]['Board Foot'] =
				(caseLookup[partNumber].Width *
				caseLookup[partNumber].Height *
				caseLookup[partNumber].Length) / 144;

		loadCase(partNumber,
			toPixels(event.delegateTarget.customlength.value),
			toPixels(event.delegateTarget.customwidth.value), true);

		// Reset the form
	    this.reset();
	    $('.welcome_page').hide();

	    // closeWelcomeScreen();
		return false;
	});



	$('.pickcase table').tablesorter();
	var $hiddenElem = $('<div style="display:none"> </div>');
	$(document.body).append($hiddenElem);
	var $elemsToHide = $('#color_tools, #sidepanels, #palette_holder, #tool_blur, #idLabel' +
		', #tool_reorient, #tool_make_link, #tool_move_top, #tool_move_bottom' +
		', #tool_wireframe, #tool_source, #tool_image_url, #tool_change_image' +
		', #tools_left, #main_button, #tools_bottom, #tools_top'
		).remove();
	$hiddenElem.append($elemsToHide);

	svgEditor.ready(function () {
		window.bindedAttributes = bindSelectedElementData(document.querySelector('.editProperties'),
			svgCanvas.getSelectedElems,
			{'cbs': 'http://www.casesbysource.com/'}
		);

		function fileUpload() {
			var fileList = this.files;

			for (var i = 0, numFiles = fileList.length; i < numFiles; i++) {

				var file = fileList[i];
			    
			    var reader = new FileReader();
			    reader.onload = function(e) {
			    	var newData = JSON.parse(e.target.result);
			    	console.log(newData);
			    	if ('name' in newData && 'shapeSvg' in newData && 'depth' in newData) {
						appData.customUserData.myLibrary.push(newData);
						saveShapeLibrary(appData.customUserData.myLibrary, function() {
							global.alert('New shape saved');
						});	
			    	} else {
			    		global.alert('Invalid shape file.');
			    	}
			    };

			    reader.readAsText(file);
			}
			this.value = '';
		}

		q('.upload-custom-shape').addEventListener('change', fileUpload);
		
		q('.add-shape-from-selected').addEventListener('click', requireLogin(function () {
			var bbox = svgMatrixUntils.bboxOfMany(svgCanvas.getSelectedElems().map(function(e) {return svgMatrixUntils.getBbox(e, null, true);}));


		    var svgElem = createSvgElem('svg');
		    svgElem.setAttribute('width', bbox.width);
		    svgElem.setAttribute('height', bbox.height);

		    var groupSvgElem = createSvgElem('g');
			var depths = $(svgCanvas.getSelectedElems()).find('*').andSelf().toArray()
				.filter(function(e) {
					return e.hasAttribute('cbs:depth');
				})
				.map(function(e) {
					return e.getAttribute('cbs:depth');
				});

			var names = $(svgCanvas.getSelectedElems()).find('*').andSelf().toArray()
				.filter(function(e) {
					return e.hasAttribute('cbs:name');
				})
				.map(function(e) {
					return e.getAttribute('cbs:name');
				})
				.map(decodeURIComponent);

			svgCanvas.getSelectedElems().forEach(function(e) {
				var clonedElem = e.cloneNode(true);

				clonedElem.removeAttribute('cbs:depth');
				clonedElem.removeAttribute('cbs:name');
				clonedElem.removeAttribute('filter');
				clonedElem.removeAttribute('class');
				clonedElem.removeAttribute('id');
				clonedElem.setAttribute('style', 'pointer-events: none; fill: rgb(34, 34, 34); stroke: none; opacity: 1;');

				groupSvgElem.appendChild(clonedElem);
			});

			$(groupSvgElem).find('*').andSelf().toArray()
				.forEach(function(e) {
					e.removeAttribute('cbs:depth');
					e.removeAttribute('cbs:name');
					e.removeAttribute('filter');
					e.removeAttribute('class');
					e.removeAttribute('id');
				});

			groupSvgElem.setAttribute('transform', 'translate(' + -bbox.x + ', ' + -bbox.y + ')');

			svgElem.appendChild(groupSvgElem);

			var imagePromises = $(svgElem).find('*').andSelf().toArray()
				.filter(function(e) {
					return e.nodeName === 'image';
				})
				.map(svgUtils.refImageTobase64);

			global.prompt('Enter new shape name', names.length>1?names[0]:'', function(shapeName) {
				$.whenall(imagePromises)
					.done(function () {
						// Replace used as hack because of IE11 namespace bug
						var newShape = {
							'name': shapeName || 'Unnamed',
							'shapeSvg': svgMarkupTextToBase64Image(serializeXmlNode(svgElem).replace('<svg ', '<svg xmlns:cbs="http://www.casesbysource.com/" ')),
							'depth': pixelsToInches(Math.min.apply(Math, depths))
						};

						console.log('Adding to my library ', newShape);
						appData.customUserData.myLibrary.push(newShape);
						showOverLay('.my-shape-library');

						saveShapeLibrary(appData.customUserData.myLibrary, function() {
							global.alert('New shape saved');
						});	
					})
					.fail(function (e) {
						global.alert('Error adding shape ' + e);
						console.error(e);
						throw(e);
					});
			});
		}));

		appData.isSvgEditorReady = true;

		$('.open-autosave').click(function() {
			svgCanvas.setSvgString(localStorage.svgXmlText);
			hideOverLay();
		});

		$('#svgcontent').attr('xmlns:cbs', 'http://www.casesbysource.com/');

		if ($('#svgcontent defs')) {
			addSVGString(document.querySelector('#svgcontent'), '<defs></defs>');
		}

		var fillString = '<radialGradient id="svg_133" spreadMethod="pad" cx="0.51953125" cy="0.6484375" r="0.6230646465181189"><stop stop-color="#242524" stop-opacity="0.99609375" offset="0.71484375"></stop><stop stop-color="#090909" stop-opacity="0.99609375" offset="1"></stop></radialGradient>';
		addSVGString(document.querySelector('#svgcontent defs'), fillString);

		fillString = '<radialGradient id="svg_8" spreadMethod="pad" cx="0.5546875" cy="0.4375" r="0.8836447680898825" gradientTransform="translate(0,0.10560344827586209) scale(1,0.7586206896551724)" fx="0.54296875" fy="0.90625"><stop stop-color="#242524" stop-opacity="0.99609375" offset="0.390625"></stop><stop stop-color="#0a0b0a" stop-opacity="0.99609375" offset="1"></stop></radialGradient>';
		addSVGString(document.querySelector('#svgcontent defs'), fillString);

		$('#view_grid').click();


		svgOverlay = SvgOverlay(document.getElementById('svgcontent'));
		svgCanvas.newSvgContentLoadEvent = () => {
			svgOverlay.destroy();
			svgOverlay = SvgOverlay(document.getElementById('svgcontent'));

		};
	});

	$('.polygon_diagram').click(function () {
		$('.polygonhelp').toggle();
	});

	function addGrips(elem, cx, cy, r) {
		var svgSting = '<circle data-move-with="' + elem.id +
						'" cx="' + cx + '" cy="' + cy + '" r="' + r + '"/>';
		var newElement = addSVGString(document.querySelector('#svgcontent > g'), svgSting);

		newElement.attr('cbs:depth', 0.1);
		newElement.attr('cbs:name', 'grip');

		addDepth(newElement);

		newElement.attr('class', 'grip');

		return newElement;
	}


	$('.add_grips').click(function() {
		var elem = svgCanvas.getSelectedElems()[0];

		var r = 96 / 2;
		var cx = elem.getBBox().x + elem.getBBox().width;
		var cy = elem.getBBox().y + (elem.getBBox().height / 2);

		var c1 = addGrips(elem, cx, cy, r);

		cx = elem.getBBox().x;
		var c2 = addGrips(elem, cx, cy, r);

		processAlginMarkup();

		$('.add_grips').attr('disabled', true);
	});

	$('.createAccount').submit(function (event) {
		if (event.delegateTarget.password.value !== event.delegateTarget.password2.value) {
			event.preventDefault();
			event.delegateTarget.password2.setCustomValidity('Passwords don\'t match. Please reenter');
			event.delegateTarget.password.value = '';
			event.delegateTarget.password2.value = '';
			$('.createAccount').prepend('Passwords don\'t match. Please reenter');
			return false;
		}
	});

	$('.notches').change(function (event) {
		var elemTarget = svgCanvas.getSelectedElems().filter(Boolean)[0];

	    if (elemTarget.nodeName === 'rect' ||
	    	elemTarget.nodeName === 'ellipse' ||
	    	elemTarget.nodeName === 'circle') {

	    	$('[data-xmiddle="' + elemTarget.id + '"]').remove();
	    	$('[data-ymiddle="' + elemTarget.id + '"]').remove();

			var r = 96 / 2;
	    	if (this.value === 'topbottom') {
				var cx = elemTarget.getBBox().x + elemTarget.getBBox().width;
				var cy = elemTarget.getBBox().y + (elemTarget.getBBox().height / 2);

				var c1 = addGrips(elemTarget, cx, cy, r);

				cx = elemTarget.getBBox().x;
				var c2 = addGrips(elemTarget, cx, cy, r);

				c1[0].classList.add('noselect');
				c2[0].classList.add('noselect');

				$(c1).attr("data-xmiddle", elemTarget.id);
				$(c1).attr("data-ytop", elemTarget.id);
				$(c2).attr("data-xmiddle", elemTarget.id);
				$(c2).attr("data-ybottom", elemTarget.id);
				// $(c1).attr("data-rotatearound", elemTarget.id);
				// $(c2).attr("data-rotatearound", elemTarget.id);

				$(c1).css("pointer-events", "none");
				$(c2).css("pointer-events", "none");

				processAlginMarkup();
	    	} else if (this.value === 'leftright') {
				var cx = elemTarget.getBBox().x + elemTarget.getBBox().width;
				var cy = elemTarget.getBBox().y + (elemTarget.getBBox().height / 2);

				var c1 = addGrips(elemTarget, cx, cy, r);

				cx = elemTarget.getBBox().x;
				var c2 = addGrips(elemTarget, cx, cy, r);
				
				c1[0].classList.add('noselect');
				c2[0].classList.add('noselect');

				$(c1).attr("data-xleft", elemTarget.id);
				$(c1).attr("data-ymiddle", elemTarget.id);
				$(c2).attr("data-xright", elemTarget.id);
				$(c2).attr("data-ymiddle", elemTarget.id);
				// $(c1).attr("data-rotatearound", elemTarget.id);
				// $(c2).attr("data-rotatearound", elemTarget.id);

				$(c1).css("pointer-events", "none");
				$(c2).css("pointer-events", "none");

				processAlginMarkup();
	    	}
		}

        svgEditor.canvas.undoMgr.addCommandToHistory();

        svgCanvas.getSelectedElems().forEach(function (e) {
            svgCanvas.selectorManager.requestSelector(e).resize();
        });


		return false;
	});

	// $('.createRect > div:first-child button').click(function (e) {
	// 	$('.createRect .selectedButton').removeClass('selectedButton');
	// 	$(this).addClass('selectedButton');

	// 	if ($(this).hasClass('elementrect')) {
	// 		$('.input_size').hide();
	// 		$('.createRect .input_width').show();
	// 		$('.createRect .input_height').show();
	// 	} else if ($(this).hasClass('elementsquare')) {
	// 		$('.input_size').show();
	// 		$('.createRect .input_width').hide();
	// 		$('.createRect .input_height').hide();
	// 	}
	// });

	$('.createCircle > div:first-child button').click(function (e) {
		$('.createCircle .selectedButton').removeClass('selectedButton');
		$(this).addClass('selectedButton');

		$('.input_radius input, .input_theta input, .createCircle .input_height input, .createCircle .input_width input').removeAttr('required');
		if ($(this).hasClass('elementarc')) {
			$('.input_radius').hide();
			$('.input_theta, .createCircle .input_height, .createCircle .input_width').show();
			$('.input_theta input, .createCircle .input_height input, .createCircle .input_width input').attr('required', 'true');
		} else if ($(this).hasClass('elementcircle')) {
			$('.input_theta, .createCircle .input_height, .createCircle .input_width').hide();
			$('.input_radius').show();
			$('.input_radius input').attr('required', 'true');
		} else if ($(this).hasClass('elementellipse')) {
			$('.input_radius, .input_theta').hide();
			$('.createCircle .input_height, .createCircle .input_width').show();
			$('.createCircle .input_height input, .createCircle .input_width input').attr('required', 'true');
		}
	});

	$('.createRect').submit(function (event) {
		event.preventDefault();

		// var svgSting = '<g class="noungroup"></g>';
		// var groupElement = addSVGString(document.querySelector('#svgcontent > g'), svgSting);

		var svgSting = '<rect class="target"></rect>';

		var newElement = addSVGString(document.querySelector('#svgcontent > g'), svgSting);

		if ($('.createRect .selectedButton').hasClass('elementrect')) {
			newElement.attr('width', toPixels(event.delegateTarget.width.value));
			newElement.attr('height', toPixels(event.delegateTarget.height.value));
		} else if ($('.createRect .selectedButton').hasClass('elementsquare')) {
			newElement.attr('width', toPixels(event.delegateTarget.size.value));
			newElement.attr('height', toPixels(event.delegateTarget.size.value));
			newElement.attr('cbs:lockaspect', 'true');
		}

		newElement.attr('x', (svgCanvas.getResolution().w / 2) - (parseFloat(newElement.attr('width')) / 2));
		newElement.attr('y', (svgCanvas.getResolution().h / 2) - (parseFloat(newElement.attr('height')) / 2));
		newElement.attr('cbs:depth', toPixels(event.delegateTarget.depth.value));
		newElement.attr('cbs:name', encodeURIComponent(event.delegateTarget.cutoutname.value));
		newElement.attr('rx', 0);
		newElement.attr('ry', 0);

		addDepth(newElement);
		// addCavityWidgets(groupElement, parseFloat(newElement.attr('x')), parseFloat(newElement.attr('y')), parseFloat(newElement.attr('width')), parseFloat(newElement.attr('height')));

		hideOverLay();
		updateCost();

        this.reset();
		return false;
	});


	function polarToCartesian(centerX, centerY, radiusX, radiusY, angleInDegrees) {
		var angleInRadians = angleInDegrees * Math.PI / 180.0;
		var x = centerX + radiusX * Math.cos(angleInRadians);
		var y = centerY + radiusY * Math.sin(angleInRadians);
		return [x,y];
	}


	$('.createCircle').submit(function (event) {
		event.preventDefault();


		var svgSting;
		var newElement;

		var cx = svgCanvas.getResolution().w / 2;
		var cy = svgCanvas.getResolution().h / 2;
		var rx = toPixels(event.delegateTarget.width.value) / 2;
		var ry = toPixels(event.delegateTarget.height.value) / 2;
		var theta = parseFloat(event.delegateTarget.theta.value);

		var start = polarToCartesian(cx, cy, rx, ry, 0);
		var coords = polarToCartesian(cx, cy, rx, ry, theta);

		// svgSting = '<g class="noungroup"></g>';
		// var groupElement = addSVGString(document.querySelector('#svgcontent > g'), svgSting);

		if ($('.createCircle .selectedButton').hasClass('elementellipse')) {
			svgSting = '<ellipse></ellipse>';
			newElement = addSVGString(document.querySelector('#svgcontent > g'), svgSting);
			newElement.attr('cx', cx);
			newElement.attr('cy', cy);
			newElement.attr('rx', rx);
			newElement.attr('ry', ry);
		} else if ($('.createCircle .selectedButton').hasClass('elementcircle')) {
			svgSting = '<circle></circle>';
			newElement = addSVGString(document.querySelector('#svgcontent > g'), svgSting);
			newElement.attr('cx', cx);
			newElement.attr('cy', cy);
			newElement.attr('r', toPixels(event.delegateTarget.r.value));

			rx = toPixels(event.delegateTarget.r.value);
			ry = toPixels(event.delegateTarget.r.value);
		} else if ($('.createCircle .selectedButton').hasClass('elementarc')) {
			if (theta >= 180) {
				svgSting = '<path d="M' + start[0] + ' ' + start[1] +
		           'A ' + rx + ' ' + ry + ', 0, 1, 1, ' + coords[0] + ' ' + coords[1] +
		           'L ' + cx + ' ' + cy + ' Z"/>';
				// svgSting = '<path d="M' + start[0] + ' ' + start[1] +
		  //          'C ' + (cx + rx) + ' ' + (cy + ry) + ', ' + rx + ' ' + ry + ',' + coords[0] + ' ' + coords[1] +
		  //          'L ' + cx + ' ' + cy + ' Z"/>';
			} else {
				svgSting = '<path d="M' + start[0] + ' ' + start[1] +
		           'A ' + rx + ' ' + ry + ', 0, 0, 1, ' + coords[0] + ' ' + coords[1] +
		           'L ' + cx + ' ' + cy + ' Z"/>';
			}
			newElement = addSVGString(document.querySelector('#svgcontent > g'), svgSting);
		}

		newElement.attr('cbs:depth', toPixels(event.delegateTarget.depth.value));
		newElement.attr('cbs:name', encodeURIComponent(event.delegateTarget.cutoutname.value));

		addDepth(newElement);
		// addCavityWidgets(groupElement, cx - rx, cy - ry, rx * 2, ry* 2);

		hideOverLay();
		updateCost();

        this.reset();
		return false;
	});


    function cot(n){
        return 1 / Math.tan(n);
    }

    function sec(n){
        return 1 / Math.cos(n);
    }

	$('.createPolygon').submit(function (event) {
		event.preventDefault();

		// var svgSting = '<g class="noungroup"></g>';
		// var groupElement = addSVGString(document.querySelector('#svgcontent > g'), svgSting);

		var svgSting = '<polygon class="target" />';

		var newElement = addSVGString(document.querySelector('#svgcontent > g'), svgSting);

        var x = (svgCanvas.getResolution().w / 2) - toPixels(event.delegateTarget.radius.value);
        var y = (svgCanvas.getResolution().h / 2) - toPixels(event.delegateTarget.radius.value);
        var cx = (svgCanvas.getResolution().w / 2);
        var cy = (svgCanvas.getResolution().h / 2);
        var edg = Math.sqrt((x - cx) * (x - cx) + (y - cy) * (y - cy)) / 1.5;
        var sides = parseFloat(event.delegateTarget.sides.value);

        var inradius = (edg / 2) * cot(Math.PI / sides);
        var circumradius = toPixels(event.delegateTarget.radius.value);//inradius * sec(Math.PI / sides);
        var points = '';
        for (var s = 0; sides >= s; s++) {
            var angle = 2.0 * Math.PI * s / sides;
            var px = (circumradius * Math.cos(angle)) + cx;
            var py = (circumradius * Math.sin(angle)) + cy;

            points += px + ',' + py + ' ';
        }


		newElement.attr('points', points);
		newElement.attr('cbs:depth', toPixels(event.delegateTarget.depth.value));
		newElement.attr('cbs:name', encodeURIComponent(event.delegateTarget.cutoutname.value));
		addDepth(newElement);
		// var bbox = groupElement[0].getBBox();
		// addCavityWidgets(groupElement[0], bbox.x, bbox.y, bbox.width, bbox.height);

		hideOverLay();
		updateCost();

        this.reset();
		return false;
	});

	$('.createCustom').submit(function (event) {
		event.preventDefault();

		svgCanvas.setMode('path');
		svgCanvas.clearSelection();
		hideOverLay();

		return false;
	});

	$('.unit').click(function () {
		$(document.body).toggleClass('mm');

		$('[data-attribute-unit]').attr('data-attribute-unit',
					document.body.classList.contains('mm')?'mm':'inch');

		appData.editor['is-unit-mm'] = document.body.classList.contains('mm');
		updateUnits();
		rivetsView.sync();

		window.bindedAttributes.selectionChanged();
	});

	$('.measure').click(function(){
		svgCanvas.setMode('ext-measure-tool');
	});

	$('.zoomActual').click(function() {
		window.startZoomAcutal();
	});

	$('.overlay').click(function(event){
		if (event.target === this){
			this.style.display = '';
			hideOverLay();
		}
	});

	$('#tool_poscenter').click(function () {
		svgCanvas.alignSelectedElements('c', 'page');
		svgCanvas.alignSelectedElements('m', 'page');
	});

	$('#tool_posvertical').click(function () {
		svgCanvas.alignSelectedElements('c', 'page');
	});

	$('#tool_poshorizontal').click(function () {
		svgCanvas.alignSelectedElements('m', 'page');
	});

    $('.distributeX').click(function() {
        var e=window.wrapGroupSVG(svgCanvas.getSelectedElems());
        e.distributeX();
        svgEditor.canvas.undoMgr.addCommandToHistory();

        svgCanvas.getSelectedElems().forEach(function (e) {
            svgCanvas.selectorManager.requestSelector(e).resize();
        });
    });

    $('.my-library').tclick(requireLogin(function() {
		showOverLay('.my-shape-library');
    }));

    $('.distributeY').click(function() {
        var e=window.wrapGroupSVG(svgCanvas.getSelectedElems());
        e.distributeY();
        svgEditor.canvas.undoMgr.addCommandToHistory();

        svgCanvas.getSelectedElems().forEach(function (e) {
            svgCanvas.selectorManager.requestSelector(e).resize();
        });
    });

	if ($.url(location.href).param('opendialog')) {
		showOverLay('.' + $.url(location.href).param('opendialog').split('/')[0]);
	}

	if ($.url(location.href).param('state')) {
		document.body.setAttribute('class', $.url(location.href).param('state').split('/')[0]);
	}


	// function foamTableClick (e) {
	// 	var foamTypeCode = ['PE]', 'XPE]','PU]'][$(e.target).parents('td').andSelf().filter('td').index() - 1];
	// 	$('input[value="' + foamTypeCode + '"]').attr('checked', "true");
	// }

	// $('.foam-table').click(foamTableClick);
	$('[data-foam-type]').click(function() {
		appData['order-data'].foamtype = this.getAttribute('data-foam-type');
		hideOverLay();
	});


	addHoldTrigger(document.querySelector('.minusRadius'), function () {
		$('[name="corner"]').toArray().forEach(function (e) {
			e.stepDown();
			// var currentValue = e.valueAsNumber;
			// var step = parseFloat(e.getAttribute('step'));
			// var newValue = currentValue - step;
			// e.value = Math.max(0, newValue - (newValue % step));
			$(e).trigger('input');
		});
	});

	addHoldTrigger(document.querySelector('.plusRadius'), function () {
		$('[name="corner"]').toArray().forEach(function (e) {
			e.stepUp();
			// var currentValue = e.valueAsNumber;
			// var step = parseFloat(e.getAttribute('step'));
			// var newValue = currentValue + step;
			// e.value = newValue - (newValue % step);
			$(e).trigger('input');
		});
	});

	// Not working in Chrome
	window.onbeforeunload = function(e) {
		var confirmationMessage = 'Are you sure you want to leave the CasePro Designer now? Please save your work before leaving.';

		(e || window.event).returnValue = confirmationMessage;     //Gecko + IE
		return confirmationMessage;                                //Gecko + Webkit, Safari, Chrome etc.
	};

});


function csvArrayToDict (csvArray) {
	var dict = {};

	var headers = csvArray.shift();
	csvArray.forEach(function (row) {
		var key = row.shift();
		dict[key] = {};
		dict[_.camelCase(key)] = {};
		row.forEach(function (col, coli) {
			dict[key][headers[coli + 1]] = col;
			dict[key][_.camelCase(headers[coli + 1])] = col;
		});
	});

	return dict;
}

function isNumber(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

function csvArrayToArray (csvArray) {
	var a = [];

	var headers = csvArray.shift();
	csvArray.forEach(function (row) {
		var dict = {};

		row.forEach(function (col, coli) {
			col = col || 'novalue';
			if (isNumber(col)) {
				col = parseFloat(col);
			}
			dict[_.camelCase(headers[coli])] = col;
			dict[headers[coli]] = col;
		});

		a.push(dict);
	});

	return a;
}


var currentOverlaySectionCssSelector;
function showOverLay(cssSelectorToShow) {
	$('.overlay > *').hide();

	if (cssSelectorToShow) {
		currentOverlaySectionCssSelector = cssSelectorToShow;
		$(cssSelectorToShow).show();
	}

	$('.overlay').addClass('show-overlay');
}



function hideOverLay() {
	$('.overlay').removeClass('show-overlay');

	$('.tools .toggle_on').removeClass('toggle_on');

	// Refresh html to stop any videos playing
	$(".overlay .video_tutorial:visible").each(function(i, e) {
		$(e).html($(".overlay :visible").html())
	});
}

$('.close-overlay').click(hideOverLay);

function addElemToWarmingOverlay(elem, bbox, minDistancePixels, color, strokeOpacity, msg) {
	const clone = elem.cloneNode(true);
	clone.id = elem.id + 'cloned-node-for-overlay';
	clone.style.fill = '';
	clone.setAttribute('fill', '#232523');
	clone.setAttribute('stroke', 'none');

	minDistancePixels = minDistancePixels || 5;

	[...elem.attributes].forEach(function(item) {
		if (item.name.indexOf('cbs:') !== -1) {
			clone.removeAttribute(item.name);
		}
	});

	const filterId = clone.id + '-filter-outline';
	const filterString = `
		   <filter id="${filterId}">
		      <feMorphology result="offset" in="SourceGraphic" operator="dilate" radius="${minDistancePixels}"/>
		      <feColorMatrix result="drop" in="offset" type="matrix"
		            values="0.8 0 0 1 1
		                    0.1 0 0 0 0 
		                    0.1 0 0 0 0
		                    0 0 0 1 0" />
		      <feBlend in="SourceGraphic" in2="drop" mode="normal" />
		   </filter>`;

	addSVGString(svgOverlay.svgOverlayElem.querySelector('defs'), filterString);

	clone.setAttribute('opacity', strokeOpacity || 0.5);
	clone.setAttribute('filter', `url(#${filterId})`);
	svgOverlay.svgOverlayElem.appendChild(clone);

	if (bbox && (bbox.width / 27) > 55) {		
		const textElem = document.createElementNS('http://www.w3.org/2000/svg', 'text');
		textElem.textContent = msg || `Shapes must be ${toUnit(minDistancePixels)}${$(document.body).hasClass('mm')?'mm':' inches'} apart`;
		textElem.setAttribute('x', bbox.x + (bbox.width / 2));
		textElem.setAttribute('y', bbox.y + (bbox.height / 2));
		textElem.setAttribute('font-size', bbox.width / 27);
		textElem.setAttribute('dy', bbox.width / 27);
		textElem.setAttribute('text-anchor', 'middle');
		textElem.setAttribute('fill', color || '#FFF');
		svgOverlay.svgOverlayElem.appendChild(textElem);
	}
}

function removeElemToWarmingOverlay(elem) {
	const clone = svgOverlay.svgOverlayElem.getElementById(elem.id + 'cloned-node-for-overlay');
	if (clone) {
		clone.remove();
	}
}

$('.order').click(function () {
	svgOverlay.clear();
	if (checkAllCavityDepth()) {
		showOverLay('.violationWarningPopup');
		return;
	}

	var minDistance = 0;
	min_spacing.forEach( function (min_space) {
		if (appData['current-case'].length >= parseFloat(min_space.case_length)){
			minDistance = parseFloat(min_space.min_distance);
		}
	});

	appData['current-case']['min-cavity-distance'] = minDistance;
	minDistance = toUnit(inchesToPixels(minDistance));


	const bboxListAndElems = [...document.querySelectorAll('#svgcontent > g > .target')]
		.map(elem => {
			return {elem, 'bbox': svgCanvas.getStrokedBBox([elem]), 'parentNode': elem.parentNode}
		});

	const minDistancePixels = toPixels(minDistance);
	var bboxList = bboxListAndElems.map(function (bboxObject) {
		bboxObject.bbox.x -= minDistancePixels / 2;
		bboxObject.bbox.y -= minDistancePixels / 2;
		bboxObject.bbox.width += minDistancePixels;
		bboxObject.bbox.height += minDistancePixels;

		return bboxObject;
	});
	console.log({minDistance, minDistancePixels});

	bboxList = bboxList.filter(function (bbox) {
		return ($(bbox.elem).attr('class') || '').indexOf('target') !== -1;
	});

	const allObjects = [...document.querySelectorAll('#svgcontent > g > *')].filter(e => e.nodeName.toLowerCase() !== 'title');

	const bboxListPromises = bboxList.map(b => {
		if (b.elem.nodeName.toLowerCase() === 'image') {
			return new Promise(function(resolve, reject) {
				svgFuncs.svgImageToGroup(b.elem).then(e => {
					[...e.querySelectorAll('text, title')].forEach(e => e.remove());

					b.transformed = e;
					resolve(b)
				}).catch(reject)
			});
		} else {
			return b;
		}
	})


	const overlappingElems = [];
	let overlap = false;
	Promise.all(bboxListPromises).then(bboxListTransformed => {
		allObjects.forEach(e => {
			e.removeAttribute('filter');
			e.style.display = 'none';
		});

		bboxListTransformed.forEach(b => b.elem.remove());
		const defsElemRef = document.querySelector('#svgcontent defs');
		defsElemRef.remove();

		k_combinations(bboxListTransformed, 2).forEach(function (combin) {
			let [bbox, bbox2] = combin;
			if (!overlap && bbox.elem !== bbox2.elem && !(bbox.parent && bbox.parent === bbox2.parent)) {
				const currentOverlap = svgedit.math.rectsIntersect(bbox.bbox, bbox2.bbox);
				overlap = overlap || currentOverlap;
				if (currentOverlap) {
					try {
						function renderSvgToCanvas(canvasString, canvasProp) {
							canvasProp.elem.setAttribute('stroke-width', minDistancePixels);
							canvasProp.elem.setAttribute('stroke', '#00F');

							if (canvasProp.transformed) {
								canvasProp.parentNode.appendChild(canvasProp.transformed);
								[...canvasProp.transformed.querySelectorAll('*')].forEach(e => {
									e.setAttribute('stroke-width', minDistancePixels);
									e.setAttribute('stroke', '#00F');
									e.setAttribute('fill', '#00F');
									e.removeAttribute('style');
								});
							} else {
								canvasProp.elem.style.display = '';
								canvasProp.parentNode.appendChild(canvasProp.elem)
							}

							document.getElementById(canvasString).width = document.getElementById("svgcontent").getAttribute('width');
							document.getElementById(canvasString).height = document.getElementById("svgcontent").getAttribute('height');

							document.getElementById(canvasString).getContext("2d").clearRect(0, 0, document.getElementById(canvasString).width, document.getElementById(canvasString).height);
							canvg(canvasString, document.getElementById("svgcontent").outerHTML, { log: true, ignoreMouse: true, ignoreAnimation: true, ignoreDimensions: true });
							if (canvasProp.transformed) {
								canvasProp.transformed.remove();
							} else {
								canvasProp.elem.remove()
							}	
							canvasProp.elem.setAttribute('stroke-width', 0);
							canvasProp.elem.setAttribute('stroke', 'none');


							return document.getElementById(canvasString).getContext("2d").getImageData(0, 0, document.getElementById(canvasString).width, document.getElementById(canvasString).height);
						}

						const imgd = renderSvgToCanvas('canvas', bbox);
						const imgd2 = renderSvgToCanvas('canvas2', bbox2);

						let isOverlap = false;
						// Loop over each pixel and invert the color.
						for (let i = 0, n = imgd.data.length; i < n; i += 4) {
						    if ((imgd.data[i] !== 0 || imgd.data[i+1] !== 0 || imgd.data[i+2] !== 0) &&
						    		(imgd2.data[i] !== 0 || imgd2.data[i+1] !== 0 || imgd2.data[i+2] !== 0)) {
							    isOverlap = true;
								break;
						    }
						}

						if (isOverlap) {
							overlappingElems.push(bbox);
							overlappingElems.push(bbox2);
							console.log('isOverlap', bbox.elem, bbox2.elem);	
						}
						overlap = isOverlap;
					} catch (e) {
						overlappingElems.push(bbox);
						overlappingElems.push(bbox2);
						console.error(e);
					}
				}
			}
		});

		document.querySelector('#svgcontent').appendChild(defsElemRef);
		bboxListTransformed.forEach(b => b.parentNode.appendChild(b.elem));
		allObjects.forEach(e => {
			// e.removeAttribute('filter');
			e.style.display = '';
		});

		_.unique(overlappingElems)
			.forEach(e => addElemToWarmingOverlay(e.elem, e.bbox, minDistancePixels));

		if (overlap) {
			global.alert('Cavities are closer than the minimum distance of '
				+ (Math.round(minDistance * 100) / 100)
				+ '<span class="unitSymbol"></span>');
			updateUnits();
		} else {
			showOverLay('.orderForm');
		}
	})

});

function moveRowToDict(dictName, rows) {
	var dict = {};

	rows.forEach(function (row) {
		var entryName = row[dictName];
		dict[entryName] = dict[entryName] || [];
		dict[entryName].push(row);
	});

	return Object.keys(dict).map(function(k) {
		return {
			'name': k,
			'title': dictName,
			'firstRow': dict[k][0],
			'data': dict[k]
		}
	});
}

$.get(serverURL + 'foam data.csv', function (csvData) {
	foam_sku = csvArrayToDict($.csv.toArrays(csvData));
});
var svgLibraries = {};
var a;
$.get(serverURL + 'shape libraries.csv', function (csvData) {

	// console.log(
	// 	_.values(svgLibraries).map(function(a) {
	// 		return _.values(a);
	// 	})
	// );

	// shapesList.forEach(function (row) {
	// 	svgLibraries[row['Library Name']] = svgLibraries[row['Library Name']] || {};
	// 	svgLibraries[row['Library Name']][row.accordion_name] =
	// 				svgLibraries[row['Library Name']][row.accordion_name] || {
	// 					'name': row.accordion_name,
	// 					'shapes': []
	// 				};

	// 	svgLibraries[row['Library Name']][row.accordion_name].shapes.push(row);
	// });


	var dataRow = csvArrayToArray($.csv.toArrays(csvData));

	dataRow = dataRow.filter(function(row) {
		return row.shapeUiIcon &&
			row.shapeSvg &&
			row.accordionImage;
	});

	dataRow
	.forEach(function (row) {
		row.shapeUiIcon = serverURL + 'svgs/' + row.shapeUiIcon;
		row.shapeSvg = serverURL + 'svgs/' + row.shapeSvg;
		row.accordionImage = serverURL + row.accordionImage;
	})

	var librariesGrouped = moveRowToDict('Library Name', dataRow);

	Object.keys(librariesGrouped).forEach(function(keyName) {
		librariesGrouped[keyName].data = moveRowToDict('Brand', librariesGrouped[keyName].data);
		librariesGrouped[keyName].data.forEach(function(row) {
			row.data = moveRowToDict('accordionName', row.data);
		});
	});
	console.table(JSON.stringify(librariesGrouped[0]));

	appData['case-cavities-library'].svgLibraries = librariesGrouped;


	function toggleEvent(event) {
		showOverLay();

		$(this).addClass('toggle_on');

		openLibraryTab(document.querySelector('.tab'));

		event.delegateTarget.getAttribute('data-toggle').split(' ').forEach(function (selector) {
			var targetElementSelector = '.' + selector;
	        $(targetElementSelector).show();
	        if (document.querySelector(targetElementSelector + ' input')) {
		        document.querySelector(targetElementSelector + ' input').focus();
		    }

		    if (event.delegateTarget.hasAttribute('data-togglecenter')) {
	            var pos   = $(event.delegateTarget).offset();
	            var width = $(event.delegateTarget).width();


	            $(targetElementSelector)
	            .css({
	            	"left": Math.max(10, 8 + pos.left + (width / 2) - ($(targetElementSelector).width() / 2)) + "px",
	            });
		    }

		    if (event.delegateTarget.hasAttribute('data-togglemiddle')) {
	            var pos   = $(event.delegateTarget).offset();
	            var height = $(event.delegateTarget).height();


	            $(targetElementSelector)
	            .css({
	            	"top": pos.top + (height / 2) - ($(targetElementSelector).height() / 2) + "px",
	            });
		    }
		});
	}

	// var hammertime = $("[data-toggle]").hammer();

	// // the whole area
	// hammertime.on("tap dragend", function(ev) {
	//   toggleEvent(ev);
	// });

	$("[data-toggle]").tclick(toggleEvent);
});

var promises = [];

promises.push(
	$.get(serverURL + 'svg.csv', function (csvData) {
		caseLookup = csvArrayToDict($.csv.toArrays(csvData));
		shapesList = csvArrayToArray($.csv.toArrays(csvData));

		groupedCaseLookup = {}
		shapesList.forEach (function (row) {
			if (!(row["Product ID"] in groupedCaseLookup)) {
				groupedCaseLookup[row["Product ID"]] = [];
			}

			groupedCaseLookup[row["Product ID"]].push(row);
		});
	})
);

var getCSVData = function (dicName, fileName) {
	promises.push(
		$.get(serverURL + fileName, function (csvData) {
			window[dicName] = csvArrayToArray($.csv.toArrays(csvData));
			console.table(csvArrayToArray($.csv.toArrays(csvData)));

			// resolver.resolve();
		})
	);
};

// $.get(serverURL + 'total cavity tier price.csv', function (csvData) {
// 	cavityPrices = csvArrayToArray($.csv.toArrays(csvData));
// });
// $.get(serverURL + 'user accounts.csv', function (csvData) {
// 	userAccounts = csvArrayToDict($.csv.toArrays(csvData));
// });
// $.get(serverURL + 'min_cavity_spacing.csv', function (csvData) {
// 	min_spacing = csvArrayToArray($.csv.toArrays(csvData));
// });


getCSVData('cavityPrices', 'total cavity tier price.csv');
getCSVData('min_spacing', 'min_cavity_spacing.csv');
getCSVData('adderPricing', 'adder pricing.csv');

// var cvsPromise = Promise.every([getCSVData('cavityPrices', 'total cavity tier price.csv'),
// 	getCSVData('userAccounts', 'user accounts.csv'),
// 	getCSVData('min_spacing', 'min_cavity_spacing.csv'),
// 	getSVGCSVData]);


$('.size-select .pressable').click(function(e) {
	if ($(this).index() === 0) {
		loadCase(groupedCaseLookup['small'][0]['Part #']);
	} else if ($(this).index() === 1) {
		loadCase(groupedCaseLookup['medium'][0]['Part #']);
	} else if ($(this).index() === 2) {
		loadCase(groupedCaseLookup['large'][0]['Part #']);
	} else if ($(this).index() === 3) {
		loadCase(groupedCaseLookup['extra-large'][0]['Part #']);
	}
});


// var img = $('<div></div>');
// $.get(serverURL + 'svgs/' + row[3], function (cavitysvg) {
// 	console.log(cavitysvg);
// 	var svgElem = $(cavitysvg).find('svg')[0];
// 	$(svgElem).addClass('target');
// 	if (svgElem.classList) {
// 		svgElem.classList.add('target');
// 	}
// 	img.append($(svgElem));
// 	$(svgElem).unwrap();
// });

// svgContainer.append(img);
// svgContainer.append($('<span>' + row[1] + '</span>'));


function addCavityWidgets(groupElement, x, y, width, height) {

	// var widgetSize = height / 7;
	// var centerX = x + (width / 2) - (widgetSize / 2);
	// var centerY = y + (height / 2) - (widgetSize / 2);

	// svgSting = '<image class="propertiesButton" x="' + centerX + '" y="' + (centerY - (widgetSize * 1.3)) + '" width="'+ widgetSize + '" height="'+ widgetSize + '" xlink:href="extensions/casebysource/properties.png"/>';
	// var propertiesButton = addSVGString(groupElement, svgSting);

	// svgSting = '<image class="lock" x="' + centerX + '" y="' + (centerY + (widgetSize * 1.3)) + '" width="'+ widgetSize + '" height="'+ widgetSize + '" xlink:href="extensions/casebysource/lock.png"/>';
	// var lockButton = addSVGString(groupElement, svgSting);

	// addCavityWidgetEvents(lockButton, propertiesButton);
}




$(".lock-unlock").click(function () {
	var elem = svgCanvas.getSelectedElems().filter(Boolean)[0];

	if (elem.classList.contains('locked')) {
		unlock();
	} else {
		lock();
	}
});


function lock() {
	svgCanvas.getSelectedElems().filter(Boolean)
		.forEach(function(elem) {
			elem.classList.add('noresize');
			elem.classList.add('nomove');
			elem.classList.add('norotate');
			elem.classList.add('locked');

			var selected = svgCanvas.getSelectedElems();
			svgCanvas.clearSelection();
			svgCanvas.addToSelection(selected);
		});
}

function unlock() {
	svgCanvas.getSelectedElems().filter(Boolean)
		.forEach(function(elem) {
			if (elem.localName !== 'image') {
				elem.classList.remove('noresize');
			}
			elem.classList.remove('nomove');
			elem.classList.remove('norotate');
			elem.classList.remove('locked');

			var selected = svgCanvas.getSelectedElems();
			svgCanvas.clearSelection();
			svgCanvas.addToSelection(selected);
		});
}

function roundCoords(d) {
	return Math.round(d * 10000) / 10000;
}


function updateProperties (elems) {
	var nonGribElems = elems.filter(function(e) {
		return !e.classList.contains('grip')
	});

	if (nonGribElems.length === 0) {
		document.body.classList.remove('singleselected');
		return;
	}

	$('.editProperties label').hide();
	$('.add_leftrightgrips').hide();

	if (elems.length > 1) {
		$('.add-shape-from-selected').show();
	} else {
		$('.add-shape-from-selected').hide();
	}
	
	if (nonGribElems.length > 1) {
		$('[data-attribute="dimention-x"]').parent().show().removeAttr('disabled');
		$('[data-attribute="dimention-y"').parent().show().removeAttr('disabled');

		var bbox = svgUtils.bboxOfManyBbox(nonGribElems.map(function(e) {
					return svgMatrixUntils.getBbox(e, null, true);
				}))

		$('[data-attribute="dimention-width"]').attr('disabled', true).parent().show().val(bbox.width);
		$('[data-attribute="dimention-height"').attr('disabled', true).parent().show().val(bbox.height);
		$('.editProperties [name="r"]').parent().hide();

		$('.add_grips').hide();
		$('[data-attribute="depth"]').attr('disabled', true).parent().show();

		document.querySelector('[data-attribute="depth"]').value = 
			toUnit(
				Math.max.apply(null, nonGribElems.map(function(e) {
					return parseFloat(e.getAttribute('cbs:depth'));
				}))
			);

		document.querySelector('.lock-unlock').textContent = nonGribElems.every(function(e) {
			return e.classList.contains('locked');
		})?'unlock':'lock';
	} else {
		var elem = nonGribElems[0];

		document.querySelector('.lock-unlock').textContent = elem.classList.contains('locked')?'unlock':'lock';

		$('.editProperties [disabled]').removeAttr('disabled');

		$('.editProperties [name="angle"]').parent().show();
		$('.add_grips').show();

		if ($('[data-ymiddle="' + elem.id + '"]').length) {
			$('.add_leftrightgrips select').val('leftright');
		} else if ($('[data-xmiddle="' + elem.id + '"]').length) {
			$('.add_leftrightgrips select').val('topbottom');
		} else {
			$('.add_leftrightgrips select').val('');
		}

		if (nonGribElems.some(function(e) {
			return e.classList.contains('noeditdepth');
		})) {
			$('[data-attribute="depth"]').attr('disabled', 'true');
		} else {
			$('[data-attribute="depth"]').removeAttr('disabled');
		}
		switch (elem.nodeName) {
			case 'rect':
				$('[data-attribute="name"]').parent().show();
				$('[data-attribute="depth"]').parent().show();
				$('[data-attribute="dimention-width"]').parent().show();
				$('[data-attribute="dimention-height"]').parent().show();
				$('[data-attribute="dimention-x"]').parent().show();
				$('[data-attribute="dimention-y"]').parent().show();
				$('.editProperties [name="corner"]').parent().show();
				$('.editProperties [name="r"]').parent().hide();

				$('.add_leftrightgrips').show();
				$('.add_grips').hide();
			break;
			case 'g':
				$('[data-attribute="name"]').parent().show();
				$('[data-attribute="dimention-x"]').parent().show();
				$('[data-attribute="dimention-y"').parent().show();
				$('.add-shape-from-selected').show();
				$('.add_grips').hide();
			break;
			case 'image':
				$('[data-attribute="name"]')
					.attr('disabled', 'true').parent().show();

				$('[data-attribute="depth"]')
					.attr('disabled', 'true').parent().show();
				$('[data-attribute="dimention-width"]')
					.attr('disabled', 'true').parent().show();
				$('[data-attribute="dimention-height"]')
					.attr('disabled', 'true').parent().show();
				$('.editProperties [name="r"]').parent().hide();

				$('[data-attribute="dimention-x"]').parent().show();
				$('[data-attribute="dimention-y"]').parent().show();
			break;
			case 'ellipse':
				$('[data-attribute="name"]').parent().show();
				$('[data-attribute="depth"]').parent().show();
				$('[data-attribute="dimention-width"]').parent().show();
				$('[data-attribute="dimention-height"]').parent().show();
				$('[data-attribute="dimention-x"]').parent().show();
				$('[data-attribute="dimention-y"]').parent().show();
				$('.editProperties [name="r"]').parent().hide();

				$('.add_leftrightgrips').show();
				$('.add_grips').hide();

			break;
			case 'circle':
				$('[data-attribute="name"]').parent().show();
				$('[data-attribute="depth"]').parent().show();
				$('[data-attribute="dimention-x"]').parent().show();
				$('[data-attribute="dimention-y"]').parent().show();
				$('.editProperties [name="angle"]').parent().hide();

				$('.editProperties [name="r"]').parent().show();
				$('.add_leftrightgrips').show();
				$('.add_grips').hide();
			break;
			case 'polygon':
			case 'path':
				$('[data-attribute="name"]').parent().show();
				$('[data-attribute="depth"]').parent().show();

				$('[data-attribute="dimention-x"]').parent().show();
				$('[data-attribute="dimention-y"]').parent().show();
			break;
		}
		if (elem.classList.contains('locked')) {
			$('.editProperties label').attr('disabled', 'true');
		}
	}

}





(function ($, svgEditor, addSVGString, hideOverLay, baseURL) {
	'use strict';
	svgEditor.addExtension('ext-zoom-actual', function() {
		var savedZoom;
		var inZoomMode = false;

		function startZoomAcutal () {
			window.svgCanvas.setMode('ext-zoom-actual');

			hideOverLay();
			if (savedZoom) {
				$('.actual-zoom-info').show();
				window.svgCanvas.setZoom(savedZoom);
				svgEditor.updateCanvas();
				window.svgCanvas.setMode('select');
				$('.actual-zoom-info').show();
			} else {
				inZoomMode = false;
				$('.toggle_on').removeClass('toggle_on');
				addSVGString($('#svgcontent')[0], 
					'<image xlink:href="' + baseURL + 'images/casebysource/caseruler.svg" x="' +
					((window.svgCanvas.getResolution().w - 633)/2) + '" y="' +
					((window.svgCanvas.getResolution().h - 188)/2) +
					'" width="633" height="188" class="zoom_diagram" />');
				$('.zoomActualPopup').show();
				savedZoom = window.svgCanvas.getZoom();
				svgEditor.updateCanvas(true);							
			}
		}

		window.startZoomAcutal = startZoomAcutal;

		$('.actual-zoom-info').click(function () {
			savedZoom = null;
			startZoomAcutal();
			$('.actual-zoom-info').hide();
		});

		$('.lockZoom').click(function () {
			$('.zoomActualPopup').hide();
			$('.zoom_diagram').remove();
			window.svgCanvas.setMode('select');
			inZoomMode = true;
			$('.actual-zoom-info').show();
		});

		$('.closeLockZoom').click(function () {
			$('.zoomActualPopup').hide();
			$('.zoom_diagram').remove();
			window.svgCanvas.setMode('select');
			savedZoom = null;
		});

		return {
			name: 'Extension Zoom Actual',
			buttons: [{
				id: 'ext-zoom-actual',
				title: 'Zoom Actual',
				events: {
					click: function() {
					}
				}
			}],
			zoomChanged: function () {
				if (window.svgCanvas.getMode() === 'ext-zoom-actual') {
					if ($('.zoom_diagram').length > 0) {
						svgEditor.updateCanvas(true);							
						savedZoom = window.svgCanvas.getZoom();
					} 
				} else if(!inZoomMode) {
					$('.actual-zoom-info').hide();
				}
				if (inZoomMode) {
					global.confirm('Would you like to leave Zoom Actual (1:1) mode? If you would like to return to Zoom Actual, don\'t worry you don\'t have to match rulers again. We saved your setting. Simply press the Zoom Actual icon.', 
						function (okay) {
							if (okay) {
								$('.actual-zoom-info').hide();
								inZoomMode = false;
							} else {
								window.svgCanvas.setZoom(savedZoom, true);
								svgEditor.updateCanvas();							
							}
						});				
				}
			},
			mouseDown: function() {
			}
		};
	});
})(window.jQuery, window.svgEditor, window.addSVGString, window.hideOverLay, window.baseURL);

/*
 * ext-grid.js
 *
 * Licensed under the Apache License, Version 2
 *
 * Copyright(c) 2010 Redou Mine
 * Copyright(c) 2010 Alexis Deveria
 *
 */

// Dependencies:
// 1) units.js
// 2) everything else

svgEditor.addExtension('view_grid', function() {

	var NS = svgedit.NS,
		svgdoc = document.getElementById('svgcanvas').ownerDocument,
		showGrid = true,
		assignAttributes = svgEditor.canvas.assignAttributes,
		hcanvas = document.createElement('canvas'),
		canvBG = $('#canvasBackground'),
		units = svgedit.units.getTypeMap(),
		intervals = [0.01, 0.1, 1, 10, 100, 1000];

	$(hcanvas).hide().appendTo('body');

	var canvasGrid = svgdoc.createElementNS(NS.SVG, 'svg');
	assignAttributes(canvasGrid, {
		'id': 'canvasGrid',
		'width': '100%',
		'height': '100%',
		'x': 0,
		'y': 0,
		'overflow': 'visible',
		'display': 'none'
	});
	canvBG.append(canvasGrid);

	// grid-pattern
	var gridPattern = svgdoc.createElementNS(NS.SVG, 'pattern');
	assignAttributes(gridPattern, {
		'id': 'gridpattern',
		'patternUnits': 'userSpaceOnUse',
		'x': 0, //-(value.strokeWidth / 2), // position for strokewidth
		'y': 0, //-(value.strokeWidth / 2), // position for strokewidth
		'width': 100,
		'height': 100
	});

	var gridimg = svgdoc.createElementNS(NS.SVG, 'image');
	assignAttributes(gridimg, {
		'x': 0,
		'y': 0,
		'width': 100,
		'height': 100
	});
	gridPattern.appendChild(gridimg);
	$('#svgroot defs').append(gridPattern);

	// grid-box
	var gridBox = svgdoc.createElementNS(NS.SVG, 'rect');
	assignAttributes(gridBox, {
		'width': '100%',
		'height': '100%',
		'x': 0,
		'y': 0,
		'stroke-width': 0,
		'stroke': 'none',
		'fill': 'url(#gridpattern)',
		'style': 'pointer-events: none; display:visible;'
	});
	$('#canvasGrid').append(gridBox);

	function updateGrid(zoom) {
		// TODO: Try this with <line> elements, then compare performance difference
		var unit = units[svgEditor.curConfig.baseUnit]; // 1 = 1px
		var u_multi = unit * zoom;
		// Calculate the main number interval
		var raw_m = 10 / u_multi;
		var multi = 1;
		for(var i = 0; i < intervals.length; i++) {
			var interval = intervals[i];
			if ($(document.body).hasClass('mm')) {
				interval *= 96 / 25.4;
			} else {
				interval *= 96;
			}
			var num = interval;
			multi = num;
			if(raw_m <= num) {
				break;
			}
		}
		var big_int = multi * u_multi;

		// Set the canvas size to the width of the container
		hcanvas.width = big_int;
		hcanvas.height = big_int;
		var ctx = hcanvas.getContext('2d');
		var cur_d = 0.5;
		var part = big_int / 10;

		ctx.globalAlpha = 0.2;
		ctx.strokeStyle = svgEditor.curConfig.gridColor;
		// for (var i = 1; i < 10; i++) {
		// 	var sub_d = Math.round(part * i) + 0.5;
		// 	// var line_num = (i % 2)?12:10;
		// 	var line_num = 0;
		// 	ctx.moveTo(sub_d, big_int);
		// 	ctx.lineTo(sub_d, line_num);
		// 	ctx.moveTo(big_int, sub_d);
		// 	ctx.lineTo(line_num ,sub_d);
		// }
		ctx.stroke();
		ctx.beginPath();
		ctx.globalAlpha = 0.1;
		ctx.moveTo(cur_d, big_int);
		ctx.lineTo(cur_d, 0);

		ctx.moveTo(big_int, cur_d);
		ctx.lineTo(0, cur_d);
		ctx.stroke();

		var datauri = hcanvas.toDataURL('image/png');
		gridimg.setAttribute('width', big_int);
		gridimg.setAttribute('height', big_int);
		gridimg.parentNode.setAttribute('width', big_int);
		gridimg.parentNode.setAttribute('height', big_int);
		svgEditor.canvas.setHref(gridimg, datauri);
	}

	return {
		name: 'view_grid',
		svgicons: 'extensions/grid-icon.xml',

		zoomChanged: function(zoom) {
			updateGrid(zoom);
		},

		buttons: [{
			id: 'view_grid',
			type: 'context',
			panel: 'editor_panel',
			title: 'Show/Hide Grid',
			events: {
				click: function() {
					svgEditor.curConfig.showGrid = true;
					updateGrid(svgEditor.canvas.getZoom());
					$('#canvasGrid').toggle(showGrid);
					$('#view_grid').toggleClass('push_button_pressed tool_button');
				}
			}
		}]
	};
});

/*
	Save, open and order ajax code
*/

var SAVE_ORDER_URL = '/builder/saveorder';
var OPEN_CASES_URL = '/builder/open_cases';
var LOGIN_URL = '/services/login';
var PRODUCTS_URL = '/services/product/';
var SAVE_CASE_URL = '/builder/filesave';
var HIDDEN_USER_FILE_NAME = 'useriiiiiiiiiiiiiiiiiiiishapes';


$.ajaxSetup({ cache: false });

function serverError (extraAjaxInfo) {
	return function (e) {
		console.error(e);
		console.trace();
		global.alert('Error communicating with the server. Please contact support.');
		Rollbar.error('Error communicating with the server. ' + JSON.stringify([extraAjaxInfo, e, appData.user]));
	};
}

function updateProductDataFromServer() {
	$.getJSON(PRODUCTS_URL + appData['order-data'].productId, function (jsonData) {
    	console.log('/services/product/', jsonData);
		qty: appData['order-data'].adders = jsonData.adders;

	}).fail(serverError(PRODUCTS_URL + appData['order-data'].productId));
}

var FileSystem = function () {
	'use strict';
	var _this = {};

	var _saved = location.href.split('/').indexOf('open') !== -1;
	var _fileName;

	_this.isSaved = function () {
		return _saved;
	};

	_this.save = function (fileName) {
		_saved = true;
		_fileName = fileName;
	};

	return _this;
};

var fileSystem = new FileSystem();

function getOrderData (cb) {
	var saveData = {
		'output_svg': encodeURI(svgCanvas.getSvgString()),
		//TODO - case name add.
		'filename': appData['current-case'].name || 'unnamed case',
		//TODO - part number add.
		'partNumber': appData['order-data'].color,
		'variation_id': 100, // Unused
		'length': currentPartInfo.Length,
		'width': currentPartInfo.Width,
		'height': currentPartInfo.Height,
		'cornerRadius': 0, // Unused
		'isCustom': $('.partnumber').text() === "Custom Size"?1:0,
		'u_of_m': $(document.body).hasClass('mm')?'mm':'in',
		'interior_sku': appData['order-data'].foamtype,
		'addOnId': getAdders(),
		'qty': appData['order-data'].quanity,
		'number_of_cavities': $('.numberofcavities').text(),
		//TODO - Acumium - issue with length not saving
        'case_length': currentPartInfo.Length
	};
	cb(saveData);
}


var sendOrder = function (e) {
	e.preventDefault();
	getOrderData(function (saveData) {
		svgCanvas.svgCanvasToString(true, true, function (svgString) {
			// TODO - CBS - Added svg converted for download and renderer
			saveData.png_output_svg = encodeURI(svgString);
			// saveData.design_output_svg = encodeURI(svgString);
//			saveData.orig_output_svg = saveData.output_svg;

			// Post svg data to server.
			var form = $('<form/>');
			form.attr('action', SAVE_ORDER_URL);
			form.attr('method', 'post');

			for (var key in saveData) {
				if (Object.prototype.toString.call(saveData[key]) === '[object Array]') {
					saveData[key].forEach(function(v) {
						form.append('<input type="hidden" name="'+ key + '[]" value="' + v + '"" />');
					});
				} else {
					console.log(key, saveData[key]);
					form.append('<input type="hidden" name="'+ key + '" value="' + saveData[key] + '" />');
				}
			}

			// BEN - If the project has been saved send the form immediately
			// if (fileSystem.isSaved()) {
				$('.overlay, .orderForm').hide();
				// TODO
				// form[0].elements['design_name'].value = $('.savedCaseName').text();

				window.onbeforeunload = function() {};
				$(document.body).append(form);
				console.log(form);
				form.submit();
			// }
		});
	});
};

$('.orderForm').submit(sendOrder);

(function ($, appData, _) {
	'use strict';

	window.loadUserShapesFile = function (callback) {
		$.get(OPEN_CASES_URL, function( data ) {
			var userShapesEntry = 
				$(data).find('a').toArray()
					.filter(function(e){
						return e.textContent.trim() === HIDDEN_USER_FILE_NAME;
					})[0];

			if (userShapesEntry) {
				var userShapesFileUrl = decodeURIComponent
					(window.getQueryParameters(userShapesEntry.search)['open-case']);

				console.log('Opening user library data ', userShapesFileUrl);
				$.get(userShapesFileUrl, function(svgFile) {
					callback(JSON.parse(svgFile.documentElement.textContent));
				});
				console.log(userShapesFileUrl);				
			} else {
				console.log('User library not found.', HIDDEN_USER_FILE_NAME);
			}
		})
		.error(function () {
			global.alert('Server error. User shapes did not load');
		});
	};

	window.saveShapeLibrary = function (data, callback) {
		getOrderData(function (saveData) {
			saveData.output_svg = encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" xlinkns="http://www.w3.org/1999/xlink" width="1" height="1" x="1" y="1">' + JSON.stringify(data) + '</svg>');
			saveData.filename = HIDDEN_USER_FILE_NAME;
			saveData.design_description = HIDDEN_USER_FILE_NAME;
			saveData.design_name = HIDDEN_USER_FILE_NAME;

			$.ajax({
				'url': SAVE_CASE_URL,
				'type': 'POST',
		    	'cache': false,
				'data': saveData
			})
			.success(function () {
				callback();
			})
			.error(function () {
				global.alert('Server error. Unable to save file');
			});
		});
	};

	$('.saveCaseForm').submit(function (event) {
		event.preventDefault();

		$('.sendSaveData').click();
		return false;
	});

	$('.sendSaveData').click(function (event) { // TODO use submit
		event.preventDefault();
		event.stopPropagation();
		$('.overlay').hide();

		getOrderData(function (saveData) {
			saveData.design_name = appData['current-case'].name;
			saveData.design_description = appData['current-case'].description;

			$.ajax({
				'url': SAVE_CASE_URL,
				'type': 'POST',
		    	'cache': false,
				'data': saveData
			})
			.success(function () {
				global.alert('Case ' + saveData.design_name + ' saved');
				fileSystem.save(saveData.design_name);
				$('.savedCaseName').text(saveData.design_name);
			})
			.error(function () {
				global.alert('Server error. Unable to save file');
			});
		});
	});

	$('.openCase').click(function () {
		$.get(OPEN_CASES_URL, function( data ) {

		  	$( '.picklayout .container').html(data);
			
			// Remove user shapes entry
			var userShapesEntry = 
				$( '.picklayout .container').find('a').toArray()
					.filter(function(e){
						return e.textContent === HIDDEN_USER_FILE_NAME;
					})[0];

			if (userShapesEntry) {
				var rowToRemove = userShapesEntry.parentNode.parentNode;
				rowToRemove.parentNode.removeChild(rowToRemove);			
			}

			$('.picklayout .container tr').find('[title="Open Project"]')
				.each(function(i, e) {
					if (appData.customUserData.deleteFiles[$(e).attr('href')]) {
						$(e).parents('tr').remove();
					}
				});

		  	$('.picklayout h2').text('My Projects');
		  	$('.picklayout th:nth-child(1)').text('Project Name');
		  	$('.picklayout th:nth-child(3)').text('Case');
		  	$('.picklayout th:nth-child(4)').text('Last Modified');
		  	$('.picklayout td:nth-child(5) a')
		  		.text('')
		  		.attr('style', 'background: url(/images/casebysource/saveopen.png);width: 31px;height: 29px;display: inline-block; margin-bottom: -7px;');

		  	var deleteButton = $('<button type="button">Delete File</button>');

	  		deleteButton.click(function() {
	  			$(this).parents('tr').find('[title="Open Project"]').attr('href');
	  			$(this).parents('tr').remove();

	  			appData.deleteFile($(this).parents('tr').find('[title="Open Project"]').attr('href'));
	  		});
	  		deleteButton.attr('style', 'margin-left: 14px;');
	  		$('.picklayout td:nth-child(5)').append(deleteButton);

		  	// $('.picklayout td:nth-child(5)').append('<img class="button delete-case" src="images/delete.png"/>').hide();
		}).error(function() {
		  	$( '.picklayout .container').html('Error: server did not respond.');
		});
	});

	['faq', 'video_tutorial', 'user_guide', 'price_calculated', 'zoom_actual_tutorial', 'terms_of_use'].forEach(function (sectionClass) {
		$.get(window.serverURL + sectionClass + '.html', function( data ) {
		  	$('.' + sectionClass + ' .popup-content').html( data );
		}).error(function() {
		  	$('.' + sectionClass + ' .popup-content').html('Error: server did not respond.');
		});
	});


	$('.login-user').click(function(e) {
		e.stopPropagation();
		e.preventDefault();

		const ajaxData = {
		    'url': LOGIN_URL,
		    'type': 'POST',
		    'data': {
		    	'email': document.querySelector('[name="email"]').value,
		    	'password': document.querySelector('[name="password"]').value
		    },
		    'cache': true,
		    'dataType': 'json',
		    'error': serverError,
		    'success': function(jsonData) {
		    	console.log('/services/login', jsonData);
		    	appData.user.loggedIn = jsonData.result;

		    	if (appData.user.loggedIn) {
		    		global.alert('Login successful.');
		    		window.loadUserData();
		    	} else {
		    		global.alert('Login details are incorrect.');
		    	}

		    	if (window.Rollbar) {	    		
			    	Rollbar.configure({
						payload: {
							user: appData.user
						}
					});
		    	}
		    	if ('error' in jsonData) {
		    		serverError();
		    	}
	   	    }
		};
		ajaxData.error = serverError(JSON.stringify(_.omit(ajaxData, 'data')));
		$.ajax(ajaxData);

		window.hideOverLay();
	});

})(window.jQuery, appData, window._);

function loadFromFile (url, callback) {
	$.ajax({
	    'url': url,
	    'type': 'GET',
	    'dataType': 'text',
	    'cache': false,
	    'error': serverError(url, 'GET'),
	    'success': function(xml){
			$(document).ready(function () {
				svgEditor.ready(function () {
					svgCanvas.setSvgString(xml, true);
					svgEditor.zoomDelta(-1);
					callback(xml);
				});
			});
	    }
	});
}

/* 
	Sets foam type, distance unit, and opens documents
*/

var USER_INFO_URL = '/builder/ajax-get-user-information';

function loadUserData() {
	$.getJSON(USER_INFO_URL, function (userData) {
		Object.keys(userData).forEach(function(k) {
			userData[_.camelCase(k)] = userData[k];
		});

		window.appData.user.isAdmin = userData['is-admin'] || false;
		window.appData.user.name = userData.user_name;
    	window.appData.user.loggedIn = userData.is_logged_in !== 0;

    	if (window.Rollbar) {		
			// Set the person data to be sent with all errors for this notifier.
			window.Rollbar.configure({
			  payload: {
			    person: userData
			  }
			});
    	}

		if (userData.is_logged_in !== 0) {
			window.appData.user.name = userData.user_name;
			window.appData.user['sales-group'] = userData.user_sales_group;

			window.loadUserShapesFile(function(shapesData) {
				if (_.isArray(shapesData)) {
					shapesData = {
						'myLibrary': shapesData,
						'deleteFiles': {}
					};
				}

				console.log('shapesData ', shapesData);
				while (window.appData.customUserData.myLibrary.length > 0) {
					window.appData.customUserData.myLibrary.pop();
				}

				Object.assign(window.appData.customUserData.deleteFiles, shapesData.deleteFiles);

				shapesData.myLibrary.forEach(function(shapeData) {
					window.appData.customUserData.myLibrary.push(shapeData);
				});
			});
		} else {
			window.appData.user.isAdmin = false;
		}

		window.appData.user.loginRedirectUrl = userData.loginRedirectUrl + encodeURIComponent(location.pathname.replace('/', '') + location.search);

	});
}


function getQueryParameters(queryString) {
	return queryString.slice(1)
		    .split('&')
		    .map(function (s) {return s.split('=');})
		    .filter(function (a) {return a[1];})
		    .reduce(function(d, e){ 
		        d[e[0]] = e[1].replace('/', '');
		        return d;
		    }, {});
}
	
(function ($, appData, loadCase, loadFromFile, promises, updateCost) {
	'use strict';

	setTimeout(function() {
		console.log('appData.user.loggedIn', appData.user.loggedIn);
		if (!appData.user.loggedIn) {
			showOverLay('.loginForm');
		}
	}, 60000);


	var QUERY_PARAMETERS = getQueryParameters(location.search);

	appData['order-data']['number-of-cases'] = QUERY_PARAMETERS.qty || null;
	appData['order-data'].quanity = QUERY_PARAMETERS.qty || 1;
	appData['order-data']['foam-type'] = QUERY_PARAMETERS.foamSku || null;

	if (QUERY_PARAMETERS['saved-case-name']) {
		appData['current-case'].name = decodeURIComponent(QUERY_PARAMETERS['saved-case-name'].replace(/\+/g, ' '));
	}
	if (QUERY_PARAMETERS['saved-case-description']) {
		appData['current-case'].description = decodeURIComponent(QUERY_PARAMETERS['saved-case-description'].replace(/\+/g, ' '));
	}
	appData['current-case']['is-custom'] = 'width' in QUERY_PARAMETERS;

	// Deside what type of case to load
	if (QUERY_PARAMETERS.loadcase) {
		// Load case from part name.
		appData['current-case']['part-number'] = QUERY_PARAMETERS.loadcase;
	} else if ('width' in QUERY_PARAMETERS) {
		appData['current-case'].width = QUERY_PARAMETERS.width;
		appData['current-case'].depth = QUERY_PARAMETERS.depth;
		appData['current-case'].length = QUERY_PARAMETERS.length;	
		appData['current-case']['part-number'] = 'Custom Size';
	}


	function showWelcomeScreen() {
		$('.welcome_page').show();
	}

	function processCaseData() {
		window.foamType = window.foamTypeInput = QUERY_PARAMETERS.foamSku || window.foamType;
		appData['order-data'].foamtype = QUERY_PARAMETERS.foamSku || appData['order-data'].foamtype || window.foamType;

		//TODO - Acumium - updated next two lines / qty is passed from product page, but foamSku is not, so just checking for qty is not enoughis
		if (!QUERY_PARAMETERS['open-case'] && !QUERY_PARAMETERS.pickcase) {
			// $('.overlay').show();
			// $('.overlay > *').hide();

			// showWelcomeScreen();
		}

		// Decide on the case to load
		if (QUERY_PARAMETERS.productId in groupedCaseLookup) {
			// Load case from part name.
			if (QUERY_PARAMETERS.productId in groupedCaseLookup) {
				loadCase(groupedCaseLookup[QUERY_PARAMETERS.productId][0]['Part #']);
			} else {
				global.alert('Product ID unknown ' + QUERY_PARAMETERS.productId);
			}
		} else if (QUERY_PARAMETERS.loadcase) {
			if (QUERY_PARAMETERS.loadcase in caseLookup) {
				loadCase(QUERY_PARAMETERS.loadcase);
			} else {
				global.alert('loadcase ID unknown ' + QUERY_PARAMETERS.loadcase);
			}
		} else if (QUERY_PARAMETERS.length) {
			// Custom case size
			var form = document.querySelector('.custom_case_size');

			form.customwidth.value = QUERY_PARAMETERS.width;
			form.customheight.value = QUERY_PARAMETERS.depth;
			form.customlength.value = QUERY_PARAMETERS.length;
			
			$(form).submit();
		} else {
			// No case set. Load first case.
			loadCase(Object.keys(window.caseLookup)[0]);
			showWelcomeScreen();
		}

		if (QUERY_PARAMETERS['open-case']) {
			loadFromFile(decodeURIComponent(QUERY_PARAMETERS['open-case']), function () {
				updateCost();
			});
		}
	}

	$(document).ready(function () {
		loadUserData();

		if (window.isMMUnit = QUERY_PARAMETERS.u_of_m === 'mm') {
			document.body.classList.add('mm');
		}
		// Reset baseUnit to px. BaseUnit should not be changed.
		window.svgEditor.curConfig.baseUnit = 'px';

		window.svgEditor.ready(function () {
	 		$.when.apply( null, promises).then(function() {
		        processCaseData();
		    }, function (error) {
		    	global.alert('Case files failed to download. Status text "' + error.statusText + '"');
		    });
		});
	});

})(window.jQuery, window.appData, window.loadCase, window.loadFromFile, window.promises, window.updateCost);

document.addEventListener('DOMContentLoaded', function() {
	'use strict';
    console.log('DOM fully loaded and parsed by browser');
});